
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4PDzO", function(module, exports) {
$parcel$export(module.exports, "UsageBasedPricingPage", function () { return $227f5787b6c960f5$export$c6f5b237bddf4246; });
/* usage-based-pricing-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jqAsR = parcelRequire("jqAsR");

var $c9P0g = parcelRequire("c9P0g");

var $ecTCn = parcelRequire("ecTCn");

var $grcEk = parcelRequire("grcEk");

var $kbpa7 = parcelRequire("kbpa7");

var $hcVGp = parcelRequire("hcVGp");
const $227f5787b6c960f5$export$c6f5b237bddf4246 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
            productKey: "usage-based-pricing"
        }),
        noInlinePadding: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jqAsR.UbpContextProvider), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($227f5787b6c960f5$var$UsageBasedPricingShell, {})
        })
    });
};
/**
 * Inner shell — sits inside PricingPageLayout's <main>. Renders the header,
 * the calculator state-machine driven step view, and the legacy wizard
 * (industry/team-size/growth/feature/solution + capacity sidebar) so behaviour
 * is preserved while the new Q4 calculator is rolled out.
 */ const $227f5787b6c960f5$var$UsageBasedPricingShell = ()=>{
    const loadData = (0, $c9P0g.useLoadProductCatalogData)();
    (0, $1oC0p.useEffect)(()=>{
        loadData();
    }, [
        loadData
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb1osq _1reo15vq _18m915vq _bfhk1afi _2rkogktf _1q51idpf _85i51jfw _xc2iidpf _144txy5q _1l9u7vkz _1u2qidpf _xlt11ejb _a5zt1crf"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1pbykb7n _1e0c1txw _2lx21bp4 _zulp1jfw _1bsb1osq _p12ftfvk _195g1wug _18zrzwfg _owpu1wqb _ex0uidpf"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
                "aria-label": "Usage-based pricing calculator",
                "data-testid": "ubp-calculator-shell",
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulpxy5q _1bsb1osq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ecTCn.UsageBasedPricingCalculator), {})
            })
        })
    });
};
/**
 * Outer container. Provides a flat white background for the calculator
 * viewport.
 */ const $227f5787b6c960f5$var$shellBackgroundStyles = null;
const $227f5787b6c960f5$var$shellInnerStyles = null;
/**
 * Step layout wrapper — every calculator step renders inside this so the
 * spacing rhythm, max-width, and inline padding are consistent across the
 * usage / needs / estimate / allowance / summary steps.
 */ const $227f5787b6c960f5$var$stepLayoutStyles = null;

});
parcelRegister("jqAsR", function(module, exports) {
$parcel$export(module.exports, "UbpStep", function () { return $906b47b2676ba510$export$23963b701e0b1ed; });
$parcel$export(module.exports, "useUbpContext", function () { return $906b47b2676ba510$export$dc0276ea3fe966fa; });
$parcel$export(module.exports, "UbpContextProvider", function () { return $906b47b2676ba510$export$17c668f0eddf3669; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
var $906b47b2676ba510$export$23963b701e0b1ed = /*#__PURE__*/ function(UbpStep) {
    UbpStep[UbpStep["collections"] = 0] = "collections";
    UbpStep[UbpStep["orgChangePercent"] = 1] = "orgChangePercent";
    UbpStep[UbpStep["usageEstimate"] = 2] = "usageEstimate";
    UbpStep[UbpStep["plans"] = 3] = "plans";
    return UbpStep;
}({});
const $906b47b2676ba510$var$UbpContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $906b47b2676ba510$export$dc0276ea3fe966fa = ()=>{
    const ctx = (0, $1oC0p.useContext)($906b47b2676ba510$var$UbpContext);
    if (!ctx) throw new Error('missing context provider for UbpContext');
    return ctx;
};
const $906b47b2676ba510$var$defaultCollections = {
    teamwork: {
        selected: false,
        plan: 'premium'
    },
    strategy: {
        selected: false,
        plan: 'premium'
    },
    service: {
        selected: false,
        plan: 'premium'
    },
    software: {
        selected: false,
        plan: 'premium'
    }
};
const $906b47b2676ba510$var$DEFAULT_ORG_CHANGE_PERCENT = 1;
const $906b47b2676ba510$var$DEFAULT_ORG_USER_COUNT = 0;
const $906b47b2676ba510$var$DEFAULT_CHAT_ADOPTION_PERCENT = 0;
const $906b47b2676ba510$var$DEFAULT_CHAT_USERS_PER_RULE_PER_MONTH = 0;
const $906b47b2676ba510$var$DEFAULT_AUTOMATION_ACTIVE_RULES = 0;
const $906b47b2676ba510$var$DEFAULT_AUTOMATION_RUNS_PER_RULE_PER_MONTH = 0;
const $906b47b2676ba510$var$DEFAULT_STEP = 0;
const $906b47b2676ba510$export$17c668f0eddf3669 = (props)=>{
    const [collections, setCollections] = (0, $1oC0p.useState)($906b47b2676ba510$var$defaultCollections);
    const [orgChangePercent, setOrgChangePercent] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_ORG_CHANGE_PERCENT);
    const [orgUserCount, setOrgUserCount] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_ORG_USER_COUNT);
    const [chatAdoptionPercent, setChatAdoptionPercent] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_CHAT_ADOPTION_PERCENT);
    const [chatUsersPerRulePerMonth, setChatUsersPerRulePerMonth] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_CHAT_USERS_PER_RULE_PER_MONTH);
    const [automationActiveRules, setAutomationActiveRules] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_AUTOMATION_ACTIVE_RULES);
    const [automationRunsPerRulePerMonth, setAutomationRunsPerRulePerMonth] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_AUTOMATION_RUNS_PER_RULE_PER_MONTH);
    const [step, setStep] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_STEP);
    const [productCatalog, setProductCatalog] = (0, $1oC0p.useState)({
        loading: false,
        data: null,
        error: null
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)($906b47b2676ba510$var$UbpContext.Provider, {
        value: {
            inputs: {
                values: {
                    collections: collections,
                    orgChangePercent: orgChangePercent,
                    orgUserCount: orgUserCount,
                    chatAdoptionPercent: chatAdoptionPercent,
                    chatUsersPerRulePerMonth: chatUsersPerRulePerMonth,
                    automationActiveRules: automationActiveRules,
                    automationRunsPerRulePerMonth: automationRunsPerRulePerMonth
                },
                setters: {
                    setCollections: setCollections,
                    setOrgChangePercent: setOrgChangePercent,
                    setOrgUserCount: setOrgUserCount,
                    setChatAdoptionPercent: setChatAdoptionPercent,
                    setChatUsersPerRulePerMonth: setChatUsersPerRulePerMonth,
                    setAutomationActiveRules: setAutomationActiveRules,
                    setAutomationRunsPerRulePerMonth: setAutomationRunsPerRulePerMonth
                }
            },
            step: step,
            setStep: setStep,
            productCatalog: productCatalog,
            setProductCatalog: setProductCatalog
        },
        children: props.children
    });
};

});

parcelRegister("c9P0g", function(module, exports) {
$parcel$export(module.exports, "useLoadProductCatalogData", function () { return $10c0b7f18a2b08eb$export$a66d0c686a571ba1; });

var $1oC0p = parcelRequire("1oC0p");

var $8KOLZ = parcelRequire("8KOLZ");

var $b6hbg = parcelRequire("b6hbg");

var $jqAsR = parcelRequire("jqAsR");

var $2LoaG = parcelRequire("2LoaG");

var $9dz7i = parcelRequire("9dz7i");
const $10c0b7f18a2b08eb$export$d4684c44411706d4 = ()=>(0, $jqAsR.useUbpContext)().inputs.values;
const $10c0b7f18a2b08eb$export$dc86fcdb557baa79 = ()=>(0, $jqAsR.useUbpContext)().inputs.setters;
const $10c0b7f18a2b08eb$export$7896576cb7635832 = ()=>(0, $jqAsR.useUbpContext)().step;
const $10c0b7f18a2b08eb$export$5fbef6a33fc3ef44 = ()=>(0, $jqAsR.useUbpContext)().setStep;
const $10c0b7f18a2b08eb$export$ed483cbd896dc262 = ()=>{
    const { collections: collections } = $10c0b7f18a2b08eb$export$d4684c44411706d4();
    return Object.values(collections).some((c)=>c.selected);
};
const $10c0b7f18a2b08eb$export$59873a11f4f97de3 = ()=>{
    const { setCollections: setCollections } = $10c0b7f18a2b08eb$export$dc86fcdb557baa79();
    return (0, $1oC0p.useCallback)((key, selected)=>{
        setCollections((prev)=>({
                ...prev,
                [key]: {
                    ...prev[key],
                    selected: selected
                }
            }));
    }, [
        setCollections
    ]);
};
const $10c0b7f18a2b08eb$export$cd9e4631f4963434 = ()=>{
    const { setCollections: setCollections } = $10c0b7f18a2b08eb$export$dc86fcdb557baa79();
    return (0, $1oC0p.useCallback)((key, plan)=>{
        setCollections((prev)=>({
                ...prev,
                [key]: {
                    ...prev[key],
                    plan: plan
                }
            }));
    }, [
        setCollections
    ]);
};
const $10c0b7f18a2b08eb$export$9eee33855d10180c = ()=>{
    const inputs = $10c0b7f18a2b08eb$export$d4684c44411706d4();
    return (0, $1oC0p.useMemo)(()=>(0, $2LoaG.calculateUsage)(inputs), [
        inputs
    ]);
};
const $10c0b7f18a2b08eb$export$39880f96d7051909 = ()=>{
    const usage = $10c0b7f18a2b08eb$export$9eee33855d10180c();
    const allowances = $10c0b7f18a2b08eb$export$f4470fb8fc59b1a1();
    const step = $10c0b7f18a2b08eb$export$7896576cb7635832();
    if (step === (0, $jqAsR.UbpStep).collections) return false;
    return usage.aiCredits > allowances.aiCredits;
};
const $10c0b7f18a2b08eb$export$f4470fb8fc59b1a1 = ()=>{
    const inputs = $10c0b7f18a2b08eb$export$d4684c44411706d4();
    const allowanceConfigs = $10c0b7f18a2b08eb$export$a1b9af7912387f4f();
    return (0, $1oC0p.useMemo)(()=>{
        if (!allowanceConfigs) return {
            aiCredits: 0,
            indexedObjects: 0
        };
        const allowances = (0, $2LoaG.calculateAllowances)({
            allowanceConfigs: allowanceConfigs,
            inputs: {
                ...inputs,
                offeringSkus: $10c0b7f18a2b08eb$var$collectionsToSkus(inputs.collections)
            }
        });
        return {
            ...allowances
        };
    }, [
        inputs
    ]);
};
const $10c0b7f18a2b08eb$var$COLLECTION_SKU_MAP = {
    teamwork: {
        free: (0, $9dz7i.skus).teamworkCollectionFree,
        standard: (0, $9dz7i.skus).teamworkCollectionStandard,
        premium: (0, $9dz7i.skus).teamworkCollectionPremium,
        enterprise: (0, $9dz7i.skus).teamworkCollectionEnterprise
    },
    service: {
        free: (0, $9dz7i.skus).serviceCollectionFree,
        standard: (0, $9dz7i.skus).serviceCollectionStandard,
        premium: (0, $9dz7i.skus).serviceCollectionPremium,
        enterprise: (0, $9dz7i.skus).serviceCollectionEnterprise
    },
    strategy: {
        free: (0, $9dz7i.skus).teamworkCollectionFree,
        standard: (0, $9dz7i.skus).teamworkCollectionStandard,
        premium: (0, $9dz7i.skus).teamworkCollectionPremium,
        enterprise: (0, $9dz7i.skus).teamworkCollectionEnterprise
    },
    software: {
        free: (0, $9dz7i.skus).teamworkCollectionFree,
        standard: (0, $9dz7i.skus).teamworkCollectionStandard,
        premium: (0, $9dz7i.skus).teamworkCollectionPremium,
        enterprise: (0, $9dz7i.skus).teamworkCollectionEnterprise
    }
};
const $10c0b7f18a2b08eb$var$collectionsToSkus = (collections)=>{
    return Object.keys(collections).filter((key)=>collections[key].selected).map((key)=>$10c0b7f18a2b08eb$var$COLLECTION_SKU_MAP[key][collections[key].plan]);
};
const $10c0b7f18a2b08eb$export$a66d0c686a571ba1 = ()=>{
    const { setProductCatalog: setProductCatalog } = (0, $jqAsR.useUbpContext)();
    const fireAnalyticsEvent = (0, $8KOLZ.useFireAnalyticsEvents)();
    // `useFireAnalyticsEvents` returns a fresh object literal every render, so
    // including it directly in the useCallback dependency array would cause the
    // returned function to change identity every render — which breaks any
    // consumer that puts this function in a useEffect dependency array
    // (infinite render loop: effect fires → setState → re-render → new fn ref
    // → effect fires again). Stash the latest value in a ref so the callback
    // can read the current `fireAnalyticsEvent` without depending on it.
    const fireAnalyticsEventRef = (0, $1oC0p.useRef)(fireAnalyticsEvent);
    fireAnalyticsEventRef.current = fireAnalyticsEvent;
    // Only depend on the truly stable `setProductCatalog` (from useState). This
    // gives the returned function a stable identity across renders, safe to
    // pass into a useEffect dependency array.
    return (0, $1oC0p.useCallback)(async function loadProductCatalogData() {
        setProductCatalog({
            loading: true,
            data: null,
            error: null
        });
        try {
            const data = await (0, $b6hbg.fetchProductCatalogData)(Object.values((0, $9dz7i.skus)));
            setProductCatalog({
                loading: false,
                data: data,
                error: null
            });
        } catch (error) {
            setProductCatalog({
                loading: false,
                data: (0, $9dz7i.offeringAllowances),
                error: null
            });
            const errorData = error;
            fireAnalyticsEventRef.current.fireOperationalEvent({
                action: 'failed',
                actionSubject: 'ubpProductCatalogDataFetch',
                attributes: {
                    errorMessage: errorData?.message
                }
            });
        }
    }, [
        setProductCatalog
    ]);
};
const $10c0b7f18a2b08eb$export$a52f278dd718031f = ()=>{
    const { productCatalog: productCatalog } = (0, $jqAsR.useUbpContext)();
    return !productCatalog.loading && !!productCatalog.data;
};
const $10c0b7f18a2b08eb$export$a1b9af7912387f4f = ()=>{
    return (0, $jqAsR.useUbpContext)().productCatalog.data;
};

});
parcelRegister("b6hbg", function(module, exports) {
$parcel$export(module.exports, "fetchProductCatalogData", function () { return $2efafce82afd6fa3$export$8d271a5aff84d3c5; });

var $61WdP = parcelRequire("61WdP");

var $aZFKp = parcelRequire("aZFKp");

var $cYm2M = parcelRequire("cYm2M");
const $2efafce82afd6fa3$export$8d271a5aff84d3c5 = async (offeringSKUs)=>{
    const client = (0, $61WdP.getContentfulProductCatalogClient)();
    const offerings = await client.getCCPPricingData(offeringSKUs);
    const data = (0, $aZFKp.transform)(offerings);
    (0, $cYm2M.validate)(data);
    return data;
};

});
parcelRegister("aZFKp", function(module, exports) {
$parcel$export(module.exports, "transform", function () { return $47dee04aa7a99b03$export$51186ad6e864892a; });
const $47dee04aa7a99b03$var$USAGE_KEY_MAP = {
    'ai-credit': 'aiCredit',
    'indexed-document': 'indexedDocument'
};
const $47dee04aa7a99b03$var$CYCLE_MAP = {
    MONTHLY: 'monthly',
    ANNUAL: 'annual'
};
const $47dee04aa7a99b03$export$51186ad6e864892a = (offerings)=>{
    const result = {};
    for (const [sku, offering] of Object.entries(offerings)){
        const allowance = {
            aiCredit: {
                monthly: 0,
                annual: 0
            },
            indexedDocument: {
                monthly: 0,
                annual: 0
            }
        };
        const features = offering?.entitlementTemplate_data?.features ?? [];
        for (const feature of features)$47dee04aa7a99b03$var$applyFeatureAllowances(allowance, feature.value?.allowances ?? []);
        result[sku] = allowance;
    }
    return result;
};
const $47dee04aa7a99b03$var$applyCycles = (target, cycles)=>{
    for (const cycle of cycles){
        const period = $47dee04aa7a99b03$var$CYCLE_MAP[cycle.cycle];
        if (period) target[period] += cycle.amount;
    }
};
const $47dee04aa7a99b03$var$applyFeatureAllowances = (allowance, featureAllowances)=>{
    for (const featureAllowance of featureAllowances){
        const usageKey = featureAllowance.config?.usageKey;
        const mappedKey = usageKey ? $47dee04aa7a99b03$var$USAGE_KEY_MAP[usageKey] : undefined;
        if (!mappedKey) continue;
        $47dee04aa7a99b03$var$applyCycles(allowance[mappedKey], featureAllowance.config?.cycles ?? []);
    }
};

});

parcelRegister("cYm2M", function(module, exports) {
$parcel$export(module.exports, "validate", function () { return $80a88424659fce82$export$a22775fa5e2eebd9; });

var $9dz7i = parcelRequire("9dz7i");
const $80a88424659fce82$var$allSkus = Object.values((0, $9dz7i.skus));
function $80a88424659fce82$export$a22775fa5e2eebd9(data) {
    if (typeof data !== 'object' || data === null || Array.isArray(data)) throw new Error(`Invalid product catalog data: expected a non-null object, got ${data === null ? 'null' : Array.isArray(data) ? 'array' : typeof data}`);
    const record = data;
    const missingSku = $80a88424659fce82$var$allSkus.find((sku)=>!(sku in record));
    if (missingSku !== undefined) throw new Error(`Invalid product catalog data: missing entry for SKU "${missingSku}"`);
    for (const sku of $80a88424659fce82$var$allSkus){
        if (!$80a88424659fce82$var$isOfferingAllowance(record[sku])) throw new Error(`Invalid product catalog data: entry for SKU "${sku}" does not match OfferingAllowance shape`);
    }
}
function $80a88424659fce82$var$isOfferingAllowance(value) {
    if (typeof value !== 'object' || value === null) return false;
    const v = value;
    for (const field of [
        'aiCredit',
        'indexedDocument'
    ]){
        const entry = v[field];
        if (typeof entry !== 'object' || entry === null) return false;
        const e = entry;
        if (typeof e['monthly'] !== 'number' || typeof e['annual'] !== 'number') return false;
    }
    return true;
}

});
parcelRegister("9dz7i", function(module, exports) {
$parcel$export(module.exports, "skus", function () { return $e10d629d1810f0d9$export$51ba92eeb7158b57; });
$parcel$export(module.exports, "AI_CREDITS_PER_USER_INTERACTION", function () { return $e10d629d1810f0d9$export$de7390b8b3586c9a; });
$parcel$export(module.exports, "AI_CREDITS_PER_AUTOMATION", function () { return $e10d629d1810f0d9$export$6a6dda0c3d52963c; });
$parcel$export(module.exports, "offeringAllowances", function () { return $e10d629d1810f0d9$export$27e361dea74e34b2; });
const $e10d629d1810f0d9$export$51ba92eeb7158b57 = {
    teamworkCollectionFree: 'teamwork-collection-free-sku',
    teamworkCollectionStandard: 'teamwork-collection-standard-sku',
    teamworkCollectionPremium: 'teamwork-collection-premium-sku',
    teamworkCollectionEnterprise: 'teamwork-collection-enterprise-sku',
    serviceCollectionFree: 'service-collection-free',
    serviceCollectionStandard: 'service-collection-standard',
    serviceCollectionPremium: 'service-collection-premium',
    serviceCollectionEnterprise: 'service-collection-enterprise'
};
const $e10d629d1810f0d9$export$de7390b8b3586c9a = 20;
const $e10d629d1810f0d9$export$6a6dda0c3d52963c = 20;
const $e10d629d1810f0d9$export$27e361dea74e34b2 = {
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.teamworkCollectionFree]: {
        aiCredit: {
            monthly: 0,
            annual: 0
        },
        indexedDocument: {
            monthly: 0,
            annual: 0
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.teamworkCollectionStandard]: {
        aiCredit: {
            monthly: 250,
            annual: 250
        },
        indexedDocument: {
            monthly: 1000,
            annual: 1000
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.teamworkCollectionPremium]: {
        aiCredit: {
            monthly: 700,
            annual: 700
        },
        indexedDocument: {
            monthly: 2500,
            annual: 2500
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.teamworkCollectionEnterprise]: {
        aiCredit: {
            monthly: 1500,
            annual: 1500
        },
        indexedDocument: {
            monthly: 6250,
            annual: 6250
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.serviceCollectionFree]: {
        aiCredit: {
            monthly: 0,
            annual: 0
        },
        indexedDocument: {
            monthly: 0,
            annual: 0
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.serviceCollectionStandard]: {
        aiCredit: {
            monthly: 25,
            annual: 25
        },
        indexedDocument: {
            monthly: 100,
            annual: 100
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.serviceCollectionPremium]: {
        aiCredit: {
            monthly: 70,
            annual: 70
        },
        indexedDocument: {
            monthly: 250,
            annual: 250
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.serviceCollectionEnterprise]: {
        aiCredit: {
            monthly: 150,
            annual: 150
        },
        indexedDocument: {
            monthly: 625,
            annual: 625
        }
    }
};

});



parcelRegister("2LoaG", function(module, exports) {
$parcel$export(module.exports, "calculateAllowances", function () { return $432c0661cb02a854$export$1ddd1a64f8973b2b; });
$parcel$export(module.exports, "calculateUsage", function () { return $432c0661cb02a854$export$48a9b49eebf17443; });

var $9dz7i = parcelRequire("9dz7i");
function $432c0661cb02a854$export$1ddd1a64f8973b2b(args) {
    const { allowanceConfigs: allowanceConfigs, inputs: inputs } = args;
    const { offeringSkus: offeringSkus, orgChangePercent: orgChangePercent, orgUserCount: orgUserCount } = inputs;
    let aiCreditsSum = 0;
    let indexedObjectsSum = 0;
    for (const sku of offeringSkus){
        const config = allowanceConfigs[sku];
        if (!config) continue;
        aiCreditsSum += config.aiCredit.monthly * orgUserCount;
        indexedObjectsSum += config.indexedDocument.monthly * orgUserCount;
    }
    return {
        aiCredits: Math.round(aiCreditsSum * orgChangePercent)
    };
}
function $432c0661cb02a854$export$48a9b49eebf17443(args) {
    const { orgUserCount: orgUserCount, orgChangePercent: orgChangePercent, chatAdoptionPercent: chatAdoptionPercent, chatUsersPerRulePerMonth: chatUsersPerRulePerMonth, automationActiveRules: automationActiveRules, automationRunsPerRulePerMonth: automationRunsPerRulePerMonth } = args;
    const userInteractionCredits = orgUserCount * orgChangePercent * chatAdoptionPercent * chatUsersPerRulePerMonth * (0, $9dz7i.AI_CREDITS_PER_USER_INTERACTION);
    const automationCredits = automationActiveRules * automationRunsPerRulePerMonth * (0, $9dz7i.AI_CREDITS_PER_AUTOMATION);
    return {
        aiCredits: Math.round(userInteractionCredits + automationCredits)
    };
}

});


parcelRegister("ecTCn", function(module, exports) {
$parcel$export(module.exports, "UsageBasedPricingCalculator", function () { return $a9a1671730ec00f4$export$81c720f4667b8b84; });
/**
 * Root component: mounts the merged provider, fetches CCP pricing data up
 * front, and gates the wizard behind that fetch ("fetch first, then show the
 * experience").
 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jsxHL = parcelRequire("jsxHL");

var $aTTpq = parcelRequire("aTTpq");

var $9wpUt = parcelRequire("9wpUt");

var $dEuk8 = parcelRequire("dEuk8");

var $jESEJ = parcelRequire("jESEJ");

var $hz9o6 = parcelRequire("hz9o6");

var $9lJTH = parcelRequire("9lJTH");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $bIpm5 = parcelRequire("bIpm5");
const $a9a1671730ec00f4$export$81c720f4667b8b84 = (props)=>{
    const initialValues = typeof window !== 'undefined' ? (0, $bIpm5.initialValuesFromQuery)(window.location.search) : undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9lJTH.UbpContextProvider), {
        initialValues: initialValues,
        ...props,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($a9a1671730ec00f4$var$UsageBasedPricingCalculatorInner, {})
    });
};
const $a9a1671730ec00f4$var$UsageBasedPricingCalculatorInner = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: $a9a1671730ec00f4$var$style,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($a9a1671730ec00f4$var$CurrentStep, {})
        })
    });
};
const $a9a1671730ec00f4$var$CurrentStep = ()=>{
    const step = (0, $4xsw0.useSelector)((0, $hSUNh.selectStep));
    (0, $1oC0p.useEffect)(()=>{
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto'
        });
    }, [
        step
    ]);
    switch(step){
        case 'usage':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hz9o6.UsageStep), {});
        case 'needs':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dEuk8.NeedsStep), {});
        case 'estimate':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9wpUt.EstimateStep), {});
        case 'allowance':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aTTpq.AllowanceStep), {});
        case 'summary':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jESEJ.SummaryStep), {});
    }
};
const $a9a1671730ec00f4$var$style = {
    display: 'flex',
    flexDirection: 'column',
    // Gap removed — each step owns its own vertical rhythm via paddings on
    // headings and section wrappers, so the design matches Figma exactly
    // without a wrapper-level gap fighting explicit values.
    gap: 0,
    // All padding + auto-margins removed for this page. Horizontal centering
    // is done by the parent flex container (stepLayoutStyles uses
    // alignItems: center), so this element stays full-width up to maxWidth
    // without introducing left/right auto margins.
    padding: 0,
    margin: 0,
    width: '100%',
    maxWidth: 1100
};

});
parcelRegister("aTTpq", function(module, exports) {
$parcel$export(module.exports, "AllowanceStep", function () { return $54ee61fb64dd615e$export$a67e8c2aef6e5372; });
/* allowance-step.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $60ByZ = parcelRequire("60ByZ");

var $lDmb2 = parcelRequire("lDmb2");

var $1dc5i = parcelRequire("1dc5i");

var $l4DCt = parcelRequire("l4DCt");

var $73KXs = parcelRequire("73KXs");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $3h32c = parcelRequire("3h32c");

var $gbxL3 = parcelRequire("gbxL3");

var $ahF4L = parcelRequire("ahF4L");

var $cNQe2 = parcelRequire("cNQe2");

var $ehiBJ = parcelRequire("ehiBJ");

var $cIZNT = parcelRequire("cIZNT");
const $54ee61fb64dd615e$export$a67e8c2aef6e5372 = ()=>{
    // Manual tab-state management (instead of using the higher-level
    // `TabsSection`) so we can insert the design-required "Selections apply
    // to one tab at a time…" advisory copy between the tab-button row and
    // the tab-panel content. `TabsSection` doesn't expose a slot for
    // between-tabs-and-panel content, so we compose the primitives
    // (`TabList`, `Tab`, `TabPanel`) directly. Default active tab is
    // `collections`, satisfying the GWP-12102 requirement that clicking
    // Next on Estimate always lands on the Collections tab.
    const [activeTabId, setActiveTabId] = (0, $1oC0p.useState)('collections');
    const [hasAttemptedNext, setHasAttemptedNext] = (0, $1oC0p.useState)(false);
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const canAdvance = (0, $4xsw0.useSelector)((0, $hSUNh.selectCanAdvanceAllowanceStep));
    const intl = (0, $8e22h.default)();
    const fireStep4Viewed = (0, $3h32c.useUbpStep4ScreenViewedEvent)();
    const fireStep4Tab = (0, $3h32c.useUbpStep4TabClickedEvent)();
    const fireStep4Compare = (0, $3h32c.useUbpStep4CompareClickedEvent)();
    const fireStep4Back = (0, $3h32c.useUbpStep4BackClickedEvent)();
    (0, $1oC0p.useEffect)(()=>{
        fireStep4Viewed();
    // Intentionally run once on mount only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const APP_STRINGS = (0, $cNQe2.useAppDescriptions)();
    const COLLECTION_STRINGS = (0, $cNQe2.useCollectionDescriptions)();
    // Filter the full app list down to only the apps allowed for the current
    // meter. METER_ALLOWED_APPS[meter] is null for csResolutions, but the
    // allowance step is never rendered for that meter (it is skipped in
    // navigation), so we fall back to all keys defensively.
    const allowedApps = (0, $73KXs.METER_ALLOWED_APPS)[meter];
    const appKeys = (0, $1oC0p.useMemo)(()=>Object.keys(APP_STRINGS).filter((key)=>allowedApps === null || allowedApps.includes(key)), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        APP_STRINGS,
        meter
    ]);
    const collectionKeys = (0, $1oC0p.useMemo)(()=>Object.keys(COLLECTION_STRINGS), [
        COLLECTION_STRINGS
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cIZNT.Stepper), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q51ys9h _85i51ylp _ect41vau _1wyb1ylp _vwz4ckbl _k48p1fw0 _y3gn1h6o _syazrf0c"
                ]),
                style: {
                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
                },
                children: intl.formatMessage((0, $gbxL3.messages).pageTitle)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _p12f1osq _nssp1y6m _1h7widpf _1v0xidpf _tjfw1ule _1tgpdkka"
                ]),
                style: {
                    "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lDmb2.TabList), {
                    activeTabId: activeTabId,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $60ByZ.Tab), {
                            tabId: "collections",
                            index: 0,
                            title: intl.formatMessage((0, $gbxL3.messages).tabCollections),
                            isActive: activeTabId === 'collections',
                            onTabSelect: (id)=>{
                                setActiveTabId(id);
                                fireStep4Tab('collections');
                            },
                            tabSize: "small"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $60ByZ.Tab), {
                            tabId: "apps",
                            index: 1,
                            title: intl.formatMessage((0, $gbxL3.messages).tabApps),
                            isActive: activeTabId === 'apps',
                            onTabSelect: (id)=>{
                                setActiveTabId(id);
                                fireStep4Tab('apps');
                            },
                            tabSize: "small"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1rjc1ylp _ect4z4z1 _1wybdlk8 _vwz4gktf _y3gn1e5h _10hl1h6o"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_syaz1pfd"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: intl.formatMessage({
                        id: 'ubp.calculator.allowance.tabsadvisory',
                        defaultMessage: 'Switching tabs and selecting new items will clear previous choices.'
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1dc5i.TabPanel), {
                        id: "collections",
                        isActive: activeTabId === 'collections',
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c11p5 _zulpxy5q _81641ejb",
                                "_yv0ewxkt _19d7hkll"
                            ]),
                            children: collectionKeys.map((choice)=>{
                                const { lockupUrl: lockupUrl, description: description, list: list } = COLLECTION_STRINGS[choice];
                                return /*#__PURE__*/ (0, $7VQPk.jsx)($54ee61fb64dd615e$var$CollectionCard, {
                                    productKey: choice,
                                    lockupUrl: lockupUrl,
                                    description: description,
                                    list: list
                                }, `collections-${choice}`);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1dc5i.TabPanel), {
                        id: "apps",
                        isActive: activeTabId === 'apps',
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c11p5 _zulpxy5q _81641ejb",
                                "_yv0e1ckl _1da7wxkt _19d7hkll"
                            ]),
                            children: appKeys.map((choice)=>{
                                const { label: label, iconUrl: iconUrl, description: description } = APP_STRINGS[choice];
                                return /*#__PURE__*/ (0, $7VQPk.jsx)($54ee61fb64dd615e$var$AppCard, {
                                    productKey: choice,
                                    label: label,
                                    iconUrl: iconUrl,
                                    description: description
                                }, `apps-${choice}`);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_syaz1d19 _1e0c1txw _1bah1h6o _4cvr1h6o _y3gn1h6o _1tke1wto"
                ]),
                style: {
                    "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                },
                children: hasAttemptedNext && !canAdvance && intl.formatMessage({
                    id: 'ubp.calculator.allowance.error',
                    defaultMessage: 'Select at least one collection or app to continue.'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ehiBJ.StepNav), {
                showBack: true,
                showNext: true,
                nextLabel: intl.formatMessage((0, $l4DCt.METER_CONTENT)[meter].allowanceStep.nextCta),
                onBeforeNext: ()=>{
                    setHasAttemptedNext(true);
                    if (!canAdvance) return false;
                    fireStep4Compare();
                },
                onBeforeBack: fireStep4Back
            })
        ]
    });
};
const $54ee61fb64dd615e$var$AppCard = ({ productKey: productKey, label: label, iconUrl: iconUrl, description: description, hide: hide = false })=>{
    const isSelected = (0, $4xsw0.useSelector)((0, $hSUNh.selectIsProductSelected)(productKey));
    const toggle = (0, $4xsw0.useToggleProduct)();
    const fireSelect = (0, $3h32c.useUbpStep4SelectButtonClickedEvent)();
    const fireDeselect = (0, $3h32c.useUbpStep4DeselectButtonClickedEvent)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ahF4L.ChoiceCard), {
        inputType: "checkbox",
        value: productKey,
        selected: isSelected,
        onSelect: ()=>{
            toggle(productKey, !isSelected);
            if (isSelected) fireDeselect(productKey);
            else fireSelect(productKey);
        },
        groupName: "group-apps",
        label: label,
        iconUrl: iconUrl,
        description: description,
        hide: hide
    });
};
const $54ee61fb64dd615e$var$CollectionCard = ({ productKey: productKey, lockupUrl: lockupUrl, description: description, list: list })=>{
    const isSelected = (0, $4xsw0.useSelector)((0, $hSUNh.selectIsProductSelected)(productKey));
    const toggle = (0, $4xsw0.useToggleProduct)();
    const fireSelect = (0, $3h32c.useUbpStep4SelectButtonClickedEvent)();
    const fireDeselect = (0, $3h32c.useUbpStep4DeselectButtonClickedEvent)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ahF4L.ChoiceCard), {
        inputType: "checkbox",
        value: productKey,
        selected: isSelected,
        onSelect: ()=>{
            toggle(productKey, !isSelected);
            if (isSelected) fireDeselect(productKey);
            else fireSelect(productKey);
        },
        groupName: "group-collections",
        lockupUrl: lockupUrl,
        description: description,
        list: list
    });
};
// H2 title per Figma node 1103:32370 (Desktop / D-H2 style):
// Charlie Display Bold 40/48, primary-black, center-aligned. 80px top
// padding (40 base + 40 extra requested for this step) gives extra
// breathing room between the Stepper and the title; 40px below keeps
// the bottom rhythm consistent with the other steps.
const $54ee61fb64dd615e$var$stepTitleStyle = null;
// Wrapper for the raw <TabList>. The TabList's outermost element is
// `width: fit-content`, so to center it we flex-center this wrapper.
// This is safe for the sliding highlight pill: the pill measures the
// active tab's offset relative to the (fit-content) <ul>, and flex
// centering only repositions that fit-content block — it doesn't change
// the <ul>'s internal width, so `useScrollableTabList`'s measurement
// stays correct. On mobile we switch to flex-start to left-align.
const $54ee61fb64dd615e$var$tabListWrapperStyle = null;
// Grid wrapper for the tab panels. `TabPanel` positions itself at
// `gridArea: 1 / 1`, so all panels stack in a single grid cell and only
// the active one is visible (via opacity). Without this grid parent,
// panels flow one below the other and the "inactive" panel still takes
// vertical space, pushing the visible panel down.
const $54ee61fb64dd615e$var$tabPanelStackStyle = null;
// Body-small advisory copy that sits BETWEEN the tab-button row and the
// tab-panel content. 40px above/below per design.
//
// Mobile (< 768px): left-aligned so it flows with the left-aligned tab
// row above; tablet/desktop keeps the centered treatment matching the
// centered tabs.
const $54ee61fb64dd615e$var$tabsAdvisoryStyle = null;
const $54ee61fb64dd615e$var$tabsAdvisorySpan = null;
const $54ee61fb64dd615e$var$collectionsGrid = null;
const $54ee61fb64dd615e$var$appsGrid = null;
const $54ee61fb64dd615e$var$allProductsGridStyle = null;
const $54ee61fb64dd615e$var$errorProceed = null;

});
parcelRegister("l4DCt", function(module, exports) {
$parcel$export(module.exports, "METER_CONTENT", function () { return $4fd1021f3e82877d$export$87671506eedc1bee; });
/**
 * Central registry mapping each `Meter` to its content bundle.
 *
 * Step components import from this module (never from individual meter
 * files) so that adding a new meter is a one-line change here.
 *
 * Atomic file architecture:
 *   - Individual meter content lives in `<meter>-content.ts` sibling
 *     files. Each is edited independently by its content author, avoiding
 *     merge conflicts.
 *   - This registry is the only file that touches all four meters, so
 *     the surface area for cross-meter conflicts is one line per meter.
 */ 
var $8nPKO = parcelRequire("8nPKO");

var $iV1lX = parcelRequire("iV1lX");

var $5XjcR = parcelRequire("5XjcR");

var $9LuUL = parcelRequire("9LuUL");
const $4fd1021f3e82877d$export$87671506eedc1bee = {
    rovoCredits: (0, $9LuUL.ROVO_CREDITS_CONTENT),
    automations: (0, $iV1lX.AUTOMATIONS_CONTENT),
    csResolutions: (0, $5XjcR.CS_RESOLUTIONS_CONTENT),
    assetsObjects: (0, $8nPKO.ASSETS_OBJECTS_CONTENT)
};

});
parcelRegister("8nPKO", function(module, exports) {
$parcel$export(module.exports, "ASSETS_OBJECTS_CONTENT", function () { return $5bfc29ef25239d99$export$41d69c02881c9866; });
/**
 * Assets Objects — content bundle for the WAC UBP calculator.
 *
 * Source of truth: Confluence "Assets objects: Content spec for WAC Calculator"
 * https://hello.atlassian.net/wiki/spaces/acbp/pages/7129383223
 *
 * Content DRI: Belle Craig · Meter CD: Sarah Campbell
 *
 * NOTE ON PROFILE KEYS: The `UsageType` enum has stable keys
 * `exploring | adopting | scaling` for URL/state/analytics compatibility.
 * The Assets spec's visible labels are `Emerging | Adopting | Scaling`,
 * which are the customer-facing strings shown on the profile cards.
 * The keys are internal identifiers only — do NOT rename them.
 *
 * Fields we haven't finalized are simply OMITTED from this file (most
 * are optional at the type level) so nothing renders for them. Do NOT
 * stub placeholder strings — omit the field entirely instead. There is
 * no `PLACEHOLDER` / `todoCopy` helper exported from this module by
 * design.
 *
 * DO NOT edit unrelated meter files when updating this one — the atomic
 * per-meter file split exists to prevent merge conflicts between authors.
 *
 * i18n: every copy field is wrapped in `defineMessage` with a literal
 * `id` and `defaultMessage`. The extractor is a static AST analyzer —
 * see the i18n contract in `meter-content.types.ts`. Keep both fields
 * literal; never build an id from a variable.
 */ 
var $fnHPc = parcelRequire("fnHPc");

var $kbpa7 = parcelRequire("kbpa7");
const $5bfc29ef25239d99$export$41d69c02881c9866 = {
    description: (0, $fnHPc.defineMessage)({
        id: 'ubp.calculator.usage.assetsObjects.description',
        defaultMessage: 'Use Assets to store and manage your objects and connect them to your work across Atlassian.'
    }),
    needsStep: {
        // Step 2 "Do you know your usage?" question — Assets objects copy.
        doYouKnowQuestion: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.needs.assetsObjects.doYouKnowQuestion',
            defaultMessage: "Know how many objects you\u2019ll need?"
        }),
        // Assets spec: Step 2 primary CTA is "Next" (not the default
        // "Get estimate" used by other meters).
        nextCta: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.needs.assetsObjects.nextCta',
            defaultMessage: 'Next'
        })
    },
    estimateStep: {
        subtitle: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.estimate.assetsObjects.subtitle',
            defaultMessage: "Based on what you\u2019ve told us, here\u2019s a summary of how many Assets Objects you need, and how you can use them."
        }),
        compareCta: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.estimate.assetsObjects.compareCta',
            defaultMessage: 'Explore plans'
        }),
        // TEMPORARY: All meters currently share this Orange Logic asset
        // while the content team finalizes per-meter hero imagery.
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/bb1q20l5xjp2i85j55ou317euquo3rv3.png',
            alt: '',
            imageBackgroundColor: (0, $kbpa7.wacToken)('color.extended.blue100')
        },
        // ContentBlock copy per revised design direction (2026-07-16):
        // reframe Card 1 around ROI + built-in allowances with the
        // "Explore plans" CTA. Shared across all non-CSR meters.
        contentBlock: {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.assetsObjects.contentBlock.title',
                defaultMessage: 'Maximize your ROI with flexible, usage-based plans'
            }),
            intro: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.assetsObjects.contentBlock.intro',
                defaultMessage: 'With Atlassian collections and apps, built-in allowances align your costs with your real-world usage.'
            }),
            listItems: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.estimate.assetsObjects.contentBlock.listItems.0',
                    defaultMessage: 'Optimize your spend'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.estimate.assetsObjects.contentBlock.listItems.1',
                    defaultMessage: 'Plan with confidence'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.estimate.assetsObjects.contentBlock.listItems.2',
                    defaultMessage: 'Do more with less'
                })
            ],
            href: '/collections'
        }
    },
    allowanceStep: {
        // Step 4 primary CTA — "Compare" per the latest design direction
        // (all meters share this comparison-focused verb on this step).
        nextCta: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.allowance.assetsObjects.nextCta',
            defaultMessage: 'Compare'
        })
    },
    summaryStep: {
        // Step 5 header — per Assets objects Confluence spec.
        title: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.summary.assetsObjects.title',
            defaultMessage: 'Review usage estimate and compare'
        }),
        subtitle: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.summary.assetsObjects.subtitle',
            defaultMessage: "Based on what you\u2019ve told us, here\u2019s a summary of how many Assets Objects you need, and how you can use them."
        }),
        orgNeedsCard: {
            eyebrow: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.assetsObjects.orgNeedsCard.eyebrow',
                defaultMessage: 'YOUR ORGANIZATION NEEDS'
            }),
            headlineSubtext: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.assetsObjects.orgNeedsCard.headlineSubtext',
                defaultMessage: 'Assets objects'
            })
        },
        whatsCoveredCard: {
            eyebrow: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.assetsObjects.whatsCoveredCard.eyebrow',
                defaultMessage: "WHAT\u2019S COVERED"
            }),
            headlineSubtext: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.assetsObjects.whatsCoveredCard.headlineSubtext',
                defaultMessage: 'Assets objects included monthly'
            }),
            bodyCovered: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.assetsObjects.whatsCoveredCard.bodyCovered',
                defaultMessage: 'Your Assets objects are covered within the allowance.'
            }),
            bodyOverage: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.assetsObjects.whatsCoveredCard.bodyOverage',
                defaultMessage: "There\u2019s a gap of {overage} Assets objects. You may incur extra usage charges of {cost}."
            }),
            listItemsCovered: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.assetsObjects.whatsCoveredCard.listItemsCovered.0',
                    defaultMessage: 'Higher plans provide more allowances'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.assetsObjects.whatsCoveredCard.listItemsCovered.1',
                    defaultMessage: 'Track your extra usage via your capabilities subscription details page in admin hub'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.assetsObjects.whatsCoveredCard.listItemsCovered.2',
                    defaultMessage: 'Set an extra usage limit to stay in budget'
                })
            ],
            listItemsOverage: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.assetsObjects.whatsCoveredCard.listItemsOverage.0',
                    defaultMessage: 'Higher plans provide more allowances'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.assetsObjects.whatsCoveredCard.listItemsOverage.1',
                    defaultMessage: 'Track your extra usage via your capabilities subscription details page in admin hub'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.assetsObjects.whatsCoveredCard.listItemsOverage.2',
                    defaultMessage: 'Set an extra usage limit to stay in budget'
                })
            ]
        }
    },
    usageProfiles: {
        exploring: {
            label: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.assetsObjects.exploring.label',
                defaultMessage: 'Emerging'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.assetsObjects.exploring.description',
                defaultMessage: 'Start tracking and managing the people and things that are important to your business.'
            }),
            usageRange: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.assetsObjects.exploring.usageRange',
                defaultMessage: "0\u20133 objects per user"
            }),
            list: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.assetsObjects.exploring.list.0',
                    defaultMessage: 'Track team members or equipment'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.assetsObjects.exploring.list.1',
                    defaultMessage: 'Link objects to work'
                })
            ],
            valueProp: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.assetsObjects.exploring.valueProp',
                defaultMessage: 'Most teams start here and scale up as they connect more of their business to Assets.'
            })
        },
        adopting: {
            label: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.assetsObjects.adopting.label',
                defaultMessage: 'Adopting'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.assetsObjects.adopting.description',
                defaultMessage: 'Track a growing number of objects like people, places, and products. Good for teams tracking important relationships between objects.'
            }),
            usageRange: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.assetsObjects.adopting.usageRange',
                defaultMessage: "4\u201310 objects per user"
            }),
            list: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.assetsObjects.adopting.list.0',
                    defaultMessage: 'Map multiple structured object relationships'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.assetsObjects.adopting.list.1',
                    defaultMessage: 'Model business processes and org structures'
                })
            ],
            valueProp: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.assetsObjects.adopting.valueProp',
                defaultMessage: 'Teams at this usage level often manage many object schemas across multiple departments.'
            })
        },
        scaling: {
            label: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.assetsObjects.scaling.label',
                defaultMessage: 'Scaling'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.assetsObjects.scaling.description',
                defaultMessage: 'Track everything and anything that matters to your business, from laptops to llamas.'
            }),
            usageRange: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.assetsObjects.scaling.usageRange',
                defaultMessage: "11\u201350 objects per user"
            }),
            list: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.assetsObjects.scaling.list.0',
                    defaultMessage: 'Manage complex cross-team dependencies'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.assetsObjects.scaling.list.1',
                    defaultMessage: 'Add significant breadth and depth to the teamwork graph'
                })
            ],
            valueProp: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.assetsObjects.scaling.valueProp',
                defaultMessage: 'Organizations at this scale connect everything and anything that matters to their business.'
            })
        }
    },
    valueProps: [
        {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.assetsObjects.valueProps.0.title',
                defaultMessage: 'Track anything that matters'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.assetsObjects.valueProps.0.description',
                defaultMessage: 'Store and manage any type of business object, from equipment to contracts, locations to vendors, in one structured, searchable place.'
            })
        },
        {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.assetsObjects.valueProps.1.title',
                defaultMessage: 'Stay organized at scale'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.assetsObjects.valueProps.1.description',
                defaultMessage: 'Manage records and object relationships with room to grow as your team needs evolve.'
            })
        },
        {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.assetsObjects.valueProps.2.title',
                defaultMessage: 'Connect work across Atlassian'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.assetsObjects.valueProps.2.description',
                defaultMessage: 'Link objects to your issues, requests, and pages, with full context, always.'
            })
        }
    ]
};

});

parcelRegister("iV1lX", function(module, exports) {
$parcel$export(module.exports, "AUTOMATIONS_CONTENT", function () { return $af23ae5caff16a66$export$364d3689367155bb; });
/**
 * Automations — content bundle for the WAC UBP calculator.
 *
 * Source of truth: Confluence "Automation: Content spec for WAC Calculator"
 * https://hello.atlassian.net/wiki/spaces/acbp/pages/7129271516
 *
 * Content DRI: Belle Craig · Meter CD: Lauren Ryan
 *
 * Fields we haven't finalized are simply OMITTED from this file (most
 * are optional at the type level) so nothing renders for them. Do NOT
 * stub placeholder strings — omit the field entirely instead. There is
 * no `PLACEHOLDER` / `todoCopy` helper exported from this module by
 * design.
 *
 * DO NOT edit unrelated meter files when updating this one — the atomic
 * per-meter file split exists to prevent merge conflicts between authors.
 *
 * i18n: every copy field is wrapped in `defineMessage` with a literal
 * `id` and `defaultMessage`. The extractor is a static AST analyzer —
 * see the i18n contract in `meter-content.types.ts`. Keep both fields
 * literal; never build an id from a variable.
 */ 
var $fnHPc = parcelRequire("fnHPc");

var $kbpa7 = parcelRequire("kbpa7");
const $af23ae5caff16a66$export$364d3689367155bb = {
    description: (0, $fnHPc.defineMessage)({
        id: 'ubp.calculator.usage.automations.description',
        defaultMessage: 'Give your team valuable time back by reducing repetitive manual work with automation flows.'
    }),
    needsStep: {
        // Step 2 "Do you know your usage?" question — Automations copy.
        doYouKnowQuestion: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.needs.automations.doYouKnowQuestion',
            defaultMessage: "Know how many Automation steps you\u2019ll need?"
        })
    },
    estimateStep: {
        subtitle: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.estimate.automations.subtitle',
            defaultMessage: "Based on what you\u2019ve told us, here\u2019s a summary of how many Automation steps you need, and how you can use them."
        }),
        compareCta: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.estimate.automations.compareCta',
            defaultMessage: 'Explore plans'
        }),
        // TEMPORARY: All meters currently share this Orange Logic asset
        // while the content team finalizes per-meter hero imagery.
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/bb1q20l5xjp2i85j55ou317euquo3rv3.png',
            alt: '',
            // eslint-disable-next-line local/ensure-wac-token-usage
            imageBackgroundColor: (0, $kbpa7.wacToken)('color.extended.blue100')
        },
        // ContentBlock copy per revised design direction (2026-07-16):
        // reframe Card 1 around ROI + built-in allowances with the
        // "Explore plans" CTA. Shared across all non-CSR meters.
        contentBlock: {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.automations.contentBlock.title',
                defaultMessage: 'Maximize your ROI with flexible, usage-based plans'
            }),
            intro: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.automations.contentBlock.intro',
                defaultMessage: 'With Atlassian collections and apps, built-in allowances align your costs with your real-world usage.'
            }),
            listItems: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.estimate.automations.contentBlock.listItems.0',
                    defaultMessage: 'Optimize your spend'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.estimate.automations.contentBlock.listItems.1',
                    defaultMessage: 'Plan with confidence'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.estimate.automations.contentBlock.listItems.2',
                    defaultMessage: 'Do more with less'
                })
            ],
            href: '/collections'
        }
    },
    allowanceStep: {
        // Step 4 primary CTA — per Automation Steps Confluence spec.
        // Overrides the generic "Next" with a comparison-focused verb.
        nextCta: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.allowance.automations.nextCta',
            defaultMessage: 'Compare'
        })
    },
    summaryStep: {
        // Step 5 header — per Automations Confluence spec.
        title: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.summary.automations.title',
            defaultMessage: 'Review usage estimate and compare'
        }),
        subtitle: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.summary.automations.subtitle',
            defaultMessage: "Based on what you\u2019ve told us, here\u2019s a summary of how many Automation steps you need, and how you can use them."
        }),
        orgNeedsCard: {
            eyebrow: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.automations.orgNeedsCard.eyebrow',
                defaultMessage: 'YOUR ORGANIZATION NEEDS'
            }),
            headlineSubtext: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.automations.orgNeedsCard.headlineSubtext',
                defaultMessage: 'Automation steps per month'
            })
        },
        whatsCoveredCard: {
            eyebrow: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.automations.whatsCoveredCard.eyebrow',
                defaultMessage: "WHAT\u2019S COVERED"
            }),
            headlineSubtext: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.automations.whatsCoveredCard.headlineSubtext',
                defaultMessage: 'Automation steps included monthly'
            }),
            bodyCovered: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.automations.whatsCoveredCard.bodyCovered',
                defaultMessage: 'Your Automation steps are covered within the allowance.'
            }),
            bodyOverage: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.automations.whatsCoveredCard.bodyOverage',
                defaultMessage: "There\u2019s a gap of {overage} Automation steps. You may incur extra usage charges of {cost}."
            }),
            listItemsCovered: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.automations.whatsCoveredCard.listItemsCovered.0',
                    defaultMessage: 'Higher plans provide more allowances'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.automations.whatsCoveredCard.listItemsCovered.1',
                    defaultMessage: 'Track your extra usage via your capabilities subscription details page in admin hub'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.automations.whatsCoveredCard.listItemsCovered.2',
                    defaultMessage: 'Set an extra usage limit to stay in budget'
                })
            ],
            listItemsOverage: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.automations.whatsCoveredCard.listItemsOverage.0',
                    defaultMessage: 'Higher plans provide more allowances'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.automations.whatsCoveredCard.listItemsOverage.1',
                    defaultMessage: 'Track your extra usage via your capabilities subscription details page in admin hub'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.automations.whatsCoveredCard.listItemsOverage.2',
                    defaultMessage: 'Set an extra usage limit to stay in budget'
                })
            ]
        },
        // Automations spec: share button label is "Share with team" instead
        // of the default "Copy URL to share".
        shareCta: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.summary.automations.shareCta',
            defaultMessage: 'Share with team'
        })
    },
    usageProfiles: {
        exploring: {
            label: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.automations.exploring.label',
                defaultMessage: 'Experimenting'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.automations.exploring.description',
                defaultMessage: 'Best for automating simple tasks for one app such as Jira, or a single space or team.'
            }),
            // usageRange omitted — Automations bullets already convey the range.
            list: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.automations.exploring.list.0',
                    defaultMessage: "1\u201310 steps run per seat per month"
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.automations.exploring.list.1',
                    defaultMessage: "1\u20135 flows created"
                })
            ],
            valueProp: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.automations.exploring.valueProp',
                defaultMessage: 'Best for automating individual tasks and simple team alerts. Focuses on reducing "busy work" like status updates and basic notifications.'
            })
        },
        adopting: {
            label: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.automations.adopting.label',
                defaultMessage: 'Adopting'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.automations.adopting.description',
                defaultMessage: 'Best for automating team collaboration across your Atlassian system of work.'
            }),
            // usageRange omitted — Automations bullets already convey the range.
            list: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.automations.adopting.list.0',
                    defaultMessage: "11\u2013200 steps run per seat per month"
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.automations.adopting.list.1',
                    defaultMessage: "6\u201350 flows created"
                })
            ],
            valueProp: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.automations.adopting.valueProp',
                defaultMessage: 'Designed for teams scaling automation across multiple projects. Includes multi-step flows, cross-product flows, and standardising team rituals.'
            })
        },
        scaling: {
            label: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.automations.scaling.label',
                defaultMessage: 'Scaling'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.automations.scaling.description',
                defaultMessage: 'Best for driving organizational efficiency and democratizing automation for all teams.'
            }),
            // usageRange omitted — Automations bullets already convey the range.
            list: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.automations.scaling.list.0',
                    defaultMessage: '200+ steps run per seat per month'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.automations.scaling.list.1',
                    defaultMessage: '60+ flows created'
                })
            ],
            valueProp: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.automations.scaling.valueProp',
                defaultMessage: 'For organizations running complex business processes at scale. Supports advanced orchestration, global rules, and high-frequency syncs across the entire enterprise.'
            })
        }
    },
    valueProps: [
        {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.automations.valueProps.0.title',
                defaultMessage: 'Automate everyday tasks'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.automations.valueProps.0.description',
                defaultMessage: 'Use automation steps to handle repetitive work like updating fields, sending notifications, creating recurring pages, and keeping issues moving through your workflow.'
            })
        },
        {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.automations.valueProps.1.title',
                defaultMessage: 'Connect workflows across tools'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.automations.valueProps.1.description',
                defaultMessage: "Build multi-step rules that sync work across Jira, Confluence, Loom, and third-party tools \u2014 so teams stay aligned without manual follow-up."
            })
        },
        {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.automations.valueProps.2.title',
                defaultMessage: 'Orchestrate business processes at scale'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.automations.valueProps.2.description',
                defaultMessage: 'Support complex, high-volume processes with branching logic, global rules, and AI-powered steps that help teams summarize, route, and respond to work faster.'
            })
        }
    ]
};

});

parcelRegister("5XjcR", function(module, exports) {
$parcel$export(module.exports, "CS_RESOLUTIONS_CONTENT", function () { return $80a0b4bc708d068d$export$89826e3a3345a753; });
/**
 * CS Resolutions (AI agent resolutions) — content bundle for the WAC UBP calculator.
 *
 * Source of truth: Confluence "AI agent resolutions: Content spec for WAC Calculator"
 * https://hello.atlassian.net/wiki/spaces/acbp/pages/7129370402
 *
 * Content DRI: Belle Craig · Meter CD: Blair Larkin
 *
 * NOTE ON PROFILE KEYS: The `UsageType` enum has stable keys
 * `exploring | adopting | scaling` for URL/state/analytics compatibility.
 * The CSR spec's visible labels are `Basic | Moderate | Comprehensive`,
 * which are the customer-facing strings shown on the profile cards.
 * The keys are internal identifiers only — do NOT rename them.
 *
 * Fields we haven't finalized are simply OMITTED from this file (most
 * are optional at the type level) so nothing renders for them. Do NOT
 * stub placeholder strings — omit the field entirely instead. There is
 * no `PLACEHOLDER` / `todoCopy` helper exported from this module by
 * design.
 *
 * DO NOT edit unrelated meter files when updating this one — the atomic
 * per-meter file split exists to prevent merge conflicts between authors.
 *
 * i18n: every copy field is wrapped in `defineMessage` with a literal
 * `id` and `defaultMessage`. The extractor is a static AST analyzer —
 * see the i18n contract in `meter-content.types.ts`. Keep both fields
 * literal; never build an id from a variable.
 */ 
var $fnHPc = parcelRequire("fnHPc");
const $80a0b4bc708d068d$export$89826e3a3345a753 = {
    description: (0, $fnHPc.defineMessage)({
        id: 'ubp.calculator.usage.csResolutions.description',
        defaultMessage: 'Use an AI agent to support customers and resolve requests before they reach your support team.'
    }),
    needsStep: {
        // Step 2 "Do you know your usage?" question — AI agent resolutions copy.
        doYouKnowQuestion: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.needs.csResolutions.doYouKnowQuestion',
            defaultMessage: "Know how many resolutions you\u2019ll need?"
        })
    },
    estimateStep: {
        subtitle: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.estimate.csResolutions.subtitle',
            defaultMessage: "Based on what you\u2019ve told us, here\u2019s a summary of how many AI Agent Resolutions you need, and how you can use them."
        }),
        // CSR Step 3 doesn’t use the Compare-value flow — the CSR spec’s
        // Card 1 Primary CTA is “Get Customer Service Management” instead.
        // The dedicated `EstimateCsrStep` component renders that CTA. This
        // field is kept for shape parity with other meters and is unused by
        // `EstimateCsrStep`; if a future CSR variant reuses the ContentBlock
        // "Compare" pattern, the string here is ready to swap in.
        compareCta: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.estimate.csResolutions.compareCta',
            defaultMessage: 'Get Customer Service Management'
        }),
        // CSR's Compare button navigates to the public Service Collection
        // landing page rather than advancing to the calculator's Summary
        // step — CSR summary lives on that landing page instead. Per
        // AI agent resolutions Confluence spec and product direction.
        compareHref: 'https://www.atlassian.com/collections/service',
        // AI agent resolutions uses its own hero asset — the blue-panel
        // service-collection graphic from Figma node 1103:33298. Distinct
        // from the shared Rovo/Automations/Assets placeholder image.
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t7fyco15otc1im8640lqtcaa3uip5j53.png',
            alt: ''
        },
        // ContentBlock copy per AI agent resolutions Confluence spec —
        // Step 3 right-column "Get Service Collection" panel.
        contentBlock: {
            // Copy verbatim from AI agent resolutions Confluence spec Step 3
            // Card 1 (title "Get Customer Service Management to use AI agent
            // resolutions", body copy about proactive support, and the three
            // check-mark bullets underneath).
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.csResolutions.contentBlock.title',
                defaultMessage: 'Get Customer Service Management to use AI agent resolutions'
            }),
            intro: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.csResolutions.contentBlock.intro',
                defaultMessage: 'Deliver proactive support with AI agents, shared customer context, and connected teams.'
            }),
            listItems: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.estimate.csResolutions.contentBlock.listItems.0',
                    defaultMessage: 'Resolve requests faster with AI agents.'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.estimate.csResolutions.contentBlock.listItems.1',
                    defaultMessage: 'Give your support team full customer context instantly.'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.estimate.csResolutions.contentBlock.listItems.2',
                    defaultMessage: 'Unite support and engineering teams together.'
                })
            ],
            // Card 1 Primary CTA per spec is "Get Customer Service Management" —
            // point to the CSM landing page.
            href: '/software/customer-service-management'
        }
    },
    allowanceStep: {
        // Step 4 primary CTA — "Compare" per the latest design direction
        // (all meters share this comparison-focused verb on this step).
        nextCta: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.allowance.csResolutions.nextCta',
            defaultMessage: 'Compare'
        })
    },
    summaryStep: {
        // Step 5 header — per AI agent resolutions Confluence spec.
        title: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.summary.csResolutions.title',
            defaultMessage: 'Review usage estimate and compare'
        }),
        subtitle: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.summary.csResolutions.subtitle',
            defaultMessage: "Based on what you\u2019ve told us, here\u2019s a summary of how many AI Agent Resolutions you need, and how you can use them."
        }),
        // Per Figma node 2055:13212: CSR shows the org needs card AND
        // a Monthly Cost Estimate card (instead of "What's covered").
        // `headline` is injected at render time by summary-step.tsx from
        // the live usage-range calculation, so it's omitted here.
        // `body` and `footerNote` are omitted until the content team
        // finalizes them (ResultsCard renders without them).
        orgNeedsCard: {
            eyebrow: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.csResolutions.orgNeedsCard.eyebrow',
                defaultMessage: 'YOUR ORGANIZATION NEEDS'
            }),
            headlineSubtext: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.csResolutions.orgNeedsCard.headlineSubtext',
                defaultMessage: 'AI agent resolutions/monthly'
            })
        },
        // GWP-12277 / Figma nodes 2164:27044 (Step 3) & 2164:28256 (Step 5):
        // Monthly Cost Estimate card. Renders on both Step 3 (Estimate) and
        // Step 5 (Summary) in the left column below the OrgNeedsCard. Body
        // copy is dynamic:
        //   - overage case  → `body`         (usage exceeds allowance)
        //   - covered case  → `bodyCovered`  (usage fits within allowance)
        // `{rate}` in `rateNote` is replaced at render time with the
        // currency-formatted per-resolution overage rate. `listItems` are
        // the AI agent resolutions value props from Confluence (Chat / Voice
        // / Email AI). Shown on Step 5 (Summary) only — Step 3's
        // MonthlyCostEstimateCard intentionally omits these bullets.
        overageCostCard: {
            eyebrow: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.csResolutions.overageCostCard.eyebrow',
                defaultMessage: 'MONTHLY COST ESTIMATE'
            }),
            rateNote: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.csResolutions.overageCostCard.rateNote',
                defaultMessage: 'at {rate} per resolution'
            }),
            body: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.csResolutions.overageCostCard.body',
                defaultMessage: 'Your AI agent resolutions usage costs are not 100% covered by allowances.'
            }),
            bodyCovered: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.csResolutions.overageCostCard.bodyCovered',
                defaultMessage: 'Your AI agent resolutions usage is covered by allowances.'
            }),
            listItems: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.csResolutions.overageCostCard.listItems.0',
                    defaultMessage: 'Chat widget AI responds to customers instantly through your website.'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.csResolutions.overageCostCard.listItems.1',
                    defaultMessage: 'Voice AI answers calls, resolves common questions, and reduces wait times.'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.csResolutions.overageCostCard.listItems.2',
                    defaultMessage: 'Email AI provides immediate responses to customer requests via email.'
                })
            ]
        }
    },
    usageProfiles: {
        exploring: {
            label: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.csResolutions.exploring.label',
                defaultMessage: 'Basic'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.csResolutions.exploring.description',
                defaultMessage: "You\u2019re building out your knowledge base and expect your AI agent to be able to handle some basic requests."
            }),
            // usageRange omitted per design — not shown on CSR Step 2 cards.
            // list omitted — CSR profile cards don't render bullets.
            valueProp: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.csResolutions.exploring.valueProp',
                defaultMessage: "Expected resolution rate: 20\u201340%"
            })
        },
        adopting: {
            label: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.csResolutions.adopting.label',
                defaultMessage: 'Moderate'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.csResolutions.adopting.description',
                defaultMessage: 'Your knowledge base covers your most common topics and your AI agent will be able to handle a meaningful share of questions.'
            }),
            // usageRange omitted per design — not shown on CSR Step 2 cards.
            valueProp: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.csResolutions.adopting.valueProp',
                defaultMessage: "Expected resolution rate: 40\u201360%"
            })
        },
        scaling: {
            label: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.csResolutions.scaling.label',
                defaultMessage: 'Comprehensive'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.csResolutions.scaling.description',
                defaultMessage: 'Your knowledge base is thorough, well-maintained, and your AI agent will be able to resolve most questions without help.'
            }),
            // usageRange omitted per design — not shown on CSR Step 2 cards.
            valueProp: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.csResolutions.scaling.valueProp',
                defaultMessage: "Expected resolution rate: 60\u201380%"
            })
        }
    },
    valueProps: [
        {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.csResolutions.valueProps.0.title',
                defaultMessage: 'Chat widget AI'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.csResolutions.valueProps.0.description',
                defaultMessage: 'Responds to customers instantly through a chat widget embedded on your website.'
            })
        },
        {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.csResolutions.valueProps.1.title',
                defaultMessage: 'Voice AI'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.csResolutions.valueProps.1.description',
                defaultMessage: 'Answers calls, resolves common questions, reduces wait times and generates transcripts.'
            })
        },
        {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.csResolutions.valueProps.2.title',
                defaultMessage: 'Email AI'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.csResolutions.valueProps.2.description',
                defaultMessage: 'Provides immediate responses to customer requests sent via email.'
            })
        }
    ]
};

});

parcelRegister("9LuUL", function(module, exports) {
$parcel$export(module.exports, "ROVO_CREDITS_CONTENT", function () { return $51586062e6fbd47f$export$cc25fbccd37e1f8f; });
/**
 * Rovo Credits — content bundle for the WAC UBP calculator.
 *
 * Source of truth: Confluence "Rovo: Content spec for WAC Calculator"
 * https://hello.atlassian.net/wiki/spaces/acbp/pages/7129272798
 *
 * Content DRI: Belle Craig · Meter CD: Melissa Jaén
 *
 * Fields we haven't finalized are simply OMITTED from this file (most
 * are optional at the type level) so nothing renders for them. Do NOT
 * stub placeholder strings — omit the field entirely instead. There is
 * no `PLACEHOLDER` / `todoCopy` helper exported from this module by
 * design.
 *
 * DO NOT edit unrelated meter files when updating this one — the atomic
 * per-meter file split exists to prevent merge conflicts between authors.
 *
 * i18n: every copy field is wrapped in `defineMessage` with a literal
 * `id` and `defaultMessage`. The extractor is a static AST analyzer —
 * see the i18n contract in `meter-content.types.ts`. Keep both fields
 * literal; never build an id from a variable.
 */ 
var $fnHPc = parcelRequire("fnHPc");

var $kbpa7 = parcelRequire("kbpa7");
const $51586062e6fbd47f$export$cc25fbccd37e1f8f = {
    description: (0, $fnHPc.defineMessage)({
        id: 'ubp.calculator.usage.rovoCredits.description',
        defaultMessage: 'Get fast answers, run powerful AI agents, and connect your organizational context to any AI tool.'
    }),
    needsStep: {
        // Step 2 "Do you know your usage?" question — Rovo copy.
        doYouKnowQuestion: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.needs.rovoCredits.doYouKnowQuestion',
            defaultMessage: "Know how many credits you\u2019ll need?"
        })
    },
    estimateStep: {
        subtitle: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.estimate.rovoCredits.subtitle',
            defaultMessage: "Based on what you\u2019ve told us, here\u2019s a summary of how many Rovo credits you need, and how you can use them."
        }),
        compareCta: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.estimate.rovoCredits.compareCta',
            defaultMessage: 'Explore plans'
        }),
        // TEMPORARY: All meters currently share this Orange Logic asset
        // while the content team finalizes per-meter hero imagery. Track
        // replacement in the follow-up content ticket.
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/bb1q20l5xjp2i85j55ou317euquo3rv3.png',
            alt: '',
            imageBackgroundColor: (0, $kbpa7.wacToken)('color.extended.blue100')
        },
        // ContentBlock copy per Rovo Confluence spec (Step 3 right-column
        // "Compare value" panel).
        contentBlock: {
            // Copy per revised design direction (2026-07-16): reframe the
            // Card 1 messaging around ROI + built-in allowances, using
            // the "Explore plans" CTA (paired with `compareCta` above).
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.rovoCredits.contentBlock.title',
                defaultMessage: 'Maximize your ROI with flexible, usage-based plans'
            }),
            intro: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.rovoCredits.contentBlock.intro',
                defaultMessage: 'With Atlassian collections and apps, built-in allowances align your costs with your real-world usage.'
            }),
            listItems: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.estimate.rovoCredits.contentBlock.listItems.0',
                    defaultMessage: 'Optimize your spend'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.estimate.rovoCredits.contentBlock.listItems.1',
                    defaultMessage: 'Plan with confidence'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.estimate.rovoCredits.contentBlock.listItems.2',
                    defaultMessage: 'Do more with less'
                })
            ],
            href: '/collections'
        }
    },
    allowanceStep: {
        // Step 4 primary CTA — "Compare" per the latest design direction
        // (all meters share the comparison-focused verb on this step so
        // users understand the Summary step surfaces a comparison view).
        nextCta: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.allowance.rovoCredits.nextCta',
            defaultMessage: 'Compare'
        })
    },
    summaryStep: {
        // Step 5 header title — currently uniform across all meters per
        // spec. Kept per-meter for future flexibility (content team may
        // promote per-meter variants later, e.g. "Review your Rovo plan").
        title: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.summary.rovoCredits.title',
            defaultMessage: 'Review usage estimate and compare'
        }),
        subtitle: (0, $fnHPc.defineMessage)({
            id: 'ubp.calculator.summary.rovoCredits.subtitle',
            defaultMessage: "Based on what you\u2019ve told us, here\u2019s a summary of how many Rovo credits you need, and how you can use them."
        }),
        // Rovo shows BOTH cards (org needs + what's covered) per
        // Figma node 2055:13212 & the Rovo Confluence spec.
        // Only the eyebrow + subtext are static — the `headline` is
        // injected at render time by summary-step.tsx from the live
        // usage-range calculation, so it's intentionally omitted here.
        // `body` and `footerNote` are omitted until content is
        // finalized (the ResultsCard renders without them).
        orgNeedsCard: {
            eyebrow: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.rovoCredits.orgNeedsCard.eyebrow',
                defaultMessage: 'YOUR ORGANIZATION NEEDS'
            }),
            headlineSubtext: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.rovoCredits.orgNeedsCard.headlineSubtext',
                defaultMessage: 'Rovo credits monthly'
            })
        },
        // "What's covered" card (Rovo Confluence spec Step 5, Card 4).
        // This card is DYNAMIC based on whether the org's estimated usage
        // fits within its included allowance:
        //   - headline       → live included allowance (e.g. "200,000")
        //   - headlineSubtext→ "Rovo credits included monthly"
        //   - covered case   → bodyCovered + listItemsCovered (value props)
        //   - overage case   → bodyOverage + listItemsOverage (guidance)
        // The `{overage}` / `{cost}` tokens in bodyOverage are replaced at
        // render time by summary-step.tsx with the live extra-usage range
        // and estimated extra monthly charge.
        whatsCoveredCard: {
            eyebrow: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.rovoCredits.whatsCoveredCard.eyebrow',
                defaultMessage: "WHAT\u2019S COVERED"
            }),
            headlineSubtext: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.rovoCredits.whatsCoveredCard.headlineSubtext',
                defaultMessage: 'Rovo credits included monthly'
            }),
            bodyCovered: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.rovoCredits.whatsCoveredCard.bodyCovered',
                defaultMessage: 'Your Rovo credits are covered within the allowance.'
            }),
            bodyOverage: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.summary.rovoCredits.whatsCoveredCard.bodyOverage',
                defaultMessage: "There\u2019s a gap of {overage} Rovo credits. You may incur extra usage charges of {cost}."
            }),
            listItemsCovered: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.rovoCredits.whatsCoveredCard.listItemsCovered.0',
                    defaultMessage: 'Quick answers'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.rovoCredits.whatsCoveredCard.listItemsCovered.1',
                    defaultMessage: 'Extended tasks'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.rovoCredits.whatsCoveredCard.listItemsCovered.2',
                    defaultMessage: 'Custom agents'
                })
            ],
            listItemsOverage: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.rovoCredits.whatsCoveredCard.listItemsOverage.0',
                    defaultMessage: 'Higher plans provide more allowances'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.rovoCredits.whatsCoveredCard.listItemsOverage.1',
                    defaultMessage: 'Track your extra usage via your capabilities subscription details page in admin hub'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.summary.rovoCredits.whatsCoveredCard.listItemsOverage.2',
                    defaultMessage: 'Set an extra usage limit to stay in budget'
                })
            ]
        }
    },
    usageProfiles: {
        // Bullets (`list`) and value props (`valueProp`) per the finalized
        // Rovo Confluence spec Step 2 (Meter Usage Profiles). `usageRange`
        // is not displayed on the Step 2 cards themselves (per spec note
        // "not displayed in this step") but drives the usage estimate.
        exploring: {
            label: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.rovoCredits.exploring.label',
                defaultMessage: 'Early exploration'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.rovoCredits.exploring.description',
                defaultMessage: "We\u2019re testing the waters \u2014 using AI for the occasional search, summary, or draft to see where it adds value."
            }),
            usageRange: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.rovoCredits.exploring.usageRange',
                defaultMessage: "100\u2013500 per user per month"
            }),
            list: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.rovoCredits.exploring.list.0',
                    defaultMessage: 'A few Chat searches and summaries'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.rovoCredits.exploring.list.1',
                    defaultMessage: 'The occasional complex research task'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.rovoCredits.exploring.list.2',
                    defaultMessage: 'Trying out an agent once or twice'
                })
            ],
            valueProp: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.rovoCredits.exploring.valueProp',
                defaultMessage: 'Teams in the early exploration profile typically save up to 2 hours per month per user.'
            })
        },
        adopting: {
            label: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.rovoCredits.adopting.label',
                defaultMessage: 'Routine adoption'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.rovoCredits.adopting.description',
                defaultMessage: "AI is part of how we work each week \u2014 drafting content, catching up on updates, and automating repetitive steps across projects."
            }),
            usageRange: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.rovoCredits.adopting.usageRange',
                defaultMessage: "500\u20132,000 per user per month"
            }),
            list: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.rovoCredits.adopting.list.0',
                    defaultMessage: 'Chat most days for quick answers'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.rovoCredits.adopting.list.1',
                    defaultMessage: 'Weekly research or analysis in Think Deeper'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.rovoCredits.adopting.list.2',
                    defaultMessage: 'Agents handling recurring tasks'
                })
            ],
            valueProp: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.rovoCredits.adopting.valueProp',
                defaultMessage: "Teams in the routine adoption profile typically save 5\u20136 hours per month, per user."
            })
        },
        scaling: {
            label: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.rovoCredits.scaling.label',
                defaultMessage: 'Transformative usage'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.rovoCredits.scaling.description',
                defaultMessage: 'Multiple teams rely on AI daily for planning, decision-making, and connecting knowledge across tools.'
            }),
            usageRange: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.rovoCredits.scaling.usageRange',
                defaultMessage: "2,000\u20134,000 per user per month"
            }),
            list: [
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.rovoCredits.scaling.list.0',
                    defaultMessage: 'AI embedded in daily workflows across teams'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.rovoCredits.scaling.list.1',
                    defaultMessage: 'Agents running autonomously in automations'
                }),
                (0, $fnHPc.defineMessage)({
                    id: 'ubp.calculator.needs.rovoCredits.scaling.list.2',
                    defaultMessage: 'Complex research and planning on demand'
                })
            ],
            valueProp: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.needs.rovoCredits.scaling.valueProp',
                defaultMessage: "Teams in the transformative usage profile typically save 1\u20132 days per month, per user."
            })
        }
    },
    valueProps: [
        {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.rovoCredits.valueProps.0.title',
                defaultMessage: 'Quick answers'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.rovoCredits.valueProps.0.description',
                defaultMessage: 'Get quick insights, summaries, and recommendations from Rovo Chat, without leaving your workflow.'
            })
        },
        {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.rovoCredits.valueProps.1.title',
                defaultMessage: 'Extended tasks'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.rovoCredits.valueProps.1.description',
                defaultMessage: 'Dynamically plan, search, reason, and iterate to return a thorough answer with Think deeper mode.'
            })
        },
        {
            title: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.rovoCredits.valueProps.2.title',
                defaultMessage: 'Custom agents'
            }),
            description: (0, $fnHPc.defineMessage)({
                id: 'ubp.calculator.estimate.rovoCredits.valueProps.2.description',
                defaultMessage: 'Power specialized agents for tasks like grooming Jira backlogs, summarizing Confluence spaces, or drafting internal comms on behalf of specific teams.'
            })
        }
    ]
};

});


parcelRegister("73KXs", function(module, exports) {
$parcel$export(module.exports, "STEP_ORDER", function () { return $2c8de9845b52d439$export$fe5882e1cacea70d; });
$parcel$export(module.exports, "EDITION_KEYS", function () { return $2c8de9845b52d439$export$15d2fd08fe349b20; });
$parcel$export(module.exports, "METER_ALLOWED_APPS", function () { return $2c8de9845b52d439$export$a01fd56ace2b3733; });
const $2c8de9845b52d439$export$fe5882e1cacea70d = [
    'usage',
    'needs',
    'estimate',
    'allowance',
    'summary'
];
const $2c8de9845b52d439$export$15d2fd08fe349b20 = [
    'free',
    'standard',
    'premium',
    'enterprise'
];
const $2c8de9845b52d439$export$a01fd56ace2b3733 = {
    assetsObjects: [
        'jira',
        'jsm'
    ],
    automations: [
        'jira',
        'jsm',
        'confluence',
        'jpd'
    ],
    rovoCredits: [
        'jira',
        'jsm',
        'confluence'
    ],
    // No allowance step for AI agent resolutions — users skip straight to Summary.
    csResolutions: null
};

});

parcelRegister("4xsw0", function(module, exports) {
$parcel$export(module.exports, "useSelector", function () { return $8fa95e6732429854$export$2105062e25df4afe; });
$parcel$export(module.exports, "useSetStep", function () { return $8fa95e6732429854$export$5fbef6a33fc3ef44; });
$parcel$export(module.exports, "useGoToNextStep", function () { return $8fa95e6732429854$export$4b216893d72ebc80; });
$parcel$export(module.exports, "useGoToPrevStep", function () { return $8fa95e6732429854$export$b300120c1380d28d; });
$parcel$export(module.exports, "useResetAll", function () { return $8fa95e6732429854$export$7ae092e5866bd7d3; });
$parcel$export(module.exports, "useSetMeter", function () { return $8fa95e6732429854$export$4f3e1ecf83371c48; });
$parcel$export(module.exports, "useSetUsageType", function () { return $8fa95e6732429854$export$9ec5ebc9bad43cb7; });
$parcel$export(module.exports, "useSetUsage", function () { return $8fa95e6732429854$export$3fd4f1a3274debf1; });
$parcel$export(module.exports, "useSetOrgUserCount", function () { return $8fa95e6732429854$export$307b1513ee9fcb41; });
$parcel$export(module.exports, "useOrgUserCountErrorMessage", function () { return $8fa95e6732429854$export$28caaf198b922e93; });
$parcel$export(module.exports, "useSetProductEdition", function () { return $8fa95e6732429854$export$4fc48d5e08ee88df; });
$parcel$export(module.exports, "useSetProductUnitCount", function () { return $8fa95e6732429854$export$fc62b22dc158a1c1; });
$parcel$export(module.exports, "useToggleProduct", function () { return $8fa95e6732429854$export$def94a993d8009ff; });

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $cGx7y = parcelRequire("cGx7y");

var $iqmYR = parcelRequire("iqmYR");

var $73KXs = parcelRequire("73KXs");

var $9lJTH = parcelRequire("9lJTH");

var $hSUNh = parcelRequire("hSUNh");

var $5eLaZ = parcelRequire("5eLaZ");
const $8fa95e6732429854$export$2105062e25df4afe = (selector)=>selector((0, $9lJTH.useUbpContext)());
const $8fa95e6732429854$export$5fbef6a33fc3ef44 = ()=>{
    const { setStep: setStep } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((step)=>setStep(step), [
        setStep
    ]);
};
const $8fa95e6732429854$export$4b216893d72ebc80 = ()=>{
    const { step: step, setStep: setStep, meter: meter } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)(()=>{
        const currentIndex = (0, $73KXs.STEP_ORDER).indexOf(step);
        let nextIndex = currentIndex + 1;
        // csResolutions has no allowance step — skip it in both directions.
        if ((0, $73KXs.METER_ALLOWED_APPS)[meter] === null && (0, $73KXs.STEP_ORDER)[nextIndex] === 'allowance') nextIndex += 1;
        const next = (0, $73KXs.STEP_ORDER)[nextIndex];
        if (next) setStep(next);
    }, [
        step,
        setStep,
        meter
    ]);
};
const $8fa95e6732429854$export$b300120c1380d28d = ()=>{
    const { step: step, setStep: setStep, meter: meter } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)(()=>{
        const currentIndex = (0, $73KXs.STEP_ORDER).indexOf(step);
        let prevIndex = currentIndex - 1;
        // csResolutions has no allowance step — skip it in both directions.
        if ((0, $73KXs.METER_ALLOWED_APPS)[meter] === null && (0, $73KXs.STEP_ORDER)[prevIndex] === 'allowance') prevIndex -= 1;
        const prev = (0, $73KXs.STEP_ORDER)[prevIndex];
        if (prev) setStep(prev);
    }, [
        step,
        setStep,
        meter
    ]);
};
const $8fa95e6732429854$export$7ae092e5866bd7d3 = ()=>{
    const { resetAll: resetAll } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)(()=>resetAll(), [
        resetAll
    ]);
};
const $8fa95e6732429854$export$4f3e1ecf83371c48 = ()=>{
    const { setMeter: setMeter } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((meter)=>setMeter(meter), [
        setMeter
    ]);
};
const $8fa95e6732429854$export$9ec5ebc9bad43cb7 = ()=>{
    const { setUsageType: setUsageType } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((usageType)=>setUsageType(usageType), [
        setUsageType
    ]);
};
const $8fa95e6732429854$export$3fd4f1a3274debf1 = ()=>{
    const { setUsage: setUsage } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((usage)=>setUsage(usage), [
        setUsage
    ]);
};
const $8fa95e6732429854$export$307b1513ee9fcb41 = ()=>{
    const { setOrgUserCount: setOrgUserCount, setOrgUserCountError: setOrgUserCountError } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((orgUserCount)=>{
        setOrgUserCountError((0, $5eLaZ.validateOrgUserCount)(orgUserCount));
        setOrgUserCount(orgUserCount);
    }, [
        setOrgUserCount,
        setOrgUserCountError
    ]);
};
const $8fa95e6732429854$export$28caaf198b922e93 = ()=>{
    const intl = (0, $8e22h.default)();
    const error = $8fa95e6732429854$export$2105062e25df4afe((0, $hSUNh.selectOrgUserCountError));
    if (!error) return undefined;
    const message = (0, $5eLaZ.orgUserCountErrorMessages)[error];
    return intl.formatMessage(message, {
        min: (0, $5eLaZ.ORG_USER_COUNT_MIN),
        max: (0, $5eLaZ.ORG_USER_COUNT_MAX)
    });
};
const $8fa95e6732429854$export$4fc48d5e08ee88df = ()=>{
    const update = $8fa95e6732429854$var$useUpdateProductInputs();
    return (0, $1oC0p.useCallback)((productKey, edition)=>update(productKey, {
            edition: edition,
            billingCycle: (0, $iqmYR.resolveBillingCycle)(productKey, edition)
        }), [
        update
    ]);
};
const $8fa95e6732429854$export$fc62b22dc158a1c1 = ()=>{
    const update = $8fa95e6732429854$var$useUpdateProductInputs();
    return (0, $1oC0p.useCallback)((productKey, unitCount)=>update(productKey, {
            unitCount: unitCount
        }), [
        update
    ]);
};
const $8fa95e6732429854$export$3cfff81176298bbc = ()=>{
    const { setProducts: setProducts } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((productKey)=>{
        setProducts((prev)=>prev.some((product)=>product.productKey === productKey) ? prev : [
                ...prev,
                (0, $9lJTH.buildDefaultProduct)(productKey)
            ]);
    }, [
        setProducts
    ]);
};
const $8fa95e6732429854$export$7046da6c329e2110 = ()=>{
    const { setProducts: setProducts } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)(()=>setProducts([]), [
        setProducts
    ]);
};
const $8fa95e6732429854$export$bfb26c471dd1b389 = (tab, setTab)=>{
    const { setProductTabSelectionWarningShown: setProductTabSelectionWarningShown } = (0, $9lJTH.useUbpContext)();
    const hasSelections = $8fa95e6732429854$export$2105062e25df4afe((0, $hSUNh.selectCategoryHasSelections)(tab));
    const clearProducts = $8fa95e6732429854$export$7046da6c329e2110();
    return (next)=>{
        if (next === tab) return;
        setProductTabSelectionWarningShown(hasSelections);
        clearProducts();
        setTab(next);
    };
};
const $8fa95e6732429854$export$8212d82dd5be3dd = ()=>{
    const { setProducts: setProducts } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((productKey)=>{
        setProducts((prev)=>prev.filter((product)=>product.productKey !== productKey));
    }, [
        setProducts
    ]);
};
const $8fa95e6732429854$export$def94a993d8009ff = ()=>{
    const { setProducts: setProducts, orgUserCount: orgUserCount } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((key, selected)=>{
        const config = (0, $cGx7y.getProductPricingConfig)(key);
        const category = config.category;
        setProducts((prev)=>{
            if (!selected) return prev.filter((p)=>p.productKey !== key);
            const sameCategory = prev.filter((p)=>p.productKey !== key && (0, $cGx7y.getProductPricingConfig)(p.productKey).category === category);
            const base = (0, $9lJTH.buildDefaultProduct)(key);
            const maxUnitCount = (0, $cGx7y.getConfigMaxUnitCount)(config, base.inputs.edition);
            const seeded = {
                ...base,
                inputs: {
                    ...base.inputs,
                    unitCount: Math.min(orgUserCount ?? base.inputs.unitCount, maxUnitCount)
                }
            };
            return [
                ...sameCategory,
                seeded
            ];
        });
    }, [
        setProducts,
        orgUserCount
    ]);
};
const $8fa95e6732429854$var$useUpdateProductInputs = ()=>{
    const { setProducts: setProducts } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((productKey, patch)=>{
        setProducts((prev)=>prev.map((product)=>product.productKey === productKey ? {
                    ...product,
                    inputs: {
                        ...product.inputs,
                        ...patch
                    }
                } : product));
    }, [
        setProducts
    ]);
};

});
parcelRegister("cGx7y", function(module, exports) {
$parcel$export(module.exports, "productPricingConfigs", function () { return $97ddc95827d4610b$export$93f5d26437fc4220; });
$parcel$export(module.exports, "productPricingConfigKeys", function () { return $97ddc95827d4610b$export$ece495eb5e96bca4; });
$parcel$export(module.exports, "getConfigMaxUnitCount", function () { return $97ddc95827d4610b$export$4a9648637d359c0a; });
$parcel$export(module.exports, "getProductPricingConfig", function () { return $97ddc95827d4610b$export$4521892356e3707c; });

var $29JVp = parcelRequire("29JVp");

var $j1ORI = parcelRequire("j1ORI");

var $lc7EO = parcelRequire("lc7EO");

var $gcAZd = parcelRequire("gcAZd");

var $fEBe5 = parcelRequire("fEBe5");

var $YmHME = parcelRequire("YmHME");
// Preference order for the default edition: prefer a paid mid-tier, else fall
// back to whatever the product actually sells. Some products sell only one
// edition, so the final fallback is the first registered edition rather than a
// fixed "free".
const $97ddc95827d4610b$var$EDITION_PREFERENCE = [
    'standard',
    'free',
    'premium',
    'enterprise'
];
const $97ddc95827d4610b$export$93f5d26437fc4220 = {
    jira: $97ddc95827d4610b$var$defineProduct({
        productKey: 'jira',
        category: 'app',
        config: {
            planLimitConfigs: $j1ORI.jiraPlanLimitConfigs,
            billingCycleConfig: $j1ORI.jiraBillingCycleConfig,
            unitMinEnterprise: $j1ORI.JIRA_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $j1ORI.jiraOfferingSkus,
        offeringSkus: $j1ORI.jiraOfferingSkusArray,
        defaultUnitCount: $j1ORI.JIRA_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $j1ORI.JIRA_DEFAULT_BILLING_CYCLE
    }),
    confluence: $97ddc95827d4610b$var$defineProduct({
        productKey: 'confluence',
        category: 'app',
        config: {
            planLimitConfigs: $29JVp.confluencePlanLimitConfigs,
            billingCycleConfig: $29JVp.confluenceBillingCycleConfig,
            unitMinEnterprise: $29JVp.CONFLUENCE_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $29JVp.confluenceOfferingSkus,
        offeringSkus: $29JVp.confluenceOfferingSkusArray,
        defaultUnitCount: $29JVp.CONFLUENCE_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $29JVp.CONFLUENCE_DEFAULT_BILLING_CYCLE
    }),
    jsm: $97ddc95827d4610b$var$defineProduct({
        productKey: 'jsm',
        category: 'app',
        config: {
            planLimitConfigs: $gcAZd.jsmPlanLimitConfigs,
            billingCycleConfig: $gcAZd.jsmBillingCycleConfig,
            unitMinEnterprise: $gcAZd.JSM_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $gcAZd.jsmOfferingSkus,
        offeringSkus: $gcAZd.jsmOfferingSkusArray,
        defaultUnitCount: $gcAZd.JSM_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $gcAZd.JSM_DEFAULT_BILLING_CYCLE
    }),
    jpd: $97ddc95827d4610b$var$defineProduct({
        productKey: 'jpd',
        category: 'app',
        config: {
            // jpd's plan-limit + sku exports are FF-gated functions, not the
            // static arrays every other config uses — call them here.
            planLimitConfigs: $lc7EO.jpdPlanLimitConfigs(),
            billingCycleConfig: $lc7EO.jpdBillingCycleConfig,
            unitMinEnterprise: $lc7EO.JPD_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $lc7EO.jpdOfferingSkus,
        offeringSkus: $lc7EO.jpdOfferingSkusArray(),
        defaultUnitCount: $lc7EO.JPD_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $lc7EO.JPD_DEFAULT_BILLING_CYCLE
    }),
    teamworkCollection: $97ddc95827d4610b$var$defineProduct({
        productKey: 'teamworkCollection',
        category: 'collection',
        config: {
            planLimitConfigs: $YmHME.teamworkCollectionPlanLimitConfigs,
            billingCycleConfig: $YmHME.teamworkCollectionBillingCycleConfig,
            unitMinEnterprise: $YmHME.TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $YmHME.teamworkCollectionOfferingSkus,
        offeringSkus: $YmHME.teamworkCollectionOfferingSkusArray,
        defaultUnitCount: $YmHME.TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $YmHME.TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE
    }),
    serviceCollection: $97ddc95827d4610b$var$defineProduct({
        productKey: 'serviceCollection',
        category: 'collection',
        config: {
            planLimitConfigs: $fEBe5.serviceCollectionPlanLimitConfigs,
            billingCycleConfig: $fEBe5.serviceCollectionBillingCycleConfig,
            unitMinEnterprise: $fEBe5.SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $fEBe5.serviceCollectionOfferingSkus,
        offeringSkus: $fEBe5.serviceCollectionOfferingSkusArray,
        defaultUnitCount: $fEBe5.SERVICE_COLLECTION_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $fEBe5.SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE
    })
};
const $97ddc95827d4610b$export$ece495eb5e96bca4 = Object.keys($97ddc95827d4610b$export$93f5d26437fc4220);
const $97ddc95827d4610b$export$4a9648637d359c0a = (config, edition)=>{
    const sku = config.editionToSku[edition];
    const selectedPlan = config.planLimitConfigs.find((plan)=>plan.offeringSku === sku);
    return selectedPlan?.signupLimit ?? Math.max(...config.planLimitConfigs.map((p)=>p.signupLimit));
};
const $97ddc95827d4610b$export$4521892356e3707c = (productKey)=>{
    const def = $97ddc95827d4610b$export$93f5d26437fc4220[productKey];
    if (!def) throw new Error(`No UBP product pricing config registered for "${productKey}"`);
    return def;
};
function $97ddc95827d4610b$var$defineProduct(args) {
    const defaultEdition = $97ddc95827d4610b$var$EDITION_PREFERENCE.find((edition)=>args.editionToSku[edition]) ?? Object.keys(args.editionToSku)[0];
    return {
        productKey: args.productKey,
        category: args.category,
        planLimitConfigs: args.config.planLimitConfigs,
        billingCycleConfig: args.config.billingCycleConfig,
        unitMinEnterprise: args.config.unitMinEnterprise,
        editionToSku: args.editionToSku,
        offeringSkus: args.offeringSkus,
        defaults: {
            edition: defaultEdition,
            unitCount: args.defaultUnitCount,
            billingCycle: args.defaultBillingCycle
        }
    };
}

});

parcelRegister("iqmYR", function(module, exports) {
$parcel$export(module.exports, "resolveBillingCycle", function () { return $ce0500e05adc655d$export$6056e10fba8c9048; });

var $cGx7y = parcelRequire("cGx7y");
const $ce0500e05adc655d$export$6056e10fba8c9048 = (productKey, edition)=>{
    if (edition === 'enterprise') return 'ANNUAL';
    return (0, $cGx7y.getProductPricingConfig)(productKey).billingCycleConfig.monthly ? 'MONTHLY' : 'ANNUAL';
};

});

parcelRegister("9lJTH", function(module, exports) {
$parcel$export(module.exports, "useUbpContext", function () { return $bc97b53d595d3da5$export$dc0276ea3fe966fa; });
$parcel$export(module.exports, "buildDefaultProduct", function () { return $bc97b53d595d3da5$export$32ada19ac063b3af; });
$parcel$export(module.exports, "UbpContextProvider", function () { return $bc97b53d595d3da5$export$17c668f0eddf3669; });
/**
 * The single merged UBP-Q4 context. Holds the wizard flow state (from the
 * flow source) together with the unified product selection + per-product
 * inputs and the CCP pricing data / derived calculation (from the calc
 * source). A product is "selected" iff it is present in `products`.
 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $dkcYJ = parcelRequire("dkcYJ");

var $61WdP = parcelRequire("61WdP");

var $bd927 = parcelRequire("bd927");

var $cGx7y = parcelRequire("cGx7y");

var $iqmYR = parcelRequire("iqmYR");
const $bc97b53d595d3da5$var$UbpContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $bc97b53d595d3da5$export$dc0276ea3fe966fa = ()=>{
    const ctx = (0, $1oC0p.useContext)($bc97b53d595d3da5$var$UbpContext);
    if (!ctx) throw new Error('useUbpContext must be used within a UbpContextProvider');
    return ctx;
};
const $bc97b53d595d3da5$export$32ada19ac063b3af = (productKey)=>{
    const def = (0, $cGx7y.getProductPricingConfig)(productKey);
    return {
        productKey: productKey,
        inputs: {
            edition: def.defaults.edition,
            unitCount: def.defaults.unitCount,
            billingCycle: (0, $iqmYR.resolveBillingCycle)(productKey, def.defaults.edition)
        }
    };
};
const $bc97b53d595d3da5$var$DEFAULT_STEP = 'usage';
const $bc97b53d595d3da5$var$DEFAULT_METER = 'rovoCredits';
const $bc97b53d595d3da5$var$DEFAULT_USAGE_TYPE = 'adopting';
const $bc97b53d595d3da5$var$DEFAULT_USAGE = 0;
const $bc97b53d595d3da5$export$17c668f0eddf3669 = (props)=>{
    const { children: children, initialValues: { step: initialStep = $bc97b53d595d3da5$var$DEFAULT_STEP, meter: initialMeter = $bc97b53d595d3da5$var$DEFAULT_METER, usageType: initialUsageType = $bc97b53d595d3da5$var$DEFAULT_USAGE_TYPE, usage: initialUsage = $bc97b53d595d3da5$var$DEFAULT_USAGE, orgUserCount: initialOrgUserCount, products: initialProducts = [] } = {}, currencyISOCode: currencyISOCode = 'USD', localeISOCode: localeISOCode = 'en-US' } = props;
    const [step, setStep] = (0, $1oC0p.useState)(initialStep);
    const [meter, setMeter] = (0, $1oC0p.useState)(initialMeter);
    const [usageType, setUsageType] = (0, $1oC0p.useState)(initialUsageType);
    const [usage, setUsage] = (0, $1oC0p.useState)(initialUsage);
    const [orgUserCount, setOrgUserCount] = (0, $1oC0p.useState)(initialOrgUserCount);
    const [orgUserCountError, setOrgUserCountError] = (0, $1oC0p.useState)(undefined);
    const [products, setProducts] = (0, $1oC0p.useState)(initialProducts);
    const [productTabSelectionWarningShown, setProductTabSelectionWarningShown] = (0, $1oC0p.useState)(false);
    // Fetch CCP data for the union of every registered product's SKUs once,
    // so selecting/deselecting products never triggers a re-fetch.
    const allSkus = (0, $1oC0p.useMemo)(()=>(0, $bd927.collectAllRegisteredSkus)((0, $cGx7y.productPricingConfigKeys).map((k)=>(0, $cGx7y.productPricingConfigs)[k])), []);
    const { fetchData: fetchData, status: ccpStatus, prices: prices } = (0, $dkcYJ.useCCPPriceFinderData)(allSkus, String((0, $61WdP.PRODUCT_CATALOG_DELIVERY_KEY)), String((0, $61WdP.PRODUCT_CATALOG_SPACE)));
    (0, $1oC0p.useEffect)(()=>{
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const ccpPricingData = prices ?? {};
    const calculation = (0, $1oC0p.useMemo)(()=>(0, $bd927.calculateMonthlyPerUnitPrices)({
            products: products,
            ccpPricingData: ccpPricingData,
            currencyISOCode: currencyISOCode,
            localeISOCode: localeISOCode
        }), [
        products,
        ccpPricingData,
        currencyISOCode,
        localeISOCode
    ]);
    /**
   * Restart the calculator flow. Wipes every wizard state field back
   * to its default. Kept as a plain function (not memoized) — it's
   * called at most once per user gesture and never appears in a
   * hook dependency array, so referential stability doesn't matter.
   */ const resetAll = ()=>{
        setStep($bc97b53d595d3da5$var$DEFAULT_STEP);
        setMeter($bc97b53d595d3da5$var$DEFAULT_METER);
        setUsageType($bc97b53d595d3da5$var$DEFAULT_USAGE_TYPE);
        setUsage($bc97b53d595d3da5$var$DEFAULT_USAGE);
        setOrgUserCount(undefined);
        setOrgUserCountError(undefined);
        setProducts([]);
        setProductTabSelectionWarningShown(false);
    };
    const value = {
        step: step,
        meter: meter,
        usageType: usageType,
        usage: usage,
        orgUserCount: orgUserCount,
        products: products,
        setProducts: setProducts,
        productTabSelectionWarningShown: productTabSelectionWarningShown,
        setProductTabSelectionWarningShown: setProductTabSelectionWarningShown,
        ccpPricingData: ccpPricingData,
        ccpStatus: ccpStatus,
        currencyISOCode: currencyISOCode,
        localeISOCode: localeISOCode,
        calculation: calculation,
        setStep: setStep,
        setMeter: setMeter,
        setUsageType: setUsageType,
        setUsage: setUsage,
        setOrgUserCount: setOrgUserCount,
        orgUserCountError: orgUserCountError,
        setOrgUserCountError: setOrgUserCountError,
        resetAll: resetAll
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($bc97b53d595d3da5$var$UbpContext.Provider, {
        value: value,
        children: children
    });
};

});
parcelRegister("bd927", function(module, exports) {
$parcel$export(module.exports, "calculateMonthlyPerUnitPrices", function () { return $8d7d9aeed8eceb47$export$774ace40e08cc870; });
$parcel$export(module.exports, "collectAllRegisteredSkus", function () { return $8d7d9aeed8eceb47$export$61067bc3afde3a70; });

var $5CQu1 = parcelRequire("5CQu1");

var $8cfMz = parcelRequire("8cfMz");

var $cGx7y = parcelRequire("cGx7y");
const $8d7d9aeed8eceb47$var$MONTHS_PER_YEAR = 12;
function $8d7d9aeed8eceb47$export$774ace40e08cc870(args) {
    const { products: products, ccpPricingData: ccpPricingData, currencyISOCode: currencyISOCode, localeISOCode: localeISOCode } = args;
    const byProductKey = {};
    for (const product of products){
        const def = (0, $cGx7y.getProductPricingConfig)(product.productKey);
        const { edition: edition, unitCount: unitCount, billingCycle: billingCycle } = product.inputs;
        const selectedSku = def.editionToSku[edition];
        // Enterprise plans have a minimum unit count below which the calculator
        // returns no price. When the enterprise edition is selected with a count
        // under that floor, price at the minimum so we report the per-unit price
        // corresponding to the enterprise minimum unit count.
        const effectiveUnitCount = edition === 'enterprise' && unitCount < def.unitMinEnterprise ? def.unitMinEnterprise : unitCount;
        const calcInputs = (0, $8cfMz.getProductCalculationInputs)(def.planLimitConfigs, def.unitMinEnterprise, effectiveUnitCount, billingCycle);
        const avgPerUnitPrice = (0, $5CQu1.calculateProductPricing)(ccpPricingData, calcInputs, currencyISOCode, localeISOCode).find((r)=>r.offeringSku === selectedSku)?.avgPerUnitPrice;
        if (avgPerUnitPrice === undefined) continue;
        // The calculator's per-unit figure is annual for ANNUAL billing.
        byProductKey[product.productKey] = billingCycle === 'ANNUAL' ? avgPerUnitPrice / $8d7d9aeed8eceb47$var$MONTHS_PER_YEAR : avgPerUnitPrice;
    }
    return {
        byProductKey: byProductKey
    };
}
function $8d7d9aeed8eceb47$export$61067bc3afde3a70(pricingConfigs) {
    const set = new Set();
    for (const cfg of pricingConfigs)for (const sku of cfg.offeringSkus)set.add(sku);
    return [
        ...set
    ];
}

});


parcelRegister("hSUNh", function(module, exports) {
$parcel$export(module.exports, "selectStep", function () { return $9558c935db5ea40c$export$7938144936e8342b; });
$parcel$export(module.exports, "selectMeter", function () { return $9558c935db5ea40c$export$b73dc07af4ca8585; });
$parcel$export(module.exports, "selectUsageType", function () { return $9558c935db5ea40c$export$dbd8d08dc10418e1; });
$parcel$export(module.exports, "selectUsage", function () { return $9558c935db5ea40c$export$a2d8c0eb2185aa32; });
$parcel$export(module.exports, "selectOrgUserCount", function () { return $9558c935db5ea40c$export$e13a46e9e42e8a29; });
$parcel$export(module.exports, "selectOrgUserCountError", function () { return $9558c935db5ea40c$export$f92f8202ac00197a; });
$parcel$export(module.exports, "selectCanAdvanceUsageStep", function () { return $9558c935db5ea40c$export$6df6c3f509d1549d; });
$parcel$export(module.exports, "selectCanAdvanceAllowanceStep", function () { return $9558c935db5ea40c$export$b7b4f1e88739f7ba; });
$parcel$export(module.exports, "selectSelectedProducts", function () { return $9558c935db5ea40c$export$a3c41b69185a85ac; });
$parcel$export(module.exports, "selectStepIndex", function () { return $9558c935db5ea40c$export$c35690e08b926207; });
$parcel$export(module.exports, "selectIncludedAllowance", function () { return $9558c935db5ea40c$export$6fadf034e788ba2; });
$parcel$export(module.exports, "selectEstimatedUsageRange", function () { return $9558c935db5ea40c$export$aa6e21e0c5ae49c4; });
$parcel$export(module.exports, "selectTotalOverageCost", function () { return $9558c935db5ea40c$export$eefa3b8271d86fb8; });
$parcel$export(module.exports, "selectTotalOverageUnits", function () { return $9558c935db5ea40c$export$39fbb53d743aac4d; });
$parcel$export(module.exports, "selectHasOverage", function () { return $9558c935db5ea40c$export$a741283b93697940; });
$parcel$export(module.exports, "selectTotalMonthlyCost", function () { return $9558c935db5ea40c$export$fe3d3486101d97bc; });
$parcel$export(module.exports, "isCcpDataPending", function () { return $9558c935db5ea40c$export$4755891f136cec04; });
$parcel$export(module.exports, "getProductEdition", function () { return $9558c935db5ea40c$export$53e066a63a960439; });
$parcel$export(module.exports, "getProductUnitCount", function () { return $9558c935db5ea40c$export$34c177475ae85bf6; });
$parcel$export(module.exports, "getProductMaxUnitCount", function () { return $9558c935db5ea40c$export$8ff85968947470ac; });
$parcel$export(module.exports, "getProductPerUnitPerMonth", function () { return $9558c935db5ea40c$export$9fb2997fa3909ba7; });
$parcel$export(module.exports, "getCurrencyIsoCode", function () { return $9558c935db5ea40c$export$5052d5e5b6a90fdc; });
$parcel$export(module.exports, "getNumberFormatLocale", function () { return $9558c935db5ea40c$export$3d36f1c8af14c3fb; });
$parcel$export(module.exports, "selectIsProductSelected", function () { return $9558c935db5ea40c$export$de52de5f9450c9fe; });
$parcel$export(module.exports, "selectCategoryHasSelections", function () { return $9558c935db5ea40c$export$ee40fe8bb6549e45; });
$parcel$export(module.exports, "selectShareableQuery", function () { return $9558c935db5ea40c$export$45bf5c0a18de967d; });
/**
 * Pure selectors over the merged UBP-Q4 context. Three groups:
 *   A. wizard flow (ported from the flow source)
 *   B. per-product reads (ported from the calc source)
 *   C. selection selectors that bridge flow ↔ products
 *
 * Selectors return only data (keys, numbers, enums) — never display strings.
 * Labels and number/currency formatting live in components/strings.ts.
 * Composition is done by calling other selectors with the same `ctx`.
 */ 
var $i8jvR = parcelRequire("i8jvR");

var $a7Tw3 = parcelRequire("a7Tw3");

var $bYgvL = parcelRequire("bYgvL");

var $cGx7y = parcelRequire("cGx7y");

var $73KXs = parcelRequire("73KXs");

var $5eLaZ = parcelRequire("5eLaZ");
const $9558c935db5ea40c$export$7938144936e8342b = (ctx)=>ctx.step;
const $9558c935db5ea40c$export$b73dc07af4ca8585 = (ctx)=>ctx.meter;
const $9558c935db5ea40c$export$dbd8d08dc10418e1 = (ctx)=>ctx.usageType;
const $9558c935db5ea40c$export$a2d8c0eb2185aa32 = (ctx)=>ctx.usage;
const $9558c935db5ea40c$export$e13a46e9e42e8a29 = (ctx)=>ctx.orgUserCount;
const $9558c935db5ea40c$export$f92f8202ac00197a = (ctx)=>ctx.orgUserCountError;
const $9558c935db5ea40c$export$6df6c3f509d1549d = (ctx)=>(0, $5eLaZ.validateOrgUserCount)($9558c935db5ea40c$export$e13a46e9e42e8a29(ctx)) === undefined;
const $9558c935db5ea40c$export$b7b4f1e88739f7ba = (ctx)=>$9558c935db5ea40c$export$a3c41b69185a85ac(ctx).length > 0;
const $9558c935db5ea40c$export$c35690e08b926207 = (ctx)=>(0, $73KXs.STEP_ORDER).indexOf($9558c935db5ea40c$export$7938144936e8342b(ctx));
const $9558c935db5ea40c$export$6fadf034e788ba2 = (ctx)=>(0, $i8jvR.calculateIncludedAllowance)({
        products: ctx.products,
        meter: ctx.meter
    });
const $9558c935db5ea40c$export$aa6e21e0c5ae49c4 = (ctx)=>(0, $a7Tw3.estimateUsageRange)({
        meter: $9558c935db5ea40c$export$b73dc07af4ca8585(ctx),
        usageType: $9558c935db5ea40c$export$dbd8d08dc10418e1(ctx),
        orgUserCount: $9558c935db5ea40c$export$e13a46e9e42e8a29(ctx),
        usage: $9558c935db5ea40c$export$a2d8c0eb2185aa32(ctx)
    });
const $9558c935db5ea40c$var$selectOverageCost = (ctx)=>(0, $bYgvL.calculateOverageCost)({
        meter: $9558c935db5ea40c$export$b73dc07af4ca8585(ctx),
        estimatedUsage: $9558c935db5ea40c$export$aa6e21e0c5ae49c4(ctx),
        includedAllowance: $9558c935db5ea40c$export$6fadf034e788ba2(ctx)
    });
const $9558c935db5ea40c$export$eefa3b8271d86fb8 = (ctx)=>$9558c935db5ea40c$var$selectOverageCost(ctx).cost;
const $9558c935db5ea40c$export$39fbb53d743aac4d = (ctx)=>$9558c935db5ea40c$var$selectOverageCost(ctx).overageUnits;
const $9558c935db5ea40c$export$a741283b93697940 = (ctx)=>$9558c935db5ea40c$var$selectOverageCost(ctx).overageUnits.high > 0;
const $9558c935db5ea40c$export$fe3d3486101d97bc = (ctx)=>{
    if ($9558c935db5ea40c$export$4755891f136cec04(ctx)) return undefined;
    let total = 0;
    for (const p of ctx.products){
        const perUnit = ctx.calculation.byProductKey[p.productKey];
        if (perUnit === undefined) // Missing pricing data for at least one product → can't produce
        // an accurate aggregate.
        return undefined;
        total += perUnit * p.inputs.unitCount;
    }
    return total;
};
const $9558c935db5ea40c$export$ce9cf0f15e42cff9 = (ctx, productKey)=>{
    const product = ctx.products.find((p)=>p.productKey === productKey);
    if (!product) throw new Error(`No product found for productKey="${productKey}"`);
    return product;
};
const $9558c935db5ea40c$export$53e066a63a960439 = (ctx, productKey)=>$9558c935db5ea40c$export$ce9cf0f15e42cff9(ctx, productKey).inputs.edition;
const $9558c935db5ea40c$export$34c177475ae85bf6 = (ctx, productKey)=>$9558c935db5ea40c$export$ce9cf0f15e42cff9(ctx, productKey).inputs.unitCount;
const $9558c935db5ea40c$export$8ff85968947470ac = (ctx, productKey)=>(0, $cGx7y.getConfigMaxUnitCount)((0, $cGx7y.getProductPricingConfig)(productKey), $9558c935db5ea40c$export$53e066a63a960439(ctx, productKey));
const $9558c935db5ea40c$export$21639746dd26fa06 = (ctx, productKey)=>$9558c935db5ea40c$export$ce9cf0f15e42cff9(ctx, productKey).inputs.billingCycle;
const $9558c935db5ea40c$export$9fb2997fa3909ba7 = (ctx, productKey)=>ctx.calculation.byProductKey[productKey];
const $9558c935db5ea40c$export$4755891f136cec04 = (ctx)=>ctx.ccpStatus === 'idle' || ctx.ccpStatus === 'fetching';
const $9558c935db5ea40c$export$5052d5e5b6a90fdc = (ctx)=>ctx.currencyISOCode;
const $9558c935db5ea40c$export$3d36f1c8af14c3fb = (ctx)=>ctx.localeISOCode;
const $9558c935db5ea40c$export$a3c41b69185a85ac = (ctx)=>ctx.products;
const $9558c935db5ea40c$export$de52de5f9450c9fe = (key)=>(ctx)=>ctx.products.some((p)=>p.productKey === key);
const $9558c935db5ea40c$export$c367dfb5ad56f8d1 = (ctx)=>ctx.productTabSelectionWarningShown;
const $9558c935db5ea40c$export$ee40fe8bb6549e45 = (category)=>(ctx)=>ctx.products.some((p)=>(0, $cGx7y.getProductPricingConfig)(p.productKey).category === category);
const $9558c935db5ea40c$export$33954d9a4543aed8 = (ctx)=>{
    const first = ctx.products[0];
    return first ? (0, $cGx7y.getProductPricingConfig)(first.productKey).category : null;
};
const $9558c935db5ea40c$export$d68a0d389d453331 = (ctx)=>$9558c935db5ea40c$export$33954d9a4543aed8(ctx) ?? 'app';
const $9558c935db5ea40c$export$45bf5c0a18de967d = (ctx)=>{
    const products = $9558c935db5ea40c$export$a3c41b69185a85ac(ctx);
    const query = {
        step: $9558c935db5ea40c$export$7938144936e8342b(ctx),
        meter: $9558c935db5ea40c$export$b73dc07af4ca8585(ctx),
        usageType: $9558c935db5ea40c$export$dbd8d08dc10418e1(ctx),
        usage: $9558c935db5ea40c$export$a2d8c0eb2185aa32(ctx),
        orgUserCount: $9558c935db5ea40c$export$e13a46e9e42e8a29(ctx),
        products: products.map((p)=>p.productKey)
    };
    for (const p of products)query[`product.${p.productKey}`] = {
        unitCount: p.inputs.unitCount,
        edition: p.inputs.edition,
        billingCycle: p.inputs.billingCycle
    };
    return query;
};

});
parcelRegister("i8jvR", function(module, exports) {
$parcel$export(module.exports, "calculateIncludedAllowance", function () { return $5e50a12920d99a42$export$5adb36b887bdb2cc; });

var $gEJcR = parcelRequire("gEJcR");
// (product, edition) -> entitlement data file SKU. Only combinations that have a
// data file are listed; anything omitted resolves to 0.
const $5e50a12920d99a42$var$DATA_SKU = {
    jira: {
        free: 'jira-software-free',
        standard: 'jira-software-standard',
        premium: 'jira-software-premium',
        enterprise: 'jira-software-enterprise-sku'
    },
    confluence: {
        free: 'confluence-free',
        standard: 'confluence-standard',
        premium: 'confluence-premium',
        enterprise: 'confluence-enterprise-sku'
    },
    jsm: {
        free: 'jira-servicedesk-free',
        standard: 'jira-servicedesk-standard',
        premium: 'jira-servicedesk-premium',
        enterprise: 'jira-servicedesk-enterprise-sku'
    },
    jpd: {
        free: 'jira-servicedesk-free',
        standard: 'jira-product-discovery-standard',
        premium: 'jira-product-discovery-premium-sku',
        enterprise: 'jira-product-discovery-enterprise'
    },
    teamworkCollection: {
        free: 'teamwork-collection-free-sku',
        standard: 'teamwork-collection-standard-sku',
        premium: 'teamwork-collection-premium-sku',
        enterprise: 'teamwork-collection-enterprise-sku'
    },
    serviceCollection: {
        free: 'service-collection-free',
        standard: 'service-collection-standard',
        premium: 'service-collection-premium',
        enterprise: 'service-collection-enterprise'
    }
};
// Meter -> entitlement usageKey.
const $5e50a12920d99a42$var$METER_USAGE_KEY = {
    rovoCredits: 'ai-credit',
    automations: 'automation-credits',
    csResolutions: 'cs-resolution',
    // no entitlement data yet
    assetsObjects: 'assets-objects'
};
// Meters whose entitlement amount is granted per site rather than per user, so
// the allowance must not be multiplied by the product's unit count.
const $5e50a12920d99a42$var$PER_SITE_METERS = new Set([
    'assetsObjects'
]);
function $5e50a12920d99a42$export$5adb36b887bdb2cc(args) {
    const { products: products, meter: meter } = args;
    const isPerSite = $5e50a12920d99a42$var$PER_SITE_METERS.has(meter);
    let sum = 0;
    for (const product of products){
        const sku = $5e50a12920d99a42$var$DATA_SKU[product.productKey][product.inputs.edition];
        if (!sku) continue;
        const allowance = (0, $gEJcR.getAllowance)({
            sku: sku,
            meter: $5e50a12920d99a42$var$METER_USAGE_KEY[meter],
            billingCycle: product.inputs.billingCycle
        });
        if (!allowance) continue;
        sum += isPerSite ? allowance : allowance * product.inputs.unitCount;
    }
    return Math.round(sum);
}

});
parcelRegister("gEJcR", function(module, exports) {
$parcel$export(module.exports, "getAllowance", function () { return $466032012911a17a$export$64c885348b2f1759; });

var $hLkPQ = parcelRequire("hLkPQ");

var $6gNGp = parcelRequire("6gNGp");

var $9k7dI = parcelRequire("9k7dI");

var $lM1xu = parcelRequire("lM1xu");

var $4CZG9 = parcelRequire("4CZG9");

var $2JqOL = parcelRequire("2JqOL");

var $cWskG = parcelRequire("cWskG");

var $7MGiZ = parcelRequire("7MGiZ");

var $dThEb = parcelRequire("dThEb");

var $8Er1n = parcelRequire("8Er1n");

var $6op9h = parcelRequire("6op9h");

var $2FsPv = parcelRequire("2FsPv");

var $4j3E0 = parcelRequire("4j3E0");

var $9HRSO = parcelRequire("9HRSO");

var $c9mas = parcelRequire("c9mas");

var $cI23f = parcelRequire("cI23f");

var $cmjxe = parcelRequire("cmjxe");

var $P3qC6 = parcelRequire("P3qC6");

var $2iPSi = parcelRequire("2iPSi");

var $4smqI = parcelRequire("4smqI");

var $e5ZMN = parcelRequire("e5ZMN");

var $4Y3Fa = parcelRequire("4Y3Fa");

var $d6TPP = parcelRequire("d6TPP");
const $466032012911a17a$export$64c885348b2f1759 = ({ sku: sku, meter: meter, billingCycle: billingCycle })=>$466032012911a17a$var$allowanceIndex[sku]?.[meter]?.[billingCycle];
// Keyed by SKU (`<product>-<edition>`), which is how the entitlement files are named.
const $466032012911a17a$var$templatesBySku = {
    'confluence-enterprise-sku': (0, (/*@__PURE__*/$parcel$interopDefault($hLkPQ))),
    'confluence-free': (0, (/*@__PURE__*/$parcel$interopDefault($6gNGp))),
    'confluence-premium': (0, (/*@__PURE__*/$parcel$interopDefault($9k7dI))),
    'confluence-standard': (0, (/*@__PURE__*/$parcel$interopDefault($lM1xu))),
    'jira-product-discovery-enterprise': (0, (/*@__PURE__*/$parcel$interopDefault($4CZG9))),
    'jira-product-discovery-premium-sku': (0, (/*@__PURE__*/$parcel$interopDefault($2JqOL))),
    'jira-product-discovery-standard': (0, (/*@__PURE__*/$parcel$interopDefault($cWskG))),
    'jira-servicedesk-enterprise-sku': (0, (/*@__PURE__*/$parcel$interopDefault($7MGiZ))),
    'jira-servicedesk-free': (0, (/*@__PURE__*/$parcel$interopDefault($dThEb))),
    'jira-servicedesk-premium': (0, (/*@__PURE__*/$parcel$interopDefault($8Er1n))),
    'jira-servicedesk-standard': (0, (/*@__PURE__*/$parcel$interopDefault($6op9h))),
    'jira-software-enterprise-sku': (0, (/*@__PURE__*/$parcel$interopDefault($2FsPv))),
    'jira-software-free': (0, (/*@__PURE__*/$parcel$interopDefault($4j3E0))),
    'jira-software-premium': (0, (/*@__PURE__*/$parcel$interopDefault($9HRSO))),
    'jira-software-standard': (0, (/*@__PURE__*/$parcel$interopDefault($c9mas))),
    'service-collection-enterprise': (0, (/*@__PURE__*/$parcel$interopDefault($cI23f))),
    'service-collection-free': (0, (/*@__PURE__*/$parcel$interopDefault($cmjxe))),
    'service-collection-premium': (0, (/*@__PURE__*/$parcel$interopDefault($P3qC6))),
    'service-collection-standard': (0, (/*@__PURE__*/$parcel$interopDefault($2iPSi))),
    'teamwork-collection-enterprise-sku': (0, (/*@__PURE__*/$parcel$interopDefault($4smqI))),
    'teamwork-collection-free-sku': (0, (/*@__PURE__*/$parcel$interopDefault($e5ZMN))),
    'teamwork-collection-premium-sku': (0, (/*@__PURE__*/$parcel$interopDefault($4Y3Fa))),
    'teamwork-collection-standard-sku': (0, (/*@__PURE__*/$parcel$interopDefault($d6TPP)))
};
// sku -> meter (usageKey) -> billing cycle -> allowance amount.
const $466032012911a17a$var$buildIndex = ()=>{
    const index = {};
    for (const [sku, template] of Object.entries($466032012911a17a$var$templatesBySku)){
        const meterIndex = {};
        for (const feature of template.features)for (const allowance of feature.value?.allowances ?? []){
            const { usageKey: usageKey, cycles: cycles } = allowance.config;
            const cycleIndex = meterIndex[usageKey] ??= {};
            for (const cycle of cycles)cycleIndex[cycle.cycle] = cycle.amount;
        }
        index[sku] = meterIndex;
    }
    return index;
};
const $466032012911a17a$var$allowanceIndex = $466032012911a17a$var$buildIndex();

});
parcelRegister("hLkPQ", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Confluence Enterprise Template\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("6gNGp", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Confluence (Cloud) Free\",\"features\":[]}");

});

parcelRegister("9k7dI", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Confluence (Cloud) Premium\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":70,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":70,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("lM1xu", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Confluence (Cloud) Standard\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":25,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":25,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("4CZG9", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement template for product a6f908c8-709c-45f4-9e2d-eca25b93b94a\",\"features\":[]}");

});

parcelRegister("2JqOL", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement template for product a6f908c8-709c-45f4-9e2d-eca25b93b94a\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("cWskG", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Jira Product Discovery Standard\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":300,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":300,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("7MGiZ", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Jira Service Management Enterprise Template\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":500000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":500000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":7500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":7500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("dThEb", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Jira Service Management (Cloud) Free\",\"features\":[]}");

});

parcelRegister("8Er1n", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Templates for Jira Service Management Premium\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":70,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":70,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":50000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":50000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":5000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":5000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("6op9h", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Templates for Jira Service Management Standard\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":25,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":25,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":5000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":5000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":2500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":2500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("2FsPv", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Jira Enterprise Template\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":1000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":1000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":1000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":1000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("4j3E0", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Jira Software (Cloud) Free\",\"features\":[]}");

});

parcelRegister("9HRSO", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Jira Software (Cloud) Premium\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":70,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":70,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":1000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":1000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":750,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":750,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("c9mas", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Jira Software (Cloud) Standard\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":25,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":25,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":1000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":1000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":400,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":400,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("cI23f", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Service Collection Entitlement template\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":500000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":500000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":7500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":7500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("cmjxe", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement template for product 9af73c36-bb77-41f8-9b11-2d20e9f74c44\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":1250},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":1250}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("P3qC6", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement template for product 9af73c36-bb77-41f8-9b11-2d20e9f74c44\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":700,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":700,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":50000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":50000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":6500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":6500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("2iPSi", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement template for product 9af73c36-bb77-41f8-9b11-2d20e9f74c44\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":5000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":5000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":3000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":3000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("4smqI", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Added admin insights for TWC - Enterprise\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":6250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":6250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":1500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":1500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":5000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":5000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":7500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":7500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("e5ZMN", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Support Level added\",\"features\":[]}");

});

parcelRegister("4Y3Fa", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Added admin insights for TWC - Premium\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":2500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":2500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":700,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":700,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":5000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":5000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":5000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":5000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("d6TPP", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Added admin insights for TWC - Standard\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":1000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":1000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":5000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":5000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":2500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":2500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});



parcelRegister("a7Tw3", function(module, exports) {
$parcel$export(module.exports, "estimateUsageRange", function () { return $e97f9afe9945d51f$export$66d117afbda1dd4f; });
/**
 * GWP-12277: Estimated organization usage-range calculation.
 *
 * Each usage profile carries its own low/high band (wide and asymmetric,
 * straight from the per-meter Confluence content specs). How the band maps to
 * the org total differs by meter:
 *
 *   perOrgUser: true  → low/high are per-org-user/month, multiplied by user count
 *     low  = orgUserCount × band.low
 *     high = orgUserCount × band.high
 *
 *   perOrgUser: false → low/high are absolute monthly totals, used as-is
 *     low  = band.low
 *     high = band.high
 *
 * The result is the low/high pair rendered in the "Your organization needs"
 * ResultsCard on Steps 3 and 5.
 *
 * All values below are from the content specs. Card 1/2/3 in each spec map
 * positionally to exploring/adopting/scaling.
 */ const $e97f9afe9945d51f$var$USAGE_MODEL = {
    // Rovo credits: per-user/month × org (Early exploration / Routine adoption / Transformative).
    rovoCredits: {
        perOrgUser: true,
        bands: {
            exploring: {
                low: 100,
                high: 500
            },
            adopting: {
                low: 500,
                high: 2000
            },
            scaling: {
                low: 2000,
                high: 4000
            }
        }
    },
    // Automation steps: per-seat/month × org (Experimenting / Adopting / Scaling).
    automations: {
        perOrgUser: true,
        bands: {
            exploring: {
                low: 30,
                high: 200
            },
            adopting: {
                low: 200,
                high: 850
            },
            scaling: {
                low: 850,
                high: 3200
            }
        }
    },
    // AI agent resolutions: absolute monthly total, NOT multiplied by org count
    // (Basic / Moderate / Comprehensive).
    csResolutions: {
        perOrgUser: false,
        bands: {
            exploring: {
                low: 2000,
                high: 4000
            },
            adopting: {
                low: 4000,
                high: 6000
            },
            scaling: {
                low: 6000,
                high: 80000
            }
        }
    },
    // Assets objects: per-user × org (Emerging / Adopting / Scaling).
    assetsObjects: {
        perOrgUser: true,
        bands: {
            exploring: {
                low: 0,
                high: 3
            },
            adopting: {
                low: 4,
                high: 10
            },
            scaling: {
                low: 11,
                high: 50
            }
        }
    }
};
function $e97f9afe9945d51f$export$66d117afbda1dd4f(args) {
    const { meter: meter, usageType: usageType, orgUserCount: orgUserCount, usage: usage } = args;
    // A custom usage value overrides the usageType estimate entirely. It's an
    // absolute org-monthly total, so both bounds collapse to it regardless of
    // meter mode / org size.
    if (usage && usage > 0) return {
        low: usage,
        high: usage
    };
    const model = $e97f9afe9945d51f$var$USAGE_MODEL[meter];
    const band = model.bands[usageType];
    // Absolute meters don't depend on org size — return the band as-is.
    if (!model.perOrgUser) return {
        low: band.low,
        high: band.high
    };
    // Per-user meters need an org size. If none yet, return a zero range and
    // let the UI decide whether to render or hide.
    if (!orgUserCount || orgUserCount <= 0) return {
        low: 0,
        high: 0
    };
    return {
        low: orgUserCount * band.low,
        high: orgUserCount * band.high
    };
}

});

parcelRegister("bYgvL", function(module, exports) {
$parcel$export(module.exports, "getOverageRateTiers", function () { return $23a877fa45be7a1d$export$18ffa497f7984108; });
$parcel$export(module.exports, "calculateOverageCost", function () { return $23a877fa45be7a1d$export$3967df266f30328a; });
/**
 * Overage cost: what an org pays for usage beyond its included allowance.
 *
 * overage units = max(0, estimatedUsage − includedAllowance)
 * cost          = overage units priced through the meter's rate tiers
 *
 * Callers pass the estimated usage RANGE (see `selectTotalOverageCost`) so the
 * result brackets the monthly spend with a low/high bound derived from the low/
 * high usage estimate.
 */ /**
 * Per-meter overage rates:
 *   Rovo credits  — $0.01/credit ($10 per 1,000)
 *   CS resolutions — $1.00/resolution
 *   Automations   — $0.50 per 1,000 steps ($0.0005/step)
 *   Assets objects — $0.02/object for the first 100K over allowance,
 *                    $0.01/object beyond 100K
 */ const $23a877fa45be7a1d$var$RATE_TIERS = {
    rovoCredits: [
        {
            upTo: Infinity,
            pricePerUnit: 0.01
        }
    ],
    csResolutions: [
        {
            upTo: Infinity,
            pricePerUnit: 1.0
        }
    ],
    automations: [
        {
            upTo: Infinity,
            pricePerUnit: 0.0005
        }
    ],
    assetsObjects: [
        {
            upTo: 100000,
            pricePerUnit: 0.02
        },
        {
            upTo: Infinity,
            pricePerUnit: 0.01
        }
    ]
};
/**
 * How many raw units each meter's overage price is quoted against.
 * Automations are quoted "per 1,000 steps", so their block size is 1,000;
 * the rest are priced per single unit. Purely numeric — the customer-facing
 * unit noun ("steps", "resolution", …) lives in the content layer.
 */ const $23a877fa45be7a1d$var$RATE_QUOTE_QUANTITY = {
    rovoCredits: 1,
    csResolutions: 1,
    automations: 1000,
    assetsObjects: 1
};
function $23a877fa45be7a1d$export$18ffa497f7984108(meter) {
    const quantity = $23a877fa45be7a1d$var$RATE_QUOTE_QUANTITY[meter];
    return $23a877fa45be7a1d$var$RATE_TIERS[meter].map((tier)=>({
            price: tier.pricePerUnit * quantity
        }));
}
/** Price a single usage figure against the meter's rate tiers. */ function $23a877fa45be7a1d$var$priceUsage(meter, estimatedUsage, includedAllowance) {
    const overageUnits = Math.max(0, estimatedUsage - includedAllowance);
    if (overageUnits === 0) return {
        overageUnits: 0,
        cost: 0
    };
    let cost = 0;
    let lowerBound = 0;
    for (const tier of $23a877fa45be7a1d$var$RATE_TIERS[meter]){
        const unitsInTier = Math.min(overageUnits, tier.upTo) - lowerBound;
        if (unitsInTier <= 0) break;
        cost += unitsInTier * tier.pricePerUnit;
        lowerBound = tier.upTo;
    }
    return {
        overageUnits: overageUnits,
        cost: cost
    };
}
function $23a877fa45be7a1d$export$3967df266f30328a(args) {
    const { meter: meter, estimatedUsage: estimatedUsage, includedAllowance: includedAllowance } = args;
    const low = $23a877fa45be7a1d$var$priceUsage(meter, estimatedUsage.low, includedAllowance);
    const high = $23a877fa45be7a1d$var$priceUsage(meter, estimatedUsage.high, includedAllowance);
    return {
        overageUnits: {
            low: low.overageUnits,
            high: high.overageUnits
        },
        cost: {
            low: low.cost,
            high: high.cost
        }
    };
}

});

parcelRegister("5eLaZ", function(module, exports) {
$parcel$export(module.exports, "ORG_USER_COUNT_MIN", function () { return $d3e9646a51defefd$export$53fb25c04d16e0db; });
$parcel$export(module.exports, "ORG_USER_COUNT_MAX", function () { return $d3e9646a51defefd$export$54043737c64deb74; });
$parcel$export(module.exports, "orgUserCountErrorMessages", function () { return $d3e9646a51defefd$export$2b0c565c56827d4d; });
$parcel$export(module.exports, "validateOrgUserCount", function () { return $d3e9646a51defefd$export$1dcb369df61720d4; });

var $fnHPc = parcelRequire("fnHPc");
var $d3e9646a51defefd$export$dac295adacb8b569 = /*#__PURE__*/ function(OrgUserCountError) {
    OrgUserCountError["Required"] = "required";
    OrgUserCountError["NotANumber"] = "notANumber";
    OrgUserCountError["NotInteger"] = "notInteger";
    OrgUserCountError["TooSmall"] = "tooSmall";
    OrgUserCountError["TooLarge"] = "tooLarge";
    return OrgUserCountError;
}({});
const $d3e9646a51defefd$export$53fb25c04d16e0db = 1;
const $d3e9646a51defefd$export$54043737c64deb74 = 1000000;
const $d3e9646a51defefd$export$2b0c565c56827d4d = (0, $fnHPc.defineMessages)({
    required: {
        id: 'ubpQ4.usage.orgUserCount.error.required',
        defaultMessage: 'Enter a number for this field.'
    },
    notANumber: {
        id: 'ubpQ4.usage.orgUserCount.error.notANumber',
        defaultMessage: 'Field must be a number.'
    },
    notInteger: {
        id: 'ubpQ4.usage.orgUserCount.error.notInteger',
        defaultMessage: 'Field must be a whole number.'
    },
    tooSmall: {
        id: 'ubpQ4.usage.orgUserCount.error.tooSmall',
        defaultMessage: 'Field must be at least {min, number}.'
    },
    tooLarge: {
        id: 'ubpQ4.usage.orgUserCount.error.tooLarge',
        defaultMessage: 'Field must be at most {max, number}.'
    }
});
const $d3e9646a51defefd$export$1dcb369df61720d4 = (value)=>{
    if (value === undefined) return "required";
    if (Number.isNaN(value)) return "notANumber";
    if (!Number.isInteger(value)) return "notInteger";
    if (value < $d3e9646a51defefd$export$53fb25c04d16e0db) return "tooSmall";
    if (value > $d3e9646a51defefd$export$54043737c64deb74) return "tooLarge";
    return undefined;
};

});



parcelRegister("3h32c", function(module, exports) {
$parcel$export(module.exports, "useUbpStep1ScreenViewedEvent", function () { return $cd01cc0e4dd06b25$export$205af9b9098879bf; });
$parcel$export(module.exports, "useUbpStep2ScreenViewedEvent", function () { return $cd01cc0e4dd06b25$export$79fc22455bcb1f4d; });
$parcel$export(module.exports, "useUbpUsageProfileSelectedEvent", function () { return $cd01cc0e4dd06b25$export$3e1393d02d56daeb; });
$parcel$export(module.exports, "useUbpStep2GetEstimateClickedEvent", function () { return $cd01cc0e4dd06b25$export$a252fbbc8093ab12; });
$parcel$export(module.exports, "useUbpStep2BackClickedEvent", function () { return $cd01cc0e4dd06b25$export$ea983506223eaa17; });
$parcel$export(module.exports, "useUbpStep3ScreenViewedEvent", function () { return $cd01cc0e4dd06b25$export$4305100754c629bd; });
$parcel$export(module.exports, "useUbpStep3CompareNowClickedEvent", function () { return $cd01cc0e4dd06b25$export$e72d661dfc5e4c93; });
$parcel$export(module.exports, "useUbpStep3BackClickedEvent", function () { return $cd01cc0e4dd06b25$export$91bc43b52c81e104; });
$parcel$export(module.exports, "useUbpStep3ShareClickedEvent", function () { return $cd01cc0e4dd06b25$export$80230ad25cc4221a; });
$parcel$export(module.exports, "useUbpStep3FeedbackClickedEvent", function () { return $cd01cc0e4dd06b25$export$fa772252253dcf7e; });
$parcel$export(module.exports, "useUbpStep4ScreenViewedEvent", function () { return $cd01cc0e4dd06b25$export$8c9b05aee29b8680; });
$parcel$export(module.exports, "useUbpStep4TabClickedEvent", function () { return $cd01cc0e4dd06b25$export$bbbd401829b6d2cb; });
$parcel$export(module.exports, "useUbpStep4SelectButtonClickedEvent", function () { return $cd01cc0e4dd06b25$export$3c05de7a7ce548f1; });
$parcel$export(module.exports, "useUbpStep4DeselectButtonClickedEvent", function () { return $cd01cc0e4dd06b25$export$bee012181fd836e8; });
$parcel$export(module.exports, "useUbpStep4CompareClickedEvent", function () { return $cd01cc0e4dd06b25$export$672cdfb8d7d66a53; });
$parcel$export(module.exports, "useUbpStep4BackClickedEvent", function () { return $cd01cc0e4dd06b25$export$cf0cb21f5e1b5faf; });
$parcel$export(module.exports, "useUbpStep5ScreenViewedEvent", function () { return $cd01cc0e4dd06b25$export$1cf955d59c4b6105; });
$parcel$export(module.exports, "useUbpStep5BackClickedEvent", function () { return $cd01cc0e4dd06b25$export$153392181bdeabbd; });
$parcel$export(module.exports, "useUbpStep5ShareClickedEvent", function () { return $cd01cc0e4dd06b25$export$d09b822e0e9c5579; });
$parcel$export(module.exports, "useUbpStep5FeedbackClickedEvent", function () { return $cd01cc0e4dd06b25$export$a74e05db53f6b5f6; });
/**
 * Analytics hooks for the UBP Q4 calculator.
 *
 * All events are GASv3 `ui` type fired via `useAnalyticsEvents()`.
 * The analytics channel is "marketing" (consistent with other WAC surfaces).
 *
 * Naming convention:
 *   actionSubject  — the element the user interacted with
 *   action         — what happened ("viewed" | "clicked" | "selected")
 *
 * Attribute naming follows camelCase. Common attributes are collected via
 * `useUbpAnalyticsAttributes()` and spread into every event so callers only
 * need to add the event-specific extras.
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");
const $cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL = 'marketing';
const $cd01cc0e4dd06b25$export$51fa01273dc92289 = ()=>{
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const orgUserCount = (0, $4xsw0.useSelector)((0, $hSUNh.selectOrgUserCount));
    const usageType = (0, $4xsw0.useSelector)((0, $hSUNh.selectUsageType));
    const usage = (0, $4xsw0.useSelector)((0, $hSUNh.selectUsage));
    const { low: low, high: high } = (0, $4xsw0.useSelector)((0, $hSUNh.selectEstimatedUsageRange));
    const selectedProducts = (0, $4xsw0.useSelector)((0, $hSUNh.selectSelectedProducts));
    return {
        meterName: meter,
        orgCount: orgUserCount,
        usageProfileName: usageType,
        // Only include customUsageCount when the user entered a non-zero value.
        customUsageCount: usage > 0 ? usage : undefined,
        // Monthly cost estimate represented as a range string (e.g. "145,000–160,000").
        monthlyCostEstimate: `${low.toLocaleString('en-US')}\u{2013}${high.toLocaleString('en-US')}`,
        productNames: selectedProducts.map((p)=>p.productKey)
    };
};
const $cd01cc0e4dd06b25$export$205af9b9098879bf = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Viewed',
            actionSubject: 'Usage Based Pricing Calculator Step 1',
            eventType: 'screen',
            name: 'ubpCalculatorStep1Screen'
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
};
const $cd01cc0e4dd06b25$export$88505207c018f400 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)((meterName)=>{
        createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'radioButton',
            eventType: 'ui',
            attributes: {
                ...attrs,
                meterName: meterName
            }
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$73a3f040e4ae4c2b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Next Button',
            eventType: 'ui',
            attributes: attrs
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$79fc22455bcb1f4d = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'Usage Based Pricing Calculator Step 2',
            eventType: 'ui',
            attributes: {
                meterName: attrs.meterName,
                orgCount: attrs.orgCount
            }
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$3e1393d02d56daeb = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)((usageProfileName)=>{
        createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'radioButton',
            eventType: 'ui',
            attributes: {
                ...attrs,
                usageProfileName: usageProfileName
            }
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$a252fbbc8093ab12 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Get Estimate Button',
            eventType: 'ui',
            attributes: attrs
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$ea983506223eaa17 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Back Button',
            eventType: 'ui',
            attributes: attrs
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$4305100754c629bd = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Viewed',
            actionSubject: 'Usage Based Pricing Calculator Step 3',
            eventType: 'ui',
            attributes: attrs
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$e72d661dfc5e4c93 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Compare Now Button',
            eventType: 'ui',
            attributes: attrs
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$b048ab4a3bd422e8 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'Explore service collection link',
            eventType: 'ui',
            attributes: attrs
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$91bc43b52c81e104 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Back Button',
            eventType: 'ui',
            attributes: attrs
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$80230ad25cc4221a = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Share Button',
            eventType: 'ui',
            attributes: attrs
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$fa772252253dcf7e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)((vote)=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Feedback',
            eventType: 'ui',
            attributes: {
                ...attrs,
                feedbackVote: vote
            }
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$8c9b05aee29b8680 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Viewed',
            actionSubject: 'Usage Based Pricing Calculator Step 4',
            eventType: 'ui',
            attributes: {
                meterName: attrs.meterName,
                orgCount: attrs.orgCount,
                usageProfileName: attrs.usageProfileName,
                customUsageCount: attrs.customUsageCount,
                productNames: attrs.productNames
            }
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$bbbd401829b6d2cb = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)((productName)=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Tab',
            eventType: 'ui',
            attributes: {
                meterName: attrs.meterName,
                orgCount: attrs.orgCount,
                usageProfileName: attrs.usageProfileName,
                customUsageCount: attrs.customUsageCount,
                productName: productName
            }
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$3c05de7a7ce548f1 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    return (0, $1oC0p.useCallback)((productName)=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Select Button',
            eventType: 'ui',
            attributes: {
                productName: productName
            }
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
};
const $cd01cc0e4dd06b25$export$bee012181fd836e8 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    return (0, $1oC0p.useCallback)((productName)=>{
        createAnalyticsEvent({
            action: 'Unclicked',
            actionSubject: 'Select Button',
            eventType: 'ui',
            attributes: {
                productName: productName
            }
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
};
const $cd01cc0e4dd06b25$export$672cdfb8d7d66a53 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Compare Button',
            eventType: 'ui',
            attributes: {
                meterName: attrs.meterName,
                orgCount: attrs.orgCount,
                usageProfileName: attrs.usageProfileName,
                customUsageCount: attrs.customUsageCount
            }
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$cf0cb21f5e1b5faf = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Back Button',
            eventType: 'ui',
            attributes: {
                meterName: attrs.meterName,
                orgCount: attrs.orgCount,
                usageProfileName: attrs.usageProfileName,
                customUsageCount: attrs.customUsageCount
            }
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$1cf955d59c4b6105 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    const selectedProducts = (0, $4xsw0.useSelector)((0, $hSUNh.selectSelectedProducts));
    // "Usage price = yes or no" — whether any selected product has a
    // usage-based price component. We treat this as whether usage > 0.
    const usage = (0, $4xsw0.useSelector)((0, $hSUNh.selectUsage));
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Viewed',
            actionSubject: 'Usage Based Pricing Calculator Step 5',
            eventType: 'ui',
            attributes: {
                ...attrs,
                productNames: selectedProducts.map((p)=>p.productKey),
                hasUsagePrice: usage > 0 ? 'yes' : 'no'
            }
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs,
        selectedProducts,
        usage
    ]);
};
const $cd01cc0e4dd06b25$export$153392181bdeabbd = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Back Button',
            eventType: 'ui',
            attributes: {
                meterName: attrs.meterName,
                orgCount: attrs.orgCount,
                usageProfileName: attrs.usageProfileName,
                customUsageCount: attrs.customUsageCount
            }
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$d09b822e0e9c5579 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Share Button',
            eventType: 'ui',
            attributes: attrs
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};
const $cd01cc0e4dd06b25$export$a74e05db53f6b5f6 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const attrs = $cd01cc0e4dd06b25$export$51fa01273dc92289();
    return (0, $1oC0p.useCallback)((vote)=>{
        createAnalyticsEvent({
            action: 'Clicked',
            actionSubject: 'Feedback',
            eventType: 'ui',
            attributes: {
                ...attrs,
                feedbackVote: vote
            }
        }).fire($cd01cc0e4dd06b25$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        attrs
    ]);
};

});

parcelRegister("gbxL3", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $381f4a2f6cd227e0$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $381f4a2f6cd227e0$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    pageTitle: {
        id: 'ubp.calculator.allowance.pageTitle',
        defaultMessage: 'Explore how Atlassian collections and apps cover your usage needs'
    },
    tabCollections: {
        id: 'ubp.calculator.allowance.tabCollections',
        defaultMessage: 'Atlassian Collections'
    },
    tabApps: {
        id: 'ubp.calculator.allowance.tabApps',
        defaultMessage: 'Atlassian apps'
    }
});

});

parcelRegister("ahF4L", function(module, exports) {
$parcel$export(module.exports, "ChoiceCard", function () { return $cbc6c0883735dbaa$export$b0dc71a89abd972a; });
/* choice-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $bSVv5 = parcelRequire("bSVv5");

var $f3oWf = parcelRequire("f3oWf");

var $azcgw = parcelRequire("azcgw");

var $lJbez = parcelRequire("lJbez");
const $cbc6c0883735dbaa$export$b0dc71a89abd972a = ({ value: value, selected: selected, onSelect: onSelect, hide: hide = false, inputType: inputType = 'radio', label: label, description: description, usageInfo: usageInfo, list: list, info: info, iconUrl: iconUrl, lockupUrl: lockupUrl, groupName: groupName })=>{
    const handleClick = (event)=>{
        event.preventDefault();
        onSelect();
    };
    const heading = label;
    if (!hide) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _16jlkb7n _1o9zkb7n _i0dluuw1 _189et94y _1dqonqa1 _1h6d6u2e _2rko1ylz _bfhk1afi _syazrf0c _80omtlke _1e0c1txw _zulppxbi _2lx21bp4 _y3gn1e5h _4cvr1y6m _1bah1y6m _vchhusvi",
            selected && "_1h6d5hrz _1a371qgu"
        ]),
        style: {
            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300')),
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100')),
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1yt4197f"
                ]),
                children: inputType === 'checkbox' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $azcgw.CustomCheckbox), {
                    checked: selected,
                    onChange: onSelect
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJbez.CustomRadio), {
                    checked: selected,
                    name: groupName ?? `group-${value}`,
                    value: String(value),
                    onChange: onSelect
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1yt41310 _1e0c1txw _2lx21bp4 _4cvr1y6m _zulpv47k"
                ]),
                children: [
                    heading && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_kmft11p5 _1hxk1h6o _wsm11r0c _mncspxbi",
                            `icon_${iconUrl ? 'true' : 'false'}`
                        ]),
                        children: [
                            iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                src: iconUrl,
                                alt: "",
                                className: (0, $2jatx.default)([
                                    "_1e0c1ule _1bsbckbl _4t3ickbl _5ral1f51"
                                ])
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                className: (0, $2jatx.default)([
                                    "_ect41vau _vwz4kb7n _19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48pni7l"
                                ]),
                                style: {
                                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_1wyb1k8s _vwz4kb7n _so7dimiu"
                                    ]),
                                    children: heading
                                })
                            })
                        ]
                    }),
                    lockupUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: lockupUrl,
                        alt: "",
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _4t3ickbl _1bsb1wug _5ral1f51"
                        ])
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ect4z4z1 _1wyb1af2 _18s861nu"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: description
                    }),
                    usageInfo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_k48p1fw0 _ect4z4z1 _1wyb1af2 _18s861nu"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: usageInfo
                    }),
                    list && list.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1yt41qut _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        children: list.map((listItem, index)=>{
                            const IconMapped = listItem.icon ? (0, $f3oWf.iconMapping)[listItem.icon]?.component : undefined;
                            const hasIcon = Boolean(IconMapped);
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                className: (0, $2jatx.default)([
                                    "_ect4z4z1 _1wyb1af2 _18s8vjyi _kqswh2mm",
                                    hasIcon && "_2mzuglyw"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: [
                                    hasIcon && IconMapped && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_syazu5k9 _kqswstnw _1e02c7mi _1ul966rk"
                                        ]),
                                        style: {
                                            "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700'))
                                        },
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)(IconMapped, {
                                            size: "small"
                                        })
                                    }),
                                    listItem.text
                                ]
                            }, `${value}-list-${index}`);
                        })
                    })
                ]
            }),
            info && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfh1wug _1bsb1osq _bfhk1bjw _2rko8sxs _1yt4utpp _ect4z4z1 _1wyb1af2 _y3gn1h6o"
                ]),
                style: {
                    "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                },
                children: info
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handleClick,
                role: inputType,
                "aria-checked": selected,
                "aria-label": typeof heading === 'string' ? heading : value,
                className: (0, $2jatx.default)([
                    "_r06hglyw _19itidpf _2rko1kw7 _11q7glyw _kqswstnw _1r041n1a _80omtlke _1ygb1hln _1ah3j39m"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                }
            })
        ]
    });
    return null;
};
/* eslint-enable complexity */ const $cbc6c0883735dbaa$var$cardStyle = null;
const $cbc6c0883735dbaa$var$cardSelectedStyle = null;
const $cbc6c0883735dbaa$var$selectorOverlayStyle = null;
const $cbc6c0883735dbaa$var$radioOrCheckContainer = null;
const $cbc6c0883735dbaa$var$textContainer = null;
const $cbc6c0883735dbaa$var$headingContainer = null;
const $cbc6c0883735dbaa$var$cardHeading = null;
const $cbc6c0883735dbaa$var$cardHeadingSpan = null;
const $cbc6c0883735dbaa$var$cardDescription = null;
const $cbc6c0883735dbaa$var$usageInfoStyle = null;
const $cbc6c0883735dbaa$var$listContainer = null;
const $cbc6c0883735dbaa$var$listElement = null;
const $cbc6c0883735dbaa$var$listElementWithIcon = null;
const $cbc6c0883735dbaa$var$iconImageStyle = null;
const $cbc6c0883735dbaa$var$lockupImageStyle = null;
const $cbc6c0883735dbaa$var$iconStyle = null;
const $cbc6c0883735dbaa$var$infoBoxStyle = null;

});
parcelRegister("azcgw", function(module, exports) {
$parcel$export(module.exports, "CustomCheckbox", function () { return $1ac1029914e0cd63$export$1cd78ad38541e100; });
/* custom-checkbox.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $1ac1029914e0cd63$export$1cd78ad38541e100 = ({ checked: checked, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _80omtlke _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                type: "checkbox",
                checked: checked,
                onChange: onChange,
                tabIndex: -1,
                className: (0, $2jatx.default)([
                    "_kqswstnw _tzy4idpf _1bsbidpf _4t3iidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _1o9zidpf"
                ]),
                children: checked ? /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M3.375 0C1.51104 0 0 1.51104 0 3.375V20.25C0 22.114 1.51104 23.625 3.375 23.625H20.25C22.114 23.625 23.625 22.114 23.625 20.25V3.375C23.625 1.51104 22.114 0 20.25 0H3.375ZM19.1129 7.56023L17.1683 5.93977L9.70312 14.898L6.45666 11.0023L4.51209 12.6227L8.73084 17.6852C8.97131 17.9738 9.32751 18.1406 9.70312 18.1406C10.0787 18.1406 10.4349 17.9738 10.6754 17.6852L19.1129 7.56023Z",
                        fill: "#1868DB"
                    })
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        x: "0.5",
                        y: "0.5",
                        width: "23",
                        height: "23",
                        rx: "2",
                        fill: "none",
                        stroke: "#8C8F97",
                        strokeWidth: "1"
                    })
                })
            })
        ]
    });
};
const $1ac1029914e0cd63$var$labelStyles = null;
const $1ac1029914e0cd63$var$hiddenInputStyles = null;
const $1ac1029914e0cd63$var$checkboxVisualStyles = null;

});

parcelRegister("lJbez", function(module, exports) {
$parcel$export(module.exports, "CustomRadio", function () { return $b7af79367e9c6347$export$8b3e5f2afd424f4d; });
/* custom-radio.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $b7af79367e9c6347$export$8b3e5f2afd424f4d = ({ checked: checked, name: name, value: value, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _80omtlke _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                type: "radio",
                name: name,
                value: value,
                checked: checked,
                onChange: onChange,
                tabIndex: -1,
                className: (0, $2jatx.default)([
                    "_kqswstnw _tzy4idpf _1bsbidpf _4t3iidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _1o9zidpf"
                ]),
                children: checked ? /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5Z",
                        fill: "#1868DB"
                    })
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "11.5",
                        fill: "none",
                        stroke: "#8C8F97",
                        strokeWidth: "1"
                    })
                })
            })
        ]
    });
};
const $b7af79367e9c6347$var$labelStyles = null;
const $b7af79367e9c6347$var$hiddenInputStyles = null;
const $b7af79367e9c6347$var$radioVisualStyles = null;

});


parcelRegister("cNQe2", function(module, exports) {
$parcel$export(module.exports, "useAppDescriptions", function () { return $9e7fccd22b36f20f$export$ab9f7780451346ce; });
$parcel$export(module.exports, "useCollectionDescriptions", function () { return $9e7fccd22b36f20f$export$b81506d4e90a8621; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iRMRa = parcelRequire("iRMRa");
const $9e7fccd22b36f20f$export$ab9f7780451346ce = ()=>{
    const intl = (0, $8e22h.default)();
    return (0, $1oC0p.useMemo)(()=>({
            jira: {
                label: 'Jira',
                iconUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/478vdip7223r1idsl83luxcl3x6d8153.svg',
                description: intl.formatMessage({
                    id: 'ubp.calculator.apps.jira.description',
                    defaultMessage: 'Flexible project management'
                })
            },
            confluence: {
                label: 'Confluence',
                iconUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/yria5c22578g421umx80xu14m77622ej.svg',
                description: intl.formatMessage({
                    id: 'ubp.calculator.apps.confluence.description',
                    defaultMessage: 'Knowledge, all in one place'
                })
            },
            jpd: {
                label: 'Jira Product Discovery',
                iconUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/06wk2ma2fw3fde5d2pu7r04r770862g4.svg',
                description: intl.formatMessage({
                    id: 'ubp.calculator.apps.jpd.description',
                    defaultMessage: 'Capture and prioritize ideas'
                })
            },
            jsm: {
                label: 'Jira Service Management',
                iconUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/bafh8247s17543215301yjy1iaw6lgon.svg',
                description: intl.formatMessage({
                    id: 'ubp.calculator.apps.jsm.description',
                    defaultMessage: 'High-velocity service delivery'
                })
            }
        }), [
        intl
    ]);
};
const $9e7fccd22b36f20f$export$b81506d4e90a8621 = ()=>{
    const intl = (0, $8e22h.default)();
    return (0, $1oC0p.useMemo)(()=>({
            teamworkCollection: {
                lockupUrl: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT1ULE7.svg',
                shortDescription: intl.formatMessage({
                    id: 'ubp.calculator.collections.teamwork.shortDescription',
                    defaultMessage: 'Plan, document, and deliver together'
                }),
                description: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "ubp.calculator.collections.teamwork.description",
                    defaultMessage: "Everything your team needs to plan, document, and deliver\u2014all in one place.<br></br><br></br>Includes licensing for the following apps:",
                    values: (0, $iRMRa.DEFAULT_VALUES)
                }),
                list: [
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.teamwork.list.one',
                            defaultMessage: 'Jira; For flexible project management'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.teamwork.list.two',
                            defaultMessage: 'Confluence; Knowledge all in one place'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.teamwork.list.three',
                            defaultMessage: 'Loom; AI-powered video messages'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.teamwork.list.four',
                            defaultMessage: 'Rovo; Transform teamwork with AI'
                        })
                    }
                ]
            },
            serviceCollection: {
                lockupUrl: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12O5B2.svg',
                shortDescription: intl.formatMessage({
                    id: 'ubp.calculator.collections.service.shortDescription',
                    defaultMessage: 'High-velocity service delivery, at scale'
                }),
                description: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "ubp.calculator.collections.service.description",
                    defaultMessage: "Set strategic priorities, allocate investments, and see real-time portfolio progress in a single view.<br></br><br></br>Includes licensing for the following apps:",
                    values: (0, $iRMRa.DEFAULT_VALUES)
                }),
                list: [
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.serviceCollection.list.one',
                            defaultMessage: 'Jira Service Management; Deliver service at high velocity'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.serviceCollection.list.two',
                            defaultMessage: 'Customer Service Management; Customer experiences reimagined'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.serviceCollection.list.three',
                            defaultMessage: 'Assets; Track what matters'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.serviceCollection.list.four',
                            defaultMessage: 'Rovo; Team up with AI'
                        })
                    }
                ]
            }
        }), [
        intl
    ]);
};

});

parcelRegister("ehiBJ", function(module, exports) {
$parcel$export(module.exports, "StepNav", function () { return $db272d046543180a$export$85e4c3883d02a5f; });
/* step-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");

var $73KXs = parcelRequire("73KXs");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $kdccD = parcelRequire("kdccD");
const $db272d046543180a$var$messages = (0, $fnHPc.defineMessages)({
    back: {
        id: 'ubp.calculator.nav.back',
        defaultMessage: 'Back'
    },
    next: {
        id: 'ubp.calculator.nav.next',
        defaultMessage: 'Next'
    },
    skip: {
        id: 'ubp.calculator.nav.skip',
        defaultMessage: 'Skip'
    }
});
const $db272d046543180a$export$85e4c3883d02a5f = (props)=>{
    const { showBack: showBack = false, showNext: showNext = false, showSkip: showSkip = false, nextDisabled: nextDisabled = false, skipTo: skipTo, nextLabel: nextLabel, onBeforeNext: onBeforeNext, onBeforeBack: onBeforeBack, onBeforeSkip: onBeforeSkip } = props;
    const intl = (0, $8e22h.default)();
    const prev = (0, $4xsw0.useGoToPrevStep)();
    const next = (0, $4xsw0.useGoToNextStep)();
    const setStep = (0, $4xsw0.useSetStep)();
    // Build a real, valid href for the Back link — same pattern as the
    // Estimate/Summary steps' inlined Back link. The href points at the
    // calculator URL with `step` set to the previous step so the link
    // behaves as a semantically-real anchor (bookmarkable, right-
    // clickable, opens-in-new-tab). The `onClick` below prevents the
    // full page reload and drives the calculator state machine.
    const shareableQuery = (0, $4xsw0.useSelector)((0, $hSUNh.selectShareableQuery));
    const currentStep = (0, $4xsw0.useSelector)((ctx)=>ctx.step);
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    // Compute the previous step, skipping allowance for csResolutions.
    const currentIndex = (0, $73KXs.STEP_ORDER).indexOf(currentStep);
    let prevStepIndex = currentIndex - 1;
    if ((0, $73KXs.METER_ALLOWED_APPS)[meter] === null && (0, $73KXs.STEP_ORDER)[prevStepIndex] === 'allowance') prevStepIndex -= 1;
    const prevStep = (0, $73KXs.STEP_ORDER)[prevStepIndex];
    const prevStepHref = prevStep ? `?${(0, $kdccD.toQueryString)({
        ...shareableQuery,
        step: prevStep
    })}` : '?';
    // Wrap the navigation action with the optional analytics hook so
    // callers can fire a "clicked" event and (optionally) abort navigation
    // by returning `false` from the hook.
    const handleBack = ()=>{
        if (onBeforeBack?.() === false) return;
        prev();
    };
    const handleNext = ()=>{
        if (onBeforeNext?.() === false) return;
        next();
    };
    const handleSkip = ()=>{
        if (!skipTo) return;
        if (onBeforeSkip?.() === false) return;
        setStep(skipTo);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _zulp1crf _1q51zwfg _1bsb1osq"
        ]),
        children: [
            showBack && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _y4ti1crf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                    type: "primary",
                    size: "md",
                    text: intl.formatMessage($db272d046543180a$var$messages.back),
                    ariaLabel: intl.formatMessage($db272d046543180a$var$messages.back),
                    href: prevStepHref,
                    onClick: (e)=>{
                        e.preventDefault();
                        handleBack();
                    },
                    showArrow: false,
                    showUnderline: false
                })
            }),
            showSkip && skipTo && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                variant: "secondary",
                onClick: handleSkip,
                children: intl.formatMessage($db272d046543180a$var$messages.skip)
            }),
            showNext && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                variant: "primary",
                isDisabled: nextDisabled,
                onClick: handleNext,
                children: nextLabel ?? intl.formatMessage($db272d046543180a$var$messages.next)
            })
        ]
    });
};
// Centered nav row with 76px top padding per Figma. Buttons flow horizontally
// with a small gap between them.
const $db272d046543180a$var$navRowStyle = null;
// Wrapper around the Back link that adds extra breathing room to the
// right — 12px in addition to the nav row's existing 12px gap, for a
// total of 24px of clear space between "Back" and the primary Next
// button. Per design feedback on GWP-1XXXX (Q4 calculator polish).
const $db272d046543180a$var$backLinkWrapperStyle = null;

});
parcelRegister("kdccD", function(module, exports) {
$parcel$export(module.exports, "toQueryString", function () { return $c08b1e7b47753322$export$249cc09c933c4d7a; });
$parcel$export(module.exports, "fromQueryString", function () { return $c08b1e7b47753322$export$654b5b3040c9f223; });
/**
 * Generic URL query-string helpers. These are intentionally business-logic
 * agnostic — they know how to serialize/deserialize plain values, arrays and
 * nested key/value records, but they do not know anything about the UBP
 * domain model.
 */ const $c08b1e7b47753322$export$249cc09c933c4d7a = (values)=>{
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(values)){
        if (value === undefined || value === null) continue;
        if (Array.isArray(value)) for (const v of value)params.append(`${key}[]`, String(v));
        else if (typeof value === 'object') for (const [subKey, subValue] of Object.entries(value)){
            if (subValue === undefined || subValue === null) continue;
            params.append(`${key}.${subKey}`, String(subValue));
        }
        else params.append(key, String(value));
    }
    return params.toString();
};
/**
 * Keys that resolve to shared prototype internals. Using any of these as an
 * object key allows an attacker to walk into `Object.prototype` and pollute it,
 * so they are rejected wherever a query segment is used as a key.
 */ const $c08b1e7b47753322$var$UNSAFE_KEYS = new Set([
    '__proto__',
    'prototype',
    'constructor'
]);
const $c08b1e7b47753322$export$654b5b3040c9f223 = (search)=>{
    const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
    const result = {
        scalars: Object.create(null),
        arrays: Object.create(null),
        nested: Object.create(null)
    };
    params.forEach((value, rawKey)=>{
        if (rawKey.endsWith('[]')) {
            const key = rawKey.slice(0, -2);
            if ($c08b1e7b47753322$var$UNSAFE_KEYS.has(key)) return;
            (result.arrays[key] ??= []).push(value);
        } else if (rawKey.includes('.')) {
            // Split on the LAST `.` so that multi-segment parents like
            // `product.jira` are preserved (parent = `product.jira`,
            // subKey = `units`).
            const lastDot = rawKey.lastIndexOf('.');
            const parent = rawKey.slice(0, lastDot);
            const subKey = rawKey.slice(lastDot + 1);
            if ($c08b1e7b47753322$var$UNSAFE_KEYS.has(parent) || $c08b1e7b47753322$var$UNSAFE_KEYS.has(subKey)) return;
            (result.nested[parent] ??= Object.create(null))[subKey] = value;
        } else {
            if ($c08b1e7b47753322$var$UNSAFE_KEYS.has(rawKey)) return;
            result.scalars[rawKey] = value;
        }
    });
    return result;
};

});


parcelRegister("cIZNT", function(module, exports) {
$parcel$export(module.exports, "Stepper", function () { return $523f115dd120cc39$export$ed8ca599049e8881; });
/* stepper.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $8gmzg = parcelRequire("8gmzg");
const $523f115dd120cc39$export$ed8ca599049e8881 = ({ visibleStepCount: visibleStepCount } = {})=>{
    const currentIndex = (0, $4xsw0.useSelector)((0, $hSUNh.selectStepIndex));
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const intl = (0, $8e22h.default)();
    // When visibleStepCount is not explicitly passed, derive it from the meter.
    // csResolutions skips the allowance step so only 3 steps are ever shown;
    // all other meters show either a capped preview (when called with an
    // explicit visibleStepCount from usage/needs steps) or all 5.
    const resolvedVisibleStepCount = visibleStepCount ?? (0, $8gmzg.METER_STEPPER_COUNT)[meter];
    const navSteps = (0, $1oC0p.useMemo)(()=>[
            intl.formatMessage({
                id: 'ubp.calculator.topnav.usage',
                defaultMessage: 'Meter'
            }),
            intl.formatMessage({
                id: 'ubp.calculator.topnav.needs',
                defaultMessage: 'Usage needs'
            }),
            intl.formatMessage({
                id: 'ubp.calculator.topnav.estimate',
                defaultMessage: 'Estimate'
            }),
            intl.formatMessage({
                id: 'ubp.calculator.topnav.allowance',
                defaultMessage: 'Compare'
            }),
            intl.formatMessage({
                id: 'ubp.calculator.topnav.summary',
                defaultMessage: 'Summary'
            })
        ], [
        intl
    ]);
    const visibleSteps = navSteps.slice(0, resolvedVisibleStepCount);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4cvr1y6m _1bsb1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug",
            currentIndex > 0 ? 'middle-step' : 'first-step'
        ]),
        children: visibleSteps.map((navStep, index)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsx)($523f115dd120cc39$var$StepperItem, {
                index: index,
                currentIndex: currentIndex,
                label: navStep,
                isLast: index === visibleSteps.length - 1
            }, `step${index}`);
        })
    });
};
// eslint-disable-next-line complexity
const $523f115dd120cc39$var$StepperItem = (props)=>{
    const { label: label, index: index, currentIndex: currentIndex, isLast: isLast } = props;
    const isPast = index < currentIndex;
    const isFuture = index > currentIndex;
    const isCurrent = index === currentIndex;
    const isFirst = index === 0;
    const leftColor = isFirst ? 'transparent' : isCurrent || isPast ? (0, $kbpa7.wacToken)('color.primary.blue') : (0, $kbpa7.wacToken)('color.neutral.light400');
    const rightColor = isLast ? 'transparent' : isCurrent || isFuture ? (0, $kbpa7.wacToken)('color.neutral.light400') : (0, $kbpa7.wacToken)('color.primary.blue');
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        style: {
            backgroundImage: `linear-gradient(to right, ${leftColor} 0 50%, ${rightColor} 50% 100%)`
        },
        className: (0, $2jatx.default)([
            "_1lrw5kut _ouxl81bl _12vemgnk _1e0c1txw _zulpu2gc _y3gn1h6o _4cvr1y6m _1bah1h6o _2lx21bp4 _1bsb53f4 _sugaglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _bfhkdkka _syaz1pfd _1bsb7vkz _4t3i7vkz _2rko1ssb _1dqonqa1 _189et94y _1h6ddkka _1wyb19bv _1e0c1txw _4cvr1h6o _1bah1h6o _16jlidpf _1o9zidpf _i0dl1wug _ga7t5hrz _1ob55hrz _1f4d1afi",
                    `active-${isPast || isCurrent}`
                ]),
                style: {
                    "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: index + 1
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1wyb1d98 _18zru2gc _syaz1pfd",
                    `active-${isPast || isCurrent}`
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: label
            })
        ]
    });
};
const $523f115dd120cc39$var$stepperItemCss = null;
const $523f115dd120cc39$var$stepperRowStyle = null;
const $523f115dd120cc39$var$stepperCircle = null;
const $523f115dd120cc39$var$stepperLabelStyle = null;

});
parcelRegister("8gmzg", function(module, exports) {
$parcel$export(module.exports, "METER_STEPPER_COUNT", function () { return $e11c937be0c32a9a$export$6f0e6611793cee60; });
const $e11c937be0c32a9a$export$6f0e6611793cee60 = {
    assetsObjects: 5,
    automations: 5,
    rovoCredits: 5,
    // AI agent resolutions has no allowance step — show only 3 steps throughout.
    csResolutions: 3
};

});



parcelRegister("9wpUt", function(module, exports) {
$parcel$export(module.exports, "EstimateStep", function () { return $61c70cc4030e4911$export$fe759901621fb73d; });
/* estimate-step.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $2axoc = parcelRequire("2axoc");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $l4DCt = parcelRequire("l4DCt");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $3h32c = parcelRequire("3h32c");

var $8wHAz = parcelRequire("8wHAz");

var $iZlze = parcelRequire("iZlze");

var $loMPq = parcelRequire("loMPq");

var $fGqzr = parcelRequire("fGqzr");

var $b7cuD = parcelRequire("b7cuD");

var $93kHd = parcelRequire("93kHd");

var $f8Axo = parcelRequire("f8Axo");

var $cIZNT = parcelRequire("cIZNT");

var $f1WTS = parcelRequire("f1WTS");
/**
 * Extra ResultsCard rendered between OrgNeedsCard and
 * HowYourTeamsMightUse — only for meters whose content bundle defines
 * `estimateStep.extraResultsCard` (currently AI agent resolutions per
 * Figma node 1160:20784). Uses the same ResultsCard primitive as the
 * main OrgNeedsCard for visual consistency.
 */ const $61c70cc4030e4911$var$ExtraResultsCardSlot = ()=>{
    const intl = (0, $8e22h.default)();
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const extra = (0, $l4DCt.METER_CONTENT)[meter].estimateStep.extraResultsCard;
    // Compute total monthly cost across the currently-selected products
    // using Briet's calculator (`selectTotalMonthlyCost` sums per-unit ×
    // unitCount using the CCP pricing data). Only displayed when the
    // meter's extra card is the "Monthly Cost Estimate" variant (CSR).
    // Falls back to the spec's static headline when the calculation is
    // pending or products aren't yet selected.
    const totalCost = (0, $4xsw0.useSelector)((0, $hSUNh.selectTotalMonthlyCost));
    const currency = (0, $4xsw0.useSelector)((0, $hSUNh.getCurrencyIsoCode));
    const locale = (0, $4xsw0.useSelector)((0, $hSUNh.getNumberFormatLocale));
    if (!extra) return null;
    // `extra.headline` is optional in the content type: meters may omit it.
    // If the meter's content omits it AND we don't have a real
    // live-price to compute (either not the cost-variant or CCP pricing
    // still loading), fall back to an empty string so the required
    // ResultsCard headline prop stays a string.
    const headline = extra.isMonthlyCostVariant && totalCost !== undefined ? (0, $f1WTS.formatPrice)(totalCost, {
        currency: currency,
        locale: locale
    }) : extra.headline ? intl.formatMessage(extra.headline) : '';
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $93kHd.ResultsCard), {
        eyebrow: intl.formatMessage(extra.eyebrow),
        headline: headline,
        headlineSubtext: extra.headlineSubtext ? intl.formatMessage(extra.headlineSubtext) : undefined
    });
};
/**
 * Monthly Cost Estimate card — Estimate step (Figma node 2164:27044).
 *
 * Presentational twin of the Summary step's overage-cost card. Renders
 * whenever the current meter defines `summaryStep.overageCostCard`. The
 * card's body copy is dynamic based on whether the org's estimated
 * usage exceeds its included allowance:
 *
 *   - overage case  → `body`         ("...not 100% covered by allowances.")
 *   - covered case  → `bodyCovered`  ("...usage is covered by allowances.")
 *
 * `{rate}` / `{rate2}` tokens in `rateNote` are substituted with
 * currency-formatted per-unit overage rates from the pricing config at
 * render time.
 *
 * Reuses `summaryStep.overageCostCard` (rather than duplicating the copy
 * onto `estimateStep`) so a single source of truth in each meter's
 * content bundle drives both steps. Note: Step 3 intentionally omits the
 * card's `listItems` bullets — they render only on the Step 5 Summary
 * card (SummaryOverageCostCard).
 */ const $61c70cc4030e4911$var$MonthlyCostEstimateCard = ()=>{
    const intl = (0, $8e22h.default)();
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const overageCostCard = (0, $l4DCt.METER_CONTENT)[meter].summaryStep.overageCostCard;
    const overageCost = (0, $4xsw0.useSelector)((0, $hSUNh.selectTotalOverageCost));
    const currency = (0, $4xsw0.useSelector)((0, $hSUNh.getCurrencyIsoCode));
    const locale = (0, $4xsw0.useSelector)((0, $hSUNh.getNumberFormatLocale));
    // Per revised design (2026-07-16): the Monthly Cost Estimate card on
    // Step 3 (Estimate) renders for CSR only. Assets shows the card on
    // Step 5 (Summary) but NOT on Step 3. The `overageCostCard` field
    // itself is still defined in both CSR + Assets content files because
    // Step 5's SummaryOverageCostCard consumes it there.
    if (!overageCostCard || meter !== 'csResolutions') return null;
    const overageRangeText = (0, $f1WTS.formatPriceRange)(overageCost.low, overageCost.high, {
        currency: currency,
        locale: locale
    });
    // Supply the `{rate}` / `{rate2}` … ICU values in the content-registry
    // `rateNote` from the pricing config. Sub-dollar rates show cents so
    // "$0.50" doesn't round to "$1".
    const overageRateNote = intl.formatMessage(overageCostCard.rateNote, (0, $f1WTS.buildOverageRateValues)({
        meter: meter,
        currency: currency,
        locale: locale
    }));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $93kHd.ResultsCard), {
        eyebrow: intl.formatMessage(overageCostCard.eyebrow),
        headline: overageRangeText,
        headlineSubtext: overageRateNote,
        testId: "estimate-monthly-cost"
    });
};
const $61c70cc4030e4911$export$335b18f104030e5f = ({ onCompareNow: onCompareNow })=>{
    const intl = (0, $8e22h.default)();
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const goToNext = (0, $4xsw0.useGoToNextStep)();
    // Meter-aware Compare CTA — sourced from the content registry so it
    // tracks the per-meter Confluence spec's "Card 1 Primary CTA" row.
    const compareCta = intl.formatMessage((0, $l4DCt.METER_CONTENT)[meter].estimateStep.compareCta);
    // Optional external href for the Compare CTA. When present the
    // button navigates to that URL (currently AI agent resolutions →
    // /collections/service). When absent, the button falls back to
    // advancing to the next calculator step.
    const compareHref = (0, $l4DCt.METER_CONTENT)[meter].estimateStep.compareHref;
    // Meter-aware ContentBlock copy (title, intro, list items). Each meter
    // file declares these as descriptors with per-meter message IDs so
    // translators can localize per-meter without disturbing others.
    const contentBlockTitle = intl.formatMessage((0, $l4DCt.METER_CONTENT)[meter].estimateStep.contentBlock.title);
    const contentBlockIntro = intl.formatMessage((0, $l4DCt.METER_CONTENT)[meter].estimateStep.contentBlock.intro);
    const contentBlockListItems = (0, $l4DCt.METER_CONTENT)[meter].estimateStep.contentBlock.listItems.map((item)=>intl.formatMessage(item));
    // Uses the design-library ContentBlock so the section matches Figma
    // node 1103:32363 ("Content Blocks Vertical") and inherits the WAC
    // design-system typography, spacing, and image treatment (16:9,
    // rounded corners). Do NOT swap this for a wpl/ component — see the
    // "Component Sourcing Rule" in wac/AGENTS.md.
    //
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
        imageBackgroundColor: (0, $l4DCt.METER_CONTENT)[meter].estimateStep.image.imageBackgroundColor,
        title: contentBlockTitle,
        titleAs: "h3",
        titleAppearsAs: "card-title",
        // Structured content per Figma node 1103:32363: intro paragraph
        // + a small bulleted list. Passed as a single React element (a
        // `<div>`) so it satisfies ContentBlock's `text: string |
        // ReactElement` prop shape. The ContentBlock renders elements
        // as-is (no `body-lg`/`body-md` wrapping), so the caller uses
        // `body-md` classes to keep the typography consistent with the
        // default string rendering.
        text: // Body copy must render at "body regular" (16/24) even on
        // wide viewports. The `p, .body-md` rule under WAC-refresh
        // typographyStylesRefresh (see
        // `libraries/wpl/foundations/src/typography-styles.tsx`
        // line 474-479) bumps every `<p>` to 18/26 at `above.lg`,
        // which visually reads as "body large" and doesn't match
        // the ContentBlock Figma spec for this section. To keep
        // the copy at body-regular:
        //   1. Use a `<div>` (not `<p>`) so the responsive `p`
        //      selector doesn't apply.
        //   2. Explicitly declare the body-md font-size /
        //      line-height on both the intro block and the bullet
        //      list to lock in 16/24 across breakpoints.
        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
                fontSize: '1rem',
                lineHeight: '1.5rem',
                fontWeight: 400
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: contentBlockIntro
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                    style: {
                        margin: 0,
                        paddingInlineStart: '1.25rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                        fontSize: '1rem',
                        lineHeight: '1.5rem',
                        fontWeight: 400
                    },
                    children: contentBlockListItems.map((item, i)=>// Meter-aware bulleted list — items come from the
                        // atomic content registry.
                        /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            children: item
                        }, `cb-li-${i}`))
                })
            ]
        }),
        alignment: "start",
        orientation: "vertical",
        imageAspectRatio: "16 / 9",
        imageProps: {
            // Meter-aware image — sourced from the atomic per-meter
            // content registry (`src/content/*.ts`,
            // `estimateStep.image`). All four meters currently point
            // to the same Orange Logic asset while the content team
            // finalizes per-meter hero imagery; each file is
            // independently swappable to a per-meter URL without
            // touching this component. Track replacement in the
            // follow-up content ticket.
            src: (0, $l4DCt.METER_CONTENT)[meter].estimateStep.image.src,
            alt: (0, $l4DCt.METER_CONTENT)[meter].estimateStep.image.alt
        },
        // Small secondary button per Figma node 1103:32350. The
        // ContentBlock's default button size is derived from title
        // semantics (`h4` → small, else large). Since our title is
        // visually h3-sized, we opt into the compact `small` size
        // explicitly via the new `buttonSize` override.
        //
        // The CTA doubles as the Estimate step's "Next" action — clicking
        // it advances the calculator to the Summary step. This is why
        // the Estimate step's StepNav omits `showNext`: the ContentBlock
        // button IS the forward navigation for this step.
        buttonSize: "small",
        callToActionProps: {
            buttonText: compareCta,
            buttonVariant: 'secondary',
            button: compareHref ? {
                // External destination — render as a real anchor
                // so it opens in a new tab, is right-clickable,
                // and is bookmarkable. Still fire the analytics
                // event before default navigation.
                href: compareHref,
                onClick: ()=>onCompareNow?.()
            } : {
                type: 'button',
                onClick: (e)=>{
                    e.preventDefault();
                    onCompareNow?.();
                    goToNext();
                }
            }
        }
    });
};
const $61c70cc4030e4911$export$fe759901621fb73d = ()=>{
    const intl = (0, $8e22h.default)();
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const resetAll = (0, $4xsw0.useResetAll)();
    const [vote, setVote] = (0, $1oC0p.useState)(null);
    const fireStep3Viewed = (0, $3h32c.useUbpStep3ScreenViewedEvent)();
    const fireStep3CompareNow = (0, $3h32c.useUbpStep3CompareNowClickedEvent)();
    // GWP-12674 — analytics event reused for the new Restart button.
    // Same underlying UI event ID / actionSubject; the semantic gesture
    // changed from "Back" to "Restart" but for analytics-continuity
    // purposes we keep the existing hook so historical funnels aren't
    // disrupted.
    const fireStep3Back = (0, $3h32c.useUbpStep3BackClickedEvent)();
    const fireStep3Share = (0, $3h32c.useUbpStep3ShareClickedEvent)();
    const fireStep3Feedback = (0, $3h32c.useUbpStep3FeedbackClickedEvent)();
    (0, $1oC0p.useEffect)(()=>{
        fireStep3Viewed();
    // Intentionally run once on mount only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // All meters (including AI agent resolutions / csResolutions) share
    // the same two-column Estimate step layout. Per-meter content is
    // resolved via the atomic content registry (`METER_CONTENT[meter]`)
    // so the same JSX renders correctly for every meter. Prior to
    // GWP-1XXXX a separate `<EstimateCsrStep>` branch existed with a
    // 3-column layout — it was removed once CSR gained proper registry
    // content.
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cIZNT.Stepper), {
                visibleStepCount: 3
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    style: $61c70cc4030e4911$var$pageHeaderStyle,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            style: $61c70cc4030e4911$var$pageTitleStyle,
                            children: intl.formatMessage({
                                id: 'ubp.calculator.estimate.title',
                                defaultMessage: 'Review usage estimate'
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            style: $61c70cc4030e4911$var$pageSubtitleStyle,
                            children: intl.formatMessage((0, $l4DCt.METER_CONTENT)[meter].estimateStep.subtitle)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: $61c70cc4030e4911$var$twoColumnRowStyle,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        style: $61c70cc4030e4911$var$twoColumnLeftStyle,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fGqzr.OrgNeedsResultsCard), {
                                testId: "estimate-org-needs"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)($61c70cc4030e4911$var$MonthlyCostEstimateCard, {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)($61c70cc4030e4911$var$ExtraResultsCardSlot, {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $loMPq.HowYourTeamsMightUse), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        style: $61c70cc4030e4911$var$twoColumnRightStyle,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($61c70cc4030e4911$export$335b18f104030e5f, {
                            onCompareNow: fireStep3CompareNow
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1y6m _1q518vuz _85i51ady _msup1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iZlze.FeedbackButtons), {
                    vote: vote,
                    onVote: (v)=>{
                        setVote(v);
                        // Only fire the analytics event when the user actually
                        // casts a vote. `v` can be null when they toggle their
                        // current vote off, in which case there's nothing to
                        // report.
                        if (v !== null) fireStep3Feedback(v);
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: $61c70cc4030e4911$var$bottomActionRowStyle,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            fireStep3Back();
                            resetAll();
                        },
                        className: (0, $2jatx.default)([
                            "_r06hglyw _bfhk1j28 _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect4z4z1 _1wyb7vkz _vwz41tcg _k48p1nn1 _syaz5hrz _80omtlke _4bfu1r31 _1hmsglyw _ajmmnqa1 _vjfr1r31 _9oik1r31 _10xf8stv _1bnx8stv _1w0vnqa1 _jf4cnqa1 _1ygb1qgu _1ah3yh40 _1basyh40"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                        },
                        children: intl.formatMessage((0, $b7cuD.messages).restart)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f8Axo.ShareButton), {
                        onShare: fireStep3Share
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8wHAz.EstimateDisclaimer), {})
        ]
    });
};
const $61c70cc4030e4911$export$abcda1a9465218a0 = {
    padding: 16,
    border: `1px solid ${(0, $kbpa7.wacToken)('color.neutral.light300')}`,
    borderRadius: 8,
    backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light100'),
    height: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column'
};
const $61c70cc4030e4911$export$7a56d429868e2274 = {
    margin: '0 0 12px',
    fontSize: 16,
    fontWeight: 700,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
/**
 * Estimate step header / bottom-action-row styles.
 *
 * The old `stepTitleStyle` (a plain 22px bold heading) was removed —
 * the Estimate step now uses the design-system H3 + body-large pattern
 * (see `pageTitleStyle` / `pageSubtitleStyle` below), consistent with
 * the other calculator steps.
 */ const $61c70cc4030e4911$var$pageHeaderStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    // 40px above the H3 (between the Stepper and the title) and 40px below
    // the subtitle (before the cards start), per Figma node 1103:32350.
    paddingBlock: '40px',
    maxWidth: '688px'
};
const $61c70cc4030e4911$var$pageTitleStyle = {
    // TypographyStyles maps raw `h3` to Charlie Display Bold 32/38 —
    // matches Figma spec (node 1103:32354).
    margin: 0
};
const $61c70cc4030e4911$var$pageSubtitleStyle = {
    // Body Large: Charlie Text Regular 20/28, matches Figma node 1103:32357.
    margin: 0,
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
// Restart button — matches Figma "medium anchor default": blue text,
// no border, no background, Charlie Text Bold 16/24 with underline on
// hover/focus for affordance. Focus-visible ring for keyboard users.
// KEEP IN SYNC with the identical `restartButtonStyle` in
// `summary-step.tsx` (GWP-12674). Compiled CSS's `@compiled/no-exported-css`
// rule forbids exporting `css()` return values because the transformer
// needs to inline the style at build time in the file where it's used —
// so we duplicate rather than centralize. If you edit either copy, edit
// the other too.
const $61c70cc4030e4911$var$restartButtonStyle = null;
const $61c70cc4030e4911$var$bottomActionRowStyle = {
    display: 'flex',
    // Vertically center Back + Share on a single row per Figma.
    alignItems: 'center',
    // Horizontally centered per Figma — Back + Copy URL sit in the middle
    // of the calculator container, with a 12px gap between them (matches
    // the gap used inside StepNav for visual consistency).
    justifyContent: 'center',
    gap: '12px',
    paddingBlockStart: '40px'
};
// Two-column layout for the main Estimate step content sections.
// Uses `grid-template-columns: repeat(auto-fit, minmax(400px, 1fr))` so
// the grid intrinsically collapses to a single column below the WAC `sm`
// breakpoint (roughly viewports < 832px) without needing a media query.
// This keeps the layout styleable with plain inline styles.
// The `min(400px, 100%)` intrinsic width lets a single card collapse
// below 400px on narrow viewports (phones) rather than overflowing the
// container. Above 832px the grid still auto-fits into two 400px cols.
const $61c70cc4030e4911$var$twoColumnRowStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(400px, 100%), 1fr))',
    gap: '32px',
    alignItems: 'start'
};
// Left column — stacks OrgNeedsCard on top of HowYourTeamsMightUse.
const $61c70cc4030e4911$var$twoColumnLeftStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
};
// Right column — holds the ExampleUsage ContentBlock. Explicit wrapper
// (rather than just placing ExampleUsage directly) keeps parallel styling
// hooks available if the right side needs its own gap/padding later.
const $61c70cc4030e4911$var$twoColumnRightStyle = {
    display: 'flex',
    flexDirection: 'column'
};
// Wrapper for the FeedbackButtons section — 56px above (40 + 16) and
// 44px below (40 + 4) per the design's spacing spec on top of the base
// 40px rhythm. Horizontally centered per Figma.
// On mobile, feedback aligns left (matches the surrounding content
// grid); on tablet/desktop, centered within the calculator. The
// FeedbackButtons component itself handles the row-vs-column layout;
// this wrapper just controls the outer horizontal placement.
// Feedback wrapper — 56px above (40 + 16) and 44px below (40 + 4) per
// design spacing spec.
//   Mobile (< 768px): left-align so prompt + thumbs sit at the same
//     x-origin as the surrounding content grid.
//   Desktop (>= 768px): centered per Figma.
const $61c70cc4030e4911$var$feedbackWrapperStyle = null;
const $61c70cc4030e4911$export$93dd9b65c49182d4 = {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
};
const $61c70cc4030e4911$export$2d90ecca2320557a = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 16,
    alignItems: 'stretch'
};

});
parcelRegister("8wHAz", function(module, exports) {
$parcel$export(module.exports, "EstimateDisclaimer", function () { return $0ecad20c385e021a$export$e962f554efad26d8; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $3WmaU = parcelRequire("3WmaU");
const $0ecad20c385e021a$export$e962f554efad26d8 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: $0ecad20c385e021a$var$wrapperStyle,
        "data-testid": "estimate-disclaimer",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            style: $0ecad20c385e021a$var$copyStyle,
            children: intl.formatMessage((0, $3WmaU.messages).disclaimer)
        })
    });
};
// Full-width centering wrapper with 20px top padding (the gap from the
// Copy URL to share row above per Figma node 1103:32365).
const $0ecad20c385e021a$var$wrapperStyle = {
    display: 'flex',
    justifyContent: 'center',
    paddingBlockStart: '20px'
};
// Fine-print typography — Charlie Text Regular 12/18, primary-black,
// center-aligned, max-width 768px so the line-length stays comfortable
// regardless of container width.
const $0ecad20c385e021a$var$copyStyle = {
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100'),
    textAlign: 'center',
    maxWidth: '768px'
};

});
parcelRegister("3WmaU", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $843caea669257594$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $843caea669257594$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    disclaimer: {
        id: 'ubp.calculator.estimateDisclaimer',
        defaultMessage: "This estimate isn\u2019t binding for either you or Atlassian. Figures shown here are intended to show an estimation of usage allowance, and may be subject to change."
    }
});

});


parcelRegister("iZlze", function(module, exports) {
$parcel$export(module.exports, "FeedbackButtons", function () { return $f575de999ccb7f41$export$c633fc044a8b8981; });
/* feedback-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $bmQfx = parcelRequire("bmQfx");

var $51it3 = parcelRequire("51it3");

var $kbpa7 = parcelRequire("kbpa7");

var $hciAo = parcelRequire("hciAo");
const $f575de999ccb7f41$export$c633fc044a8b8981 = ({ vote: vote, onVote: onVote, label: label, testId: testId = 'ubp-feedback-buttons' })=>{
    const intl = (0, $8e22h.default)();
    const hasVoted = vote !== null;
    const handleClick = (nextVote)=>{
        // The user can freely switch between thumbs up and thumbs down, or
        // click the currently-selected thumb again to clear their vote.
        // (Previously this early-returned once a vote was cast, which locked
        // the user into their first choice — corrected so votes are toggleable.)
        onVote(vote === nextVote ? null : nextVote);
    };
    const resolvedLabel = label ?? intl.formatMessage((0, $hciAo.messages).label);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": testId,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _1bah1y6m _zulp1crf _ect4z4z1 _1inivrvc _1jsv1h6o _msup1h6o _pdlmgktf"
        ]),
        style: {
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect4z4z1 _1wyb7vkz _vwz41tcg _syaz1pfd _o5721q9c _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: resolvedLabel
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulpftgi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        onClick: ()=>handleClick('up'),
                        "aria-label": intl.formatMessage((0, $hciAo.messages).thumbsUpAriaLabel),
                        "aria-pressed": vote === 'up',
                        "data-testid": `${testId}-thumbs-up`,
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1h6o _11q7glyw _19it79pa _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _80omtlke _2rkoftgi _syaz1pfd _v564cklq _16l415iw _1ygb1qgu _1ah3yh40 _j5dh1wug _1ldbkb7n",
                            vote === 'up' && "_syaz5hrz"
                        ]),
                        style: {
                            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($51it3))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        onClick: ()=>handleClick('down'),
                        "aria-label": intl.formatMessage((0, $hciAo.messages).thumbsDownAriaLabel),
                        "aria-pressed": vote === 'down',
                        "data-testid": `${testId}-thumbs-down`,
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1h6o _11q7glyw _19it79pa _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _80omtlke _2rkoftgi _syaz1pfd _v564cklq _16l415iw _1ygb1qgu _1ah3yh40 _j5dh1wug _1ldbkb7n",
                            vote === 'down' && "_syaz5hrz"
                        ]),
                        style: {
                            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmQfx))), {
                            label: ""
                        })
                    })
                ]
            }),
            hasVoted ? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                role: "status",
                className: (0, $2jatx.default)([
                    "_kqswstnw _1bsbt94y _4t3it94y _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ogtocqaw _o5721q9c _19itidpf"
                ]),
                children: intl.formatMessage((0, $hciAo.messages).thanksAfterVote)
            }) : null
        ]
    });
};
// Left-aligned across all viewports so prompt + thumbs sit at the
// same x-origin as the surrounding content grid.
//   - Mobile (< 768px): column layout — prompt on top, thumbs below.
//   - Tablet / desktop: row layout — prompt + thumbs on same line.
const $f575de999ccb7f41$var$containerStyles = null;
const $f575de999ccb7f41$var$labelStyles = null;
const $f575de999ccb7f41$var$buttonRowStyles = null;
const $f575de999ccb7f41$var$iconButtonStyles = null;
const $f575de999ccb7f41$var$iconButtonActiveStyles = null;
// Standard visually-hidden pattern — keeps the confirmation available to
// screen readers without occupying visual space or shifting the layout.
const $f575de999ccb7f41$var$visuallyHiddenStyles = null;

});
parcelRegister("hciAo", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $d5befc58923476ff$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $d5befc58923476ff$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    label: {
        id: 'ubp.calculator.feedbackButtons.label',
        defaultMessage: 'Did you find this page helpful?'
    },
    thumbsUpAriaLabel: {
        id: 'ubp.calculator.feedbackButtons.thumbsUpAriaLabel',
        defaultMessage: 'Yes, this page was helpful'
    },
    thumbsDownAriaLabel: {
        id: 'ubp.calculator.feedbackButtons.thumbsDownAriaLabel',
        defaultMessage: 'No, this page was not helpful'
    },
    thanksAfterVote: {
        id: 'ubp.calculator.feedbackButtons.thanksAfterVote',
        defaultMessage: 'Thanks for your feedback!'
    }
});

});


parcelRegister("loMPq", function(module, exports) {
$parcel$export(module.exports, "HowYourTeamsMightUse", function () { return $3fea331ec21b6715$export$65a74acb094c9303; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $l4DCt = parcelRequire("l4DCt");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");
const $3fea331ec21b6715$export$28833053b5e4afa6 = {
    rovoCredits: 'rovo credits',
    automations: 'automation steps',
    csResolutions: 'AI agent resolutions',
    assetsObjects: 'assets objects'
};
/**
 * Eyebrow copy, one full sentence per meter. Deliberately NOT a single
 * message with a `{meter}` placeholder: some locales don't preserve the
 * "verb + meter noun" word order, so translators need the whole sentence.
 * Keys must stay literal for the i18n extractor — see the i18n contract in
 * `content/meter-content.types.ts`.
 */ const $3fea331ec21b6715$var$eyebrowMessages = (0, $fnHPc.defineMessages)({
    rovoCredits: {
        id: 'ubp.calculator.estimate.rovoCredits.howYourTeamsMightUse.eyebrow',
        defaultMessage: 'How your teams might use rovo credits'
    },
    automations: {
        id: 'ubp.calculator.estimate.automations.howYourTeamsMightUse.eyebrow',
        defaultMessage: 'How your teams might use automation steps'
    },
    csResolutions: {
        id: 'ubp.calculator.estimate.csResolutions.howYourTeamsMightUse.eyebrow',
        defaultMessage: 'How your teams might use AI agent resolutions'
    },
    assetsObjects: {
        id: 'ubp.calculator.estimate.assetsObjects.howYourTeamsMightUse.eyebrow',
        defaultMessage: 'How your teams might use assets objects'
    }
});
const $3fea331ec21b6715$export$65a74acb094c9303 = ()=>{
    const intl = (0, $8e22h.default)();
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const valueProps = (0, $l4DCt.METER_CONTENT)[meter].valueProps.map((vp)=>({
            title: intl.formatMessage(vp.title),
            description: intl.formatMessage(vp.description)
        }));
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        style: $3fea331ec21b6715$var$howYourTeamsMightUseStyle,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                style: $3fea331ec21b6715$var$howYourTeamsMightUseEyebrowStyle,
                children: intl.formatMessage($3fea331ec21b6715$var$eyebrowMessages[meter])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: $3fea331ec21b6715$var$valuePropStackStyle,
                children: valueProps.map((vp, i)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        style: $3fea331ec21b6715$var$valuePropItemStyle,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                style: $3fea331ec21b6715$var$valuePropTitleStyle,
                                children: vp.title
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                style: $3fea331ec21b6715$var$valuePropDescriptionStyle,
                                children: vp.description
                            })
                        ]
                    }, `${vp.title}-${i}`))
            })
        ]
    });
};
// "How your teams might use" section — value cards without icons.
// Neutral-light-100 panel (matches ResultsCard) with 20px inside padding
// and 20px rounded corners. Content is a stack of bold title + description
// pairs with 24px between items (matches Figma 1103:32350).
const $3fea331ec21b6715$var$howYourTeamsMightUseStyle = {
    backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light100'),
    borderRadius: '20px',
    padding: '20px 20px 32px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
};
const $3fea331ec21b6715$var$howYourTeamsMightUseEyebrowStyle = {
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 400,
    textTransform: 'uppercase',
    letterSpacing: 0,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $3fea331ec21b6715$var$valuePropStackStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
};
const $3fea331ec21b6715$var$valuePropItemStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 0
};
const $3fea331ec21b6715$var$valuePropTitleStyle = {
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 700,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $3fea331ec21b6715$var$valuePropDescriptionStyle = {
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};

});

parcelRegister("fGqzr", function(module, exports) {
$parcel$export(module.exports, "OrgNeedsResultsCard", function () { return $17f8fb3e78b6e6e0$export$db2d15e052816845; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $l4DCt = parcelRequire("l4DCt");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $93kHd = parcelRequire("93kHd");

var $f1WTS = parcelRequire("f1WTS");
/**
 * "Your Organization Needs" card — shared by the Estimate step (Step 3)
 * and the Summary step (Step 5). Both steps render an identical card
 * (usage-range headline + usage-type dropdown + value-prop footer), so
 * the wiring lives here once and each step passes only a `testId`.
 *
 * Content-driven: eyebrow/subtext come from the meter's
 * `summaryStep.orgNeedsCard` (single source of truth). Renders nothing
 * when the meter omits that content.
 */ const $17f8fb3e78b6e6e0$var$messages = (0, $fnHPc.defineMessages)({
    /** Fallback subtext when a meter omits `orgNeedsCard.headlineSubtext`. */ headlineSubtextFallback: {
        id: 'ubp.calculator.summary.orgNeedsCard.headlineSubtextFallback',
        defaultMessage: '{meterLabel} per month'
    },
    dropdownAriaLabel: {
        id: 'ubp.calculator.summary.orgNeedsCard.dropdownAriaLabel',
        defaultMessage: 'Meter'
    }
});
const $17f8fb3e78b6e6e0$export$db2d15e052816845 = ({ testId: testId })=>{
    const intl = (0, $8e22h.default)();
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const usageType = (0, $4xsw0.useSelector)((0, $hSUNh.selectUsageType));
    const usage = (0, $4xsw0.useSelector)((0, $hSUNh.selectUsage));
    const setUsageType = (0, $4xsw0.useSetUsageType)();
    const { low: low, high: high } = (0, $4xsw0.useSelector)((0, $hSUNh.selectEstimatedUsageRange));
    const locale = (0, $4xsw0.useSelector)((0, $hSUNh.getNumberFormatLocale));
    const orgNeedsCard = (0, $l4DCt.METER_CONTENT)[meter].summaryStep.orgNeedsCard;
    if (!orgNeedsCard) return null;
    // A custom usage value overrides the usageType estimate, so the
    // profile-driven controls (usage-type dropdown + value-prop footer)
    // no longer apply — hide both when a custom value is set.
    const hasCustomUsage = usage > 0;
    // Value-prop footer tracks the user's selected usage type from the
    // Needs step (Exploring / Adopting / Scaling). Switching the dropdown
    // here drives the same `usageType` context state, so the card content
    // stays in sync across steps.
    const valueProp = (0, $l4DCt.METER_CONTENT)[meter].usageProfiles[usageType].valueProp;
    const footerText = valueProp ? intl.formatMessage(valueProp) : undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $93kHd.ResultsCard), {
        eyebrow: intl.formatMessage(orgNeedsCard.eyebrow),
        headline: (0, $f1WTS.formatNumberRange)(low, high, locale),
        headlineSubtext: orgNeedsCard.headlineSubtext ? intl.formatMessage(orgNeedsCard.headlineSubtext) : intl.formatMessage($17f8fb3e78b6e6e0$var$messages.headlineSubtextFallback, {
            meterLabel: intl.formatMessage((0, $f1WTS.METER_LABEL_MESSAGES)[meter])
        }),
        // coverageText + bullets intentionally omitted per the 2026-07-17
        // design revision: the bold callout and duplicated bullet list were
        // removed for the OrgNeedsCard. The Needs-step ChoiceCard remains the
        // source of truth for `usageProfile.list`.
        footerNote: hasCustomUsage ? undefined : footerText,
        dropdown: hasCustomUsage ? undefined : {
            ariaLabel: intl.formatMessage($17f8fb3e78b6e6e0$var$messages.dropdownAriaLabel),
            // Source dropdown labels from the same meter-content registry that
            // powers the Needs step's usage-profile cards, so all surfaces stay
            // in sync per meter. Enum values stay meter-agnostic; only the
            // human-readable labels are per-meter.
            options: [
                'exploring',
                'adopting',
                'scaling'
            ].map((profileKey)=>({
                    value: profileKey,
                    label: intl.formatMessage((0, $l4DCt.METER_CONTENT)[meter].usageProfiles[profileKey].label)
                })),
            value: usageType,
            onChange: (value)=>setUsageType(value)
        },
        testId: testId
    });
};

});
parcelRegister("93kHd", function(module, exports) {
$parcel$export(module.exports, "ResultsCard", function () { return $1fe9b0855fddbdb4$export$eded4c54ca0c8242; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $gKWOC = parcelRequire("gKWOC");
const $1fe9b0855fddbdb4$export$eded4c54ca0c8242 = ({ eyebrow: eyebrow, headline: headline, headlineSubtext: headlineSubtext, coverageText: coverageText, bullets: bullets, dropdown: dropdown, footerNote: footerNote, testId: testId = 'results-card' })=>{
    // Stable ID for the native select's aria-label / label-for pairing.
    const uid = (0, $1oC0p.useId)();
    const selectId = dropdown ? `${testId}-${uid}-select` : undefined;
    // Locally-typed bullets array — avoids a non-null assertion in the
    // JSX below and gives TypeScript a narrowed `string[]` inside the guard.
    const safeBullets = Array.isArray(bullets) && bullets.length > 0 ? bullets : [];
    const hasBullets = safeBullets.length > 0;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            style: $1fe9b0855fddbdb4$var$cardStyle,
            "data-testid": testId,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: $1fe9b0855fddbdb4$var$cardInnerStyle,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        style: $1fe9b0855fddbdb4$var$contentStyle,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                style: $1fe9b0855fddbdb4$var$eyebrowStyle,
                                children: eyebrow
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                style: $1fe9b0855fddbdb4$var$recommendationStyle,
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        style: $1fe9b0855fddbdb4$var$headlineStyle,
                                        children: headline
                                    }),
                                    headlineSubtext ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        style: $1fe9b0855fddbdb4$var$headlineSubtextStyle,
                                        children: headlineSubtext
                                    }) : null
                                ]
                            }),
                            coverageText || hasBullets ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                style: $1fe9b0855fddbdb4$var$coverageStyle,
                                children: [
                                    coverageText ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        style: $1fe9b0855fddbdb4$var$coverageTextStyle,
                                        children: coverageText
                                    }) : null,
                                    hasBullets ? /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                        style: $1fe9b0855fddbdb4$var$bulletListStyle,
                                        children: safeBullets.map((bullet, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                                style: $1fe9b0855fddbdb4$var$bulletItemStyle,
                                                children: bullet
                                            }, `${bullet}-${index}`))
                                    }) : null
                                ]
                            }) : null,
                            dropdown ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                style: $1fe9b0855fddbdb4$var$dropdownWrapperStyle,
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gKWOC.Dropdown), {
                                    id: selectId ?? `${testId}-dropdown`,
                                    label: dropdown.ariaLabel,
                                    labelHidden: true,
                                    value: dropdown.value,
                                    options: dropdown.options.map((opt)=>({
                                            value: opt.value,
                                            label: opt.label
                                        })),
                                    onChange: dropdown.onChange
                                })
                            }) : null
                        ]
                    })
                }),
                footerNote ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: $1fe9b0855fddbdb4$var$footerStyle,
                    "data-testid": `${testId}-footer`,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $1fe9b0855fddbdb4$var$footerTextStyle,
                        children: footerNote
                    })
                }) : null
            ]
        })
    });
};
// ─────────────────────────────────────────────────────────────────────────
// Styles — matching Figma tokens from node 642:6143.
// The card lives in the calculator's estimate/summary steps; keep all
// styling colocated so future designers can eyeball it in one place.
// ─────────────────────────────────────────────────────────────────────────
const $1fe9b0855fddbdb4$var$cardStyle = {
    // Figma: neutral/opaque/neutral100 (#F8F8F8), 20px rounded corners,
    // no border. NOTE: we intentionally do NOT set `overflow: hidden`
    // here — that would clip the Dropdown's inline listbox popup when
    // the "usage level" dropdown opens near the bottom of the card. To
    // keep the blue footer's bottom corners rounded to match the card,
    // the footer style below applies `borderRadius: 0 0 20px 20px`
    // directly. The footer's TOP corners are naturally square, which is
    // what Figma shows (band spans full width flush against the card).
    backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light100'),
    borderRadius: '20px',
    // Column flex so the value-add footer sits flush against the bottom.
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%'
};
const $1fe9b0855fddbdb4$var$cardInnerStyle = {
    // Figma padding: 20px sides, 20px top, 32px bottom.
    padding: '20px 20px 32px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%',
    boxSizing: 'border-box'
};
const $1fe9b0855fddbdb4$var$contentStyle = {
    // Figma gap: space/300 (24px) between eyebrow / recommendation /
    // coverage / dropdown sections.
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    alignItems: 'stretch'
};
const $1fe9b0855fddbdb4$var$eyebrowStyle = {
    // Figma "More Styles / Eyebrow - Regular": 14/18 Charlie Text Regular,
    // uppercase, Primary Black at 80% opacity.
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 400,
    letterSpacing: 0,
    textTransform: 'uppercase',
    // Figma spec uses `rgba(0,0,0,0.8)`. WAC's design system has no
    // opacity-adjusted token that matches exactly; using the solid Primary
    // Black (`color.neutral.light1100` = #101214) provides equivalent
    // contrast and stays token-compliant.
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $1fe9b0855fddbdb4$var$recommendationStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '0px',
    alignItems: 'stretch'
};
const $1fe9b0855fddbdb4$var$headlineStyle = {
    // Figma "Desktop / D - H3": 32/38 Charlie Display Bold, tracking 0.3px.
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.display'),
    fontSize: '32px',
    lineHeight: '38px',
    fontWeight: 700,
    letterSpacing: '0.3px',
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $1fe9b0855fddbdb4$var$headlineSubtextStyle = {
    // Figma "Desktop / D - Body Medium": 16/24 Charlie Text Regular.
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $1fe9b0855fddbdb4$var$coverageStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'stretch'
};
const $1fe9b0855fddbdb4$var$coverageTextStyle = {
    // Figma "Desktop / D - Body Medium - Bold": 16/24 Charlie Text Bold.
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 700,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $1fe9b0855fddbdb4$var$bulletListStyle = {
    margin: 0,
    // 21px left indent from Figma matches the ContentBlock bullet spec.
    paddingInlineStart: '21px',
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100'),
    listStyle: 'disc'
};
const $1fe9b0855fddbdb4$var$bulletItemStyle = {
    // Figma: 8px between bullets. Last-child handled by natural absence of margin.
    marginBottom: '8px'
};
const $1fe9b0855fddbdb4$var$dropdownWrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
};
const $1fe9b0855fddbdb4$var$footerStyle = {
    // Figma "value add": Extended/Blues/B100 (#E9F2FE) bg, 12px padding.
    // Bottom corners rounded to match the outer card's 20px radius since
    // the card no longer clips overflow (see cardStyle comment for why).
    backgroundColor: (0, $kbpa7.wacToken)('color.extended.blue100'),
    padding: '12px',
    borderRadius: '0 0 20px 20px',
    display: 'flex',
    alignItems: 'flex-start'
};
const $1fe9b0855fddbdb4$var$footerTextStyle = {
    margin: 0,
    flex: 1,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};

});
parcelRegister("gKWOC", function(module, exports) {
$parcel$export(module.exports, "Dropdown", function () { return $d36717d2231e846c$export$931cbfb6bfb85fc; });
/* dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $d36717d2231e846c$export$931cbfb6bfb85fc = (props)=>{
    const { id: id, label: label, labelHidden: labelHidden, value: value, options: options, onChange: onChange } = props;
    const [open, setOpen] = (0, $1oC0p.useState)(false);
    const [focused, setFocused] = (0, $1oC0p.useState)(false);
    const [activeIndex, setActiveIndex] = (0, $1oC0p.useState)(-1);
    const groupRef = (0, $1oC0p.useRef)(null);
    const triggerRef = (0, $1oC0p.useRef)(null);
    const listRef = (0, $1oC0p.useRef)(null);
    const typeahead = (0, $1oC0p.useRef)({
        query: '',
        timer: null
    });
    const labelId = `${id}-label`;
    const listboxId = `${id}-listbox`;
    const optionId = (index)=>`${id}-option-${index}`;
    const selectedIndex = options.findIndex((option)=>String(option.value) === String(value));
    const selected = selectedIndex >= 0 ? options[selectedIndex] : undefined;
    // Close on outside click. Escape and keyboard navigation are handled on the
    // options themselves so focus can be returned to the trigger.
    (0, $1oC0p.useEffect)(()=>{
        if (!open) return;
        const handlePointerDown = (event)=>{
            if (!groupRef.current?.contains(event.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handlePointerDown);
        return ()=>{
            document.removeEventListener('mousedown', handlePointerDown);
        };
    }, [
        open
    ]);
    const scrollActiveIntoView = (index)=>{
        const el = listRef.current?.children[index];
        if (el instanceof HTMLElement) el.scrollIntoView({
            block: 'nearest'
        });
    };
    // When the menu opens, highlight the currently selected option (or the
    // first option). Focus stays on the trigger throughout — the active option
    // is tracked via aria-activedescendant and the gray background, never by
    // moving DOM focus.
    (0, $1oC0p.useEffect)(()=>{
        if (open) {
            const index = selectedIndex >= 0 ? selectedIndex : 0;
            setActiveIndex(index);
            scrollActiveIntoView(index);
        } else {
            setActiveIndex(-1);
            typeahead.current.query = '';
        }
    // selectedIndex intentionally read only on the open transition
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    const moveActiveTo = (index)=>{
        if (options.length === 0) return;
        const next = Math.max(0, Math.min(index, options.length - 1));
        setActiveIndex(next);
        scrollActiveIntoView(next);
    };
    const selectByIndex = (index)=>{
        const option = options[index];
        if (!option) return;
        onChange(String(option.value));
        setOpen(false);
        triggerRef.current?.focus();
    };
    const runTypeahead = (key)=>{
        if (typeahead.current.timer !== null) window.clearTimeout(typeahead.current.timer);
        typeahead.current.query += key.toLowerCase();
        const query = typeahead.current.query;
        const match = options.findIndex((option)=>option.label.toLowerCase().startsWith(query));
        if (match >= 0) moveActiveTo(match);
        typeahead.current.timer = window.setTimeout(()=>{
            typeahead.current.query = '';
        }, 500);
    };
    const handleOpenKeyDown = (event)=>{
        switch(event.key){
            case 'ArrowDown':
                event.preventDefault();
                moveActiveTo(activeIndex + 1);
                break;
            case 'ArrowUp':
                event.preventDefault();
                moveActiveTo(activeIndex - 1);
                break;
            case 'Home':
                event.preventDefault();
                moveActiveTo(0);
                break;
            case 'End':
                event.preventDefault();
                moveActiveTo(options.length - 1);
                break;
            case 'Enter':
            case ' ':
                // Prevent the native button click from re-toggling the menu.
                event.preventDefault();
                selectByIndex(activeIndex);
                break;
            case 'Escape':
                event.preventDefault();
                setOpen(false);
                break;
            case 'Tab':
                // Collapse the menu; focus is already on the trigger.
                setOpen(false);
                break;
            default:
                if (event.key.length === 1 && !event.metaKey && !event.ctrlKey) runTypeahead(event.key);
        }
    };
    const handleTriggerKeyDown = (event)=>{
        if (open) {
            handleOpenKeyDown(event);
            return;
        }
        // Menu closed: opening keys only; Enter/Space fall through to the
        // native button click that toggles the menu open.
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            setOpen(true);
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: groupRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm _16jlkb7n _1o9zkb7n _i0dlf1ug _1ul911ux _1fe7idpf"
        ]),
        children: [
            !labelHidden && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                id: labelId,
                htmlFor: id,
                className: (0, $2jatx.default)([
                    "_1e0c1ule _ect4z4z1 _1wyb1crf _syazk0sw _6rthu2gc"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                    "--_1e97w25": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light700'))
                },
                children: label
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                id: id,
                ref: triggerRef,
                type: "button",
                role: "combobox",
                "aria-haspopup": "listbox",
                "aria-expanded": open,
                "aria-controls": open ? listboxId : undefined,
                "aria-activedescendant": open && activeIndex >= 0 ? optionId(activeIndex) : undefined,
                ...labelHidden ? {
                    'aria-label': label
                } : {
                    'aria-labelledby': `${labelId} ${id}`
                },
                onClick: ()=>setOpen((prev)=>!prev),
                onKeyDown: handleTriggerKeyDown,
                onFocus: ()=>setFocused(true),
                onBlur: ()=>setFocused(false),
                className: (0, $2jatx.default)([
                    "_1bsb1osq _r06hglyw _y3gn1e5h _bfhk1afi _19it79pa _2rkogktf _ca0qftgi _u5f3zwfg _n3tdftgi _19bv7vkz _ect4z4z1 _1wyb7vkz _syaz1pfd _80omtlke _1itk1sgq _12vemgnk _ouxl16pt",
                    focused && "_1a371qgu _1cwgidpf"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: selected?.label ?? ''
            }),
            open && /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                id: listboxId,
                ref: listRef,
                role: "listbox",
                ...labelHidden ? {
                    'aria-label': label
                } : {
                    'aria-labelledby': labelId
                },
                onMouseLeave: ()=>setActiveIndex(selectedIndex),
                onBlur: ()=>setActiveIndex(selectedIndex),
                className: (0, $2jatx.default)([
                    "_kqswstnw _152t1osq _dk5didpf _6rthidpf _1pfh1b66 _1pbykb7n _vchhusvi _qtt8glyw _1e0c1txw _2lx21bp4 _4cvr1y6m _1wpz1fhb _1yt4u2gc _2rko1y44 _19it1ixx _11q71afi _16qs130s"
                ]),
                style: {
                    "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: options.map((option, index)=>{
                    const isSelected = String(option.value) === String(value);
                    const isActive = activeIndex === index;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                        role: "presentation",
                        className: (0, $2jatx.default)([
                            "_1wpz1fhb _1bsb1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            type: "button",
                            id: optionId(index),
                            role: "option",
                            "aria-selected": isSelected,
                            tabIndex: -1,
                            // Keep focus on the trigger when clicking.
                            onMouseDown: (event)=>event.preventDefault(),
                            onMouseEnter: ()=>setActiveIndex(index),
                            onFocus: ()=>setActiveIndex(index),
                            onClick: ()=>selectByIndex(index),
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _1bsb1osq _zulputpp _1yt4u2gc _2rko1y44 _80omtlke _r06hglyw _19itglyw _bfhk1afi _y3gn1e5h _11c81kw7",
                                isActive && "_bfhkg7ng"
                            ]),
                            style: {
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_syaz1pfd _1iqs1jhh _ect4z4z1 _1wyb7vkz _zg8l4jg8 _k48p1nn1 _vwz41tcg"
                                ]),
                                style: {
                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: option.label
                            })
                        })
                    }, option.value);
                })
            })
        ]
    });
};
const $d36717d2231e846c$var$dropdownGroupStyles = null;
const $d36717d2231e846c$var$dropdownLabelStyles = null;
const $d36717d2231e846c$var$triggerStyles = null;
const $d36717d2231e846c$var$triggerFocusStyles = null;
const $d36717d2231e846c$var$menuStyles = null;
const $d36717d2231e846c$var$presentationItemStyles = null;
const $d36717d2231e846c$var$optionButtonStyles = null;
const $d36717d2231e846c$var$itemHoveredStyles = null;
const $d36717d2231e846c$var$itemTextStyles = null;

});


parcelRegister("f1WTS", function(module, exports) {
$parcel$export(module.exports, "METER_LABEL_MESSAGES", function () { return $f9a8942f61abe515$export$db47379d98116c6f; });
$parcel$export(module.exports, "collectionAllowanceMessage", function () { return $f9a8942f61abe515$export$74526bcbf9764c3c; });
$parcel$export(module.exports, "formatNumber", function () { return $f9a8942f61abe515$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatPrice", function () { return $f9a8942f61abe515$export$c86caf1be068fb8d; });
$parcel$export(module.exports, "formatNumberRange", function () { return $f9a8942f61abe515$export$41043ef248f9bef2; });
$parcel$export(module.exports, "formatPriceRange", function () { return $f9a8942f61abe515$export$eccd4d6fa21cd337; });
$parcel$export(module.exports, "buildOverageRateValues", function () { return $f9a8942f61abe515$export$317adb464ac969db; });

var $fnHPc = parcelRequire("fnHPc");

var $bYgvL = parcelRequire("bYgvL");
const $f9a8942f61abe515$export$db47379d98116c6f = (0, $fnHPc.defineMessages)({
    rovoCredits: {
        id: 'ubp.calculator.meterLabel.rovoCredits',
        defaultMessage: 'Rovo credits'
    },
    automations: {
        id: 'ubp.calculator.meterLabel.automations',
        defaultMessage: 'Automation steps'
    },
    csResolutions: {
        id: 'ubp.calculator.meterLabel.csResolutions',
        defaultMessage: 'AI agent resolutions'
    },
    assetsObjects: {
        id: 'ubp.calculator.meterLabel.assetsObjects',
        defaultMessage: 'Assets objects'
    }
});
const $f9a8942f61abe515$export$74526bcbf9764c3c = (0, $fnHPc.defineMessage)({
    id: 'ubp.calculator.productcard.collectionAllowance',
    defaultMessage: '{allowance} {meterLabel}'
});
const $f9a8942f61abe515$export$f5dd818bff069720 = (value, locale)=>new Intl.NumberFormat(locale, {
        maximumFractionDigits: 0
    }).format(value);
const $f9a8942f61abe515$export$c86caf1be068fb8d = (price, options)=>{
    const { currency: currency, locale: locale, fractionDigits: fractionDigits = 0 } = options;
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    }).format(price);
};
const $f9a8942f61abe515$export$41043ef248f9bef2 = (low, high, locale)=>low === high ? $f9a8942f61abe515$export$f5dd818bff069720(low, locale) : `${$f9a8942f61abe515$export$f5dd818bff069720(low, locale)}\u{2013}${$f9a8942f61abe515$export$f5dd818bff069720(high, locale)}`;
const $f9a8942f61abe515$export$eccd4d6fa21cd337 = (low, high, options)=>low === high ? `${options.currency} ${$f9a8942f61abe515$export$c86caf1be068fb8d(low, options)}` : `${options.currency} ${$f9a8942f61abe515$export$c86caf1be068fb8d(low, options)}\u{2013}${$f9a8942f61abe515$export$f5dd818bff069720(high, options.locale)}`;
const $f9a8942f61abe515$export$317adb464ac969db = (args)=>{
    const { meter: meter, currency: currency, locale: locale } = args;
    return (0, $bYgvL.getOverageRateTiers)(meter).reduce((values, tier, index)=>{
        values[index === 0 ? 'rate' : `rate${index + 1}`] = `${currency} ${$f9a8942f61abe515$export$c86caf1be068fb8d(tier.price, {
            currency: currency,
            locale: locale,
            fractionDigits: Number.isInteger(tier.price) ? 0 : 2
        })}`;
        return values;
    }, {});
};

});


parcelRegister("b7cuD", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $455cb044e5dc04ab$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $455cb044e5dc04ab$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    restart: {
        id: 'ubp.calculator.restart',
        defaultMessage: 'Restart'
    }
});

});

parcelRegister("f8Axo", function(module, exports) {
$parcel$export(module.exports, "ShareButton", function () { return $0c13ec0efd8426d8$export$e980dfbc2840e8bc; });
/* share-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $hrBjL = parcelRequire("hrBjL");

var $8DbjG = parcelRequire("8DbjG");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $kdccD = parcelRequire("kdccD");
const $0c13ec0efd8426d8$var$messages = (0, $fnHPc.defineMessages)({
    defaultLabel: {
        id: 'ubp.calculator.share.defaultLabel',
        defaultMessage: 'Copy link to share'
    },
    copiedToClipboard: {
        id: 'ubp.calculator.share.copiedToClipboard',
        defaultMessage: 'Copied to clipboard'
    },
    /** Fallback prompt when the Clipboard API is unavailable (insecure context). */ copyUrlPrompt: {
        id: 'ubp.calculator.share.copyUrlPrompt',
        defaultMessage: 'Copy this URL:'
    }
});
const $0c13ec0efd8426d8$export$e980dfbc2840e8bc = ({ label: label, onShare: onShareCallback } = {})=>{
    const intl = (0, $8e22h.default)();
    const resolvedLabel = label ?? intl.formatMessage($0c13ec0efd8426d8$var$messages.defaultLabel);
    const query = (0, $4xsw0.useSelector)((0, $hSUNh.selectShareableQuery));
    // Popup open state — anchored to the button, dismissed after a short
    // timeout so it behaves like a passive confirmation, not a modal.
    const [isCopiedOpen, setIsCopiedOpen] = (0, $1oC0p.useState)(false);
    const dismissTimerRef = (0, $1oC0p.useRef)(null);
    // Clean up the auto-dismiss timer if the component unmounts before it
    // fires — otherwise React logs a "state update on unmounted component"
    // warning in dev.
    (0, $1oC0p.useEffect)(()=>{
        return ()=>{
            if (dismissTimerRef.current) clearTimeout(dismissTimerRef.current);
        };
    }, []);
    const onShare = (0, $1oC0p.useCallback)(async ()=>{
        onShareCallback?.();
        const url = $0c13ec0efd8426d8$var$buildShareUrl((0, $kdccD.toQueryString)(query));
        try {
            await navigator.clipboard.writeText(url);
            setIsCopiedOpen(true);
            if (dismissTimerRef.current) clearTimeout(dismissTimerRef.current);
            dismissTimerRef.current = setTimeout(()=>setIsCopiedOpen(false), 2000);
        } catch  {
            // Clipboard may be unavailable (e.g. insecure context) — fall back.
            window.prompt(intl.formatMessage($0c13ec0efd8426d8$var$messages.copyUrlPrompt), url);
        }
    }, [
        query,
        onShareCallback,
        intl
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c116y"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                variant: "primary",
                size: "small",
                onClick: onShare,
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                    style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8DbjG))), {
                            label: ""
                        }),
                        resolvedLabel
                    ]
                })
            }),
            isCopiedOpen ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                role: "status",
                "aria-live": "polite",
                className: (0, $2jatx.default)([
                    "_kqswstnw _u7co54a6 _1e021ssb _t9eczr6s _1e0c116y _4cvr1h6o _zulpu2gc _1rjcu2gc _18zrpxbi _bfhk1bhr _2rko1y44 _16qs130s _1wybdlk8 _vwz4gktf _syazrf0c _o5721q9c _1pbyb4wl"
                ]),
                style: {
                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hrBjL))), {
                        label: "",
                        color: "var(--ds-icon-success, #6A9A23)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: intl.formatMessage($0c13ec0efd8426d8$var$messages.copiedToClipboard)
                    })
                ]
            }) : null
        ]
    });
};
// Wrapper — provides the position: relative anchor for the confirmation.
// Inline-flex keeps it sized to the button's width.
const $0c13ec0efd8426d8$var$sharePositionWrapperStyle = null;
// Copy confirmation bubble — positioned directly above the button.
// Uses ADS elevation.surface.overlay + shadow to read as a floating hint.
const $0c13ec0efd8426d8$var$copiedBubbleStyle = null;
const $0c13ec0efd8426d8$var$buildShareUrl = (queryString)=>{
    const { origin: origin, pathname: pathname } = window.location;
    return `${origin}${pathname}${queryString ? `?${queryString}` : ''}`;
};

});


parcelRegister("dEuk8", function(module, exports) {
$parcel$export(module.exports, "NeedsStep", function () { return $d8baf1a85e15b192$export$e20aa7cd146c54c8; });
/* needs-step.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $l4DCt = parcelRequire("l4DCt");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $3h32c = parcelRequire("3h32c");

var $ahF4L = parcelRequire("ahF4L");

var $24e6W = parcelRequire("24e6W");

var $ehiBJ = parcelRequire("ehiBJ");

var $cIZNT = parcelRequire("cIZNT");

var $f1WTS = parcelRequire("f1WTS");
/**
 * Default Step 2 CTA, used when a meter doesn't override `needsStep.nextCta`.
 * Lives here rather than in the content files so the shared default isn't
 * duplicated across all four meters.
 */ const $d8baf1a85e15b192$var$fallbackMessages = (0, $fnHPc.defineMessages)({
    nextCta: {
        id: 'ubp.calculator.needs.nextCta',
        defaultMessage: 'Get estimate'
    }
});
/**
 * Hover / focus controlled help-tooltip used on the "Do you know your
 * usage?" heading (Figma nodes 2023:11772 + 1843:3742).
 *
 * Why not `@atlaskit/tooltip`?
 * We initially wired this up with `@atlaskit/tooltip`, which is the
 * WAC-blessed pattern for hover help elsewhere in the codebase. Inside
 * the usage-based-pricing calculator shell it consistently rendered its
 * portalled bubble at `top: ~1500px, left: 0` — hundreds of pixels
 * below the anchor button — regardless of `position`, `strategy`, or a
 * custom `component` override. Instrumented onShow/onHide/mouseenter/
 * mouseleave logs confirmed the show event was firing and the portal
 * was mounting at document.body, but the underlying `@atlaskit/popper`
 * position calculation was silently defaulting to (0, viewportBottom).
 * The root cause is likely something specific about the calculator
 * shell's stacking / ancestor CSS interaction with atlaskit's popper,
 * but we couldn't isolate it after several rounds of debugging.
 *
 * This custom implementation gives us:
 *   - reliable positioning (absolute, relative to the anchor span)
 *   - pixel-perfect Figma-spec styling (black bg, 20px radius,
 *     16px padding, Charlie Text 14/20, elevation shadow)
 *   - the same a11y story (`role="tooltip"` on the bubble,
 *     `aria-label` on the trigger button, focus + hover parity)
 *   - no portal / no popper / no atlaskit dependency for this element
 *
 * If we later find a fix for the atlaskit positioning issue we can
 * revert to `<Tooltip>` — the API surface here is intentionally minimal
 * (`label` + `text`) so the swap is a small drop-in.
 */ const $d8baf1a85e15b192$var$UsageHelpTooltip = ({ label: label, text: text })=>{
    const [visible, setVisible] = (0, $1oC0p.useState)(false);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c116y"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                "aria-label": label,
                onMouseEnter: ()=>setVisible(true),
                onMouseLeave: ()=>setVisible(false),
                onFocus: ()=>setVisible(true),
                onBlur: ()=>setVisible(false),
                className: (0, $2jatx.default)([
                    "_r06hglyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81kw7 _1e0c116y _4cvr1h6o _1bah1h6o _80omtlke _lcxv1wug _bfhkrf0c _1bsbgktf _4t3igktf _2rko1ssb _syaz1afi _irr3lkxj _1ygb1qgu _1ah3yh40"
                ]),
                style: {
                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_1px5u0o": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1000')),
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    "aria-hidden": "true",
                    className: (0, $2jatx.default)([
                        "_1wybdlk8 _k48p1fw0 _vwz4kb7n _ect4z4z1"
                    ]),
                    style: {
                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                    },
                    children: "?"
                })
            }),
            visible && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                role: "tooltip",
                className: (0, $2jatx.default)([
                    "_kqswstnw _u7co54a6 _1e021ssb _t9eczr6s _1ul9uuw1 _p12fnklw _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _2rkogktf _bfhkrf0c _syaz1afi _1wybdlk8 _vwz4gktf _ect4z4z1 _y3gn1e5h _16qs130s _1pbyb4wl _lcxvglyw"
                ]),
                style: {
                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                },
                children: text
            })
        ]
    });
};
const $d8baf1a85e15b192$export$e20aa7cd146c54c8 = ()=>{
    const intl = (0, $8e22h.default)();
    const usageType = (0, $4xsw0.useSelector)((0, $hSUNh.selectUsageType));
    const setUsageType = (0, $4xsw0.useSetUsageType)();
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const usage = (0, $4xsw0.useSelector)((0, $hSUNh.selectUsage));
    const setUsage = (0, $4xsw0.useSetUsage)();
    const fireStep2Viewed = (0, $3h32c.useUbpStep2ScreenViewedEvent)();
    const fireUsageProfileSelected = (0, $3h32c.useUbpUsageProfileSelectedEvent)();
    const fireStep2GetEstimate = (0, $3h32c.useUbpStep2GetEstimateClickedEvent)();
    const fireStep2Back = (0, $3h32c.useUbpStep2BackClickedEvent)();
    (0, $1oC0p.useEffect)(()=>{
        fireStep2Viewed();
    // Intentionally run once on mount only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const NEEDS_STRINGS = (0, $1oC0p.useMemo)(()=>Object.keys((0, $l4DCt.METER_CONTENT)[meter].usageProfiles).reduce((acc, key)=>{
            const profile = (0, $l4DCt.METER_CONTENT)[meter].usageProfiles[key];
            acc[key] = {
                label: intl.formatMessage(profile.label),
                description: intl.formatMessage(profile.description),
                usageRange: profile.usageRange ? intl.formatMessage(profile.usageRange) : undefined,
                info: profile.valueProp ? intl.formatMessage(profile.valueProp) : undefined,
                list: profile.list?.map((item)=>({
                        text: intl.formatMessage(item)
                    }))
            };
            return acc;
        }, {}), [
        intl,
        meter
    ]);
    const needsTypes = Object.keys(NEEDS_STRINGS);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jsxHL.TypographyStyles), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cIZNT.Stepper), {
                visibleStepCount: 3
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q511ylp"
                ]),
                children: intl.formatMessage({
                    id: 'ubp.calculator.needs.pageTitle',
                    defaultMessage: 'Tell us about your team\u2019s usage'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                id: "needs-step-heading",
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q51u2gc _85i51ylp _1wyb1k92 _vwz41m1q _k48p1nn1 _syazrf0c"
                ]),
                style: {
                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
                },
                children: intl.formatMessage({
                    id: 'ubp.calculator.needs.pageSubtitle',
                    defaultMessage: 'Choose one option that best describes how your team will use {meterLabel} each month'
                }, {
                    meterLabel: intl.formatMessage((0, $f1WTS.METER_LABEL_MESSAGES)[meter])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "radiogroup",
                "aria-labelledby": "needs-step-heading",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulpxy5q _yv0e1ckl _81641ejb _19d7hkll"
                ]),
                children: needsTypes.map((choice)=>{
                    const { label: label, description: description, list: list, info: info } = NEEDS_STRINGS[choice];
                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ahF4L.ChoiceCard), {
                        value: choice,
                        selected: usage === 0 && usageType === choice,
                        onSelect: ()=>{
                            setUsageType(choice);
                            setUsage(0);
                            fireUsageProfileSelected(choice);
                        },
                        groupName: "group-needs",
                        label: label,
                        description: description,
                        list: list,
                        info: info
                    }, `needs-${choice}`);
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1yt41yj3 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1wyboxwj _1dyz303w _kqswh2mm _syazk0sw _1yt4pxbi _1p1dangw _aetrb3bt _1kt9b3bt _19nqidpf _iajmidpf _1gufidpf _1fkridpf _18postnw _1cs8stnw _z0ai1c3h _1mp41c3h _1qdgt94y _kfgtt94y _j8d61wug _pasc1wug _1av21wug _eid31wug _1doy1wug _zr3e1wug _pfzt1wug _fntn1wug _16r26u2e _1s6k6u2e _1enw1osq _g0nf1osq"
                    ]),
                    style: {
                        "--_1e97w25": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light700')),
                        "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
                    },
                    children: intl.formatMessage({
                        id: 'ubp.calculator.needs.usage.or',
                        defaultMessage: 'Or'
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulppxbi _1n261g80 _1q51xy5q _85i51jfw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                id: "usage-label",
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                    htmlFor: "usage",
                                    children: intl.formatMessage((0, $l4DCt.METER_CONTENT)[meter].needsStep.doYouKnowQuestion)
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)($d8baf1a85e15b192$var$UsageHelpTooltip, {
                                label: intl.formatMessage({
                                    id: 'ubp.calculator.needs.usageQuestionTooltipLabel',
                                    defaultMessage: 'More information about usage'
                                }),
                                text: intl.formatMessage({
                                    id: 'ubp.calculator.needs.usageQuestionTooltip',
                                    defaultMessage: 'Your estimated monthly usage for each meter'
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _zulppxbi"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $24e6W.NumericInput), {
                                id: "usage",
                                value: usage,
                                min: 0,
                                // Narrower than the default 160 so the H3 question
                                // (which for meters like "Automation steps" is
                                // visibly longer than the Rovo credits variant) has
                                // more room on the shared row before wrapping.
                                width: 120,
                                "aria-labelledby": "usage-label",
                                onChange: (next)=>setUsage(next ?? 0)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1wyboxwj _vwz4gktf _syazrf0c"
                                ]),
                                style: {
                                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
                                },
                                children: intl.formatMessage({
                                    id: 'ubp.calculator.needs.overrides',
                                    defaultMessage: 'Overrides any profile selected above'
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ehiBJ.StepNav), {
                showBack: true,
                showNext: true,
                nextLabel: intl.formatMessage((0, $l4DCt.METER_CONTENT)[meter].needsStep.nextCta ?? $d8baf1a85e15b192$var$fallbackMessages.nextCta),
                onBeforeNext: fireStep2GetEstimate,
                onBeforeBack: fireStep2Back
            })
        ]
    });
};
// Page title — rendered as an H3 (Charlie Display Bold 32/38 via
// TypographyStyles). Left-aligned per Figma; 40px top padding keeps the title
// spaced from the Stepper, and the subtitle below owns the bottom spacing so
// the title + subtitle stay visually grouped.
const $d8baf1a85e15b192$var$pageTitleStyle = null;
// Body Large subtitle beneath the H3 title. Charlie Text 20/28 with the
// standard neutral text color. Sits directly under the title with a small gap
// above (space.100) and 40px padding below to separate the title/subtitle
// pair from the choice-card grid. The visible copy dynamically references the
// meter chosen in the previous step (e.g. "Rovo Credits", "Automations", "CS
// Resolutions", "Assets Objects") via ICU `{meterLabel}` interpolation.
const $d8baf1a85e15b192$var$pageSubtitleStyle = null;
const $d8baf1a85e15b192$var$cardGridStyle = null;
const $d8baf1a85e15b192$var$orCss = null;
const $d8baf1a85e15b192$var$orLabel = null;
// Wraps the usage-question H3 and the input + "Optional" indicator so they sit
// on the same row — mirrors usage-step.tsx's orgSizeQuestionStyle so both steps
// share the same input row treatment. 60px top padding lives on the row
// wrapper so both sides shift together and stay vertically aligned.
const $d8baf1a85e15b192$var$usageQuestionStyle = null;
// Places the H3 label and the `?` help icon side-by-side, vertically
// centered on the label baseline. Used to attach the tooltip trigger
// inline with the question heading per Figma node 2023:11772.
const $d8baf1a85e15b192$var$usageQuestionRowStyle = null;
// Bare button wrapper for the `?` icon per Figma node 2023:11772.
// We render a solid black circle with a white `?` glyph via a plain
// text character (not an SVG icon) to avoid conflicts with atlaskit
// icon strokes. The button uses a real <button> (not a <span>) so
// it's keyboard-focusable and meets WCAG for interactive UI — it's
// the tooltip trigger inside `UsageHelpTooltip`.
const $d8baf1a85e15b192$var$helpIconButtonStyle = null;
// Plain `?` glyph — bold, tight line-height so it centers cleanly inside the
// 20×20 button without any built-in icon stroke.
const $d8baf1a85e15b192$var$helpIconGlyphStyle = null;
// Positions the ? button relative to its tooltip bubble so the bubble
// can absolutely-position itself above/beside the button.
const $d8baf1a85e15b192$var$helpTooltipAnchorStyle = null;
// Tooltip bubble per Figma node 1843:3742. Rendered as an
// absolutely-positioned <span> above the `?` button (no portal, no
// popper). See the doc comment on `UsageHelpTooltip` above for why we
// went custom instead of `@atlaskit/tooltip`.
const $d8baf1a85e15b192$var$helpTooltipBubbleStyle = null;
const $d8baf1a85e15b192$var$usageQuestionHeadingStyle = null;
// Places the number input and the "Optional" indicator side-by-side, with the
// label vertically centered on the input.
const $d8baf1a85e15b192$var$inputAndOptionalStyle = null;
const $d8baf1a85e15b192$var$optionalLabelStyle = null;

});
parcelRegister("24e6W", function(module, exports) {
$parcel$export(module.exports, "NumericInput", function () { return $488887e415f0c2c3$export$155c12e5e618c06c; });
/* numeric-input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $f1WTS = parcelRequire("f1WTS");

var $lb2uy = parcelRequire("lb2uy");
const $488887e415f0c2c3$export$155c12e5e618c06c = (props)=>{
    const { id: id, value: value, onChange: onChange, min: min, max: max, placeholder: placeholder, variant: variant = 'field', width: width, invalid: invalid, onBlur: onBlur, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, 'aria-required': ariaRequired } = props;
    const locale = (0, $4xsw0.useSelector)($hSUNh.getNumberFormatLocale);
    const toDisplayString = (v)=>v === undefined || v === 0 ? '' : (0, $f1WTS.formatNumber)(v, locale);
    const inputRef = (0, $lb2uy.useDisableWheel)();
    const [displayValue, setDisplayValue] = (0, $1oC0p.useState)(toDisplayString(value));
    // Sync display value when the parent value changes externally (e.g. a reset).
    (0, $1oC0p.useEffect)(()=>{
        setDisplayValue(toDisplayString(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        value
    ]);
    const handleChange = (e)=>{
        // Strip the thousands separators (and any other non-digits) before parsing.
        const digits = e.target.value.replace(/\D/g, '');
        if (digits === '') {
            setDisplayValue('');
            onChange(undefined);
            return;
        }
        const parsed = parseInt(digits, 10);
        if (isNaN(parsed)) return;
        const clamped = min !== undefined && max !== undefined ? Math.min(max, Math.max(min, parsed)) : min !== undefined ? Math.max(min, parsed) : max !== undefined ? Math.min(max, parsed) : parsed;
        // Re-format with thousands separators (also drops any leading zeros).
        setDisplayValue((0, $f1WTS.formatNumber)(clamped, locale));
        onChange(clamped);
    };
    const handleBlur = ()=>{
        const digits = displayValue.replace(/\D/g, '');
        onBlur?.(digits === '' ? undefined : parseInt(digits, 10));
    };
    // Stop the arrow keys from stepping the value, mirroring the scroll-wheel.
    // Block '-', 'e', and '.' so only whole non-negative numbers can be typed.
    const handleKeyDown = (e)=>{
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault();
        if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '.') e.preventDefault();
    };
    // Dynamic width override; applied only when provided so the variant's
    // default width still wins when `width` is omitted.
    const widthStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
        ref: inputRef,
        id: id,
        type: "text",
        inputMode: "numeric",
        "aria-invalid": invalid || undefined,
        value: displayValue,
        placeholder: placeholder,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-required": ariaRequired,
        onChange: handleChange,
        onBlur: onBlur ? handleBlur : undefined,
        onKeyDown: handleKeyDown,
        autoComplete: "off",
        className: (0, $2jatx.default)([
            "_r06hglyw _13di444r _bfhk1afi _19it79pa _1rjcu2gc _18zrpxbi _jh1sglyw _ii5aidpf _78z1idpf _urk4idpf _j0mvidpf _ji0mglyw _1sm7idpf _1ahuidpf _vgtdidpf _15c1idpf",
            variant === 'inline' ? "_1wyb1kw7 _syaz1pfd _2rko1mv1" : "_1bsb1lit _4t3i1ylp _1wyb1j6v _vwz41tcg _2rkogktf _syazrf0c",
            width !== undefined && "_1bsb9tg7",
            invalid && "_189eyh40 _1h6d1d19 _1mb81l7b _nt751r31 _49pcglyw _1hvwidpf"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_hjrx1n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.pill')),
            "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100')),
            "--_1ea5ebz": (0, $6ZVlx.default)(width),
            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
        }
    });
};
const $488887e415f0c2c3$var$baseInputStyles = null;
const $488887e415f0c2c3$var$fieldVariantStyles = null;
const $488887e415f0c2c3$var$inlineVariantStyles = null;
const $488887e415f0c2c3$var$invalidStyles = null;

});
parcelRegister("lb2uy", function(module, exports) {
$parcel$export(module.exports, "useDisableWheel", function () { return $6bcd8bdc4f93bd6f$export$e0ae8649f3cb2c59; });

var $1oC0p = parcelRequire("1oC0p");
function $6bcd8bdc4f93bd6f$export$e0ae8649f3cb2c59() {
    const ref = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        const el = ref.current;
        const handleWheel = (e)=>{
            // Only intervene while focused — an unfocused input already scrolls
            // the page and leaves its value untouched.
            if (document.activeElement !== el) return;
            e.preventDefault();
            window.scrollBy({
                top: e.deltaY
            });
        };
        el?.addEventListener('wheel', handleWheel, {
            passive: false
        });
        return ()=>{
            el?.removeEventListener('wheel', handleWheel);
        };
    }, []);
    return ref;
}

});



parcelRegister("jESEJ", function(module, exports) {
$parcel$export(module.exports, "SummaryStep", function () { return $add1ab1e0ec10174$export$a9efd057ccbc1d85; });
/* summary-step.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $5EeVR = parcelRequire("5EeVR");

var $l4DCt = parcelRequire("l4DCt");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $3h32c = parcelRequire("3h32c");

var $8wHAz = parcelRequire("8wHAz");

var $iZlze = parcelRequire("iZlze");

var $loMPq = parcelRequire("loMPq");

var $fGqzr = parcelRequire("fGqzr");

var $gU1Id = parcelRequire("gU1Id");

var $b7cuD = parcelRequire("b7cuD");

var $93kHd = parcelRequire("93kHd");

var $f8Axo = parcelRequire("f8Axo");

var $cIZNT = parcelRequire("cIZNT");

var $f1WTS = parcelRequire("f1WTS");

var $hpGSb = parcelRequire("hpGSb");
const $add1ab1e0ec10174$export$a9efd057ccbc1d85 = ()=>{
    const intl = (0, $8e22h.default)();
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const resetAll = (0, $4xsw0.useResetAll)();
    const pending = (0, $4xsw0.useSelector)((0, $hSUNh.isCcpDataPending));
    const [vote, setVote] = (0, $1oC0p.useState)(null);
    const fireStep5Viewed = (0, $3h32c.useUbpStep5ScreenViewedEvent)();
    // GWP-12674 — analytics event reused for the new Restart button.
    // The old "Back" gesture becomes "Restart" semantically; the event
    // hook name is intentionally kept for funnel continuity.
    const fireStep5Back = (0, $3h32c.useUbpStep5BackClickedEvent)();
    const fireStep5Share = (0, $3h32c.useUbpStep5ShareClickedEvent)();
    const fireStep5Feedback = (0, $3h32c.useUbpStep5FeedbackClickedEvent)();
    (0, $1oC0p.useEffect)(()=>{
        fireStep5Viewed();
    // Intentionally run once on mount only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cIZNT.Stepper), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpu2gc _1q511epz _85i51jfw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: intl.formatMessage((0, $l4DCt.METER_CONTENT)[meter].summaryStep.title)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb1k92 _vwz419ii _k48p1nn1 _syazrf0c"
                            ]),
                            style: {
                                "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
                            },
                            children: intl.formatMessage((0, $l4DCt.METER_CONTENT)[meter].summaryStep.subtitle)
                        })
                    ]
                })
            }),
            pending ? /*#__PURE__*/ (0, $7VQPk.jsx)($add1ab1e0ec10174$var$SummarySkeleton, {}) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _yv0eydnj _zulpxy5q _4cvrv2br"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _zulppxbi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($add1ab1e0ec10174$var$SummaryResultsCards, {}),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $loMPq.HowYourTeamsMightUse), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($add1ab1e0ec10174$var$SelectedProductCards, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bah1y6m _1q518vuz _85i51ady _msup1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iZlze.FeedbackButtons), {
                            vote: vote,
                            onVote: (v)=>{
                                setVote(v);
                                // Only fire the analytics event when the user actually
                                // casts a vote. `v` can be null when they toggle their
                                // current vote off, in which case there's nothing to
                                // report.
                                if (v !== null) fireStep5Feedback(v);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1h6o _zulputpp"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    fireStep5Back();
                                    resetAll();
                                },
                                className: (0, $2jatx.default)([
                                    "_r06hglyw _bfhk1j28 _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz5hrz _ect4z4z1 _1wyb7vkz _k48p1nn1 _vwz41tcg _80omtlke _4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1 _1ygb1qgu _1ah3yh40 _1basyh40"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: intl.formatMessage((0, $b7cuD.messages).restart)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f8Axo.ShareButton), {
                                label: (0, $l4DCt.METER_CONTENT)[meter].summaryStep.shareCta ? intl.formatMessage((0, $l4DCt.METER_CONTENT)[meter].summaryStep.shareCta) : undefined,
                                onShare: fireStep5Share
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8wHAz.EstimateDisclaimer), {})
                ]
            })
        ]
    });
};
// ─────────────────────────────────────────────────────────────────────────
// Loading placeholder — shown below the header while CCP pricing data is
// pending. Two equal-width columns: the left stacks three 300px blocks, the
// right is a single 600px block. Each block mimics a summary card with a
// header bone and a run of text-line bones. Collapses to a single column
// below the md breakpoint.
// ─────────────────────────────────────────────────────────────────────────
const $add1ab1e0ec10174$var$SkeletonBlock = ({ height: height })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulppxbi _1rjc1ejb _18zr1ejb _2rko1ylz _bfhkg7ng"
        ]),
        style: {
            minHeight: height,
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5EeVR.default), {
                height: "2.5rem",
                maxWidth: "360px"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5EeVR.default), {
                count: 4,
                height: "1.25rem",
                lastLineWidth: "60%"
            })
        ]
    });
const $add1ab1e0ec10174$var$SummarySkeleton = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "aria-busy": "true",
        "aria-live": "polite",
        className: (0, $2jatx.default)([
            "_1e0c11p5 _yv0ehkll _zulpxy5q _4cvrv2br _1rqtwxkt"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($add1ab1e0ec10174$var$SkeletonBlock, {
                        height: "300px"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($add1ab1e0ec10174$var$SkeletonBlock, {
                        height: "300px"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($add1ab1e0ec10174$var$SkeletonBlock, {
                        height: "300px"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($add1ab1e0ec10174$var$SkeletonBlock, {
                height: "600px"
            })
        ]
    });
// ─────────────────────────────────────────────────────────────────────────
// Left-column: ResultsCards — content-driven, per-meter.
//
// Each meter's `summaryStep` object in the content registry may define
// any combination of three optional cards:
//   - orgNeedsCard       (all meters)
//   - whatsCoveredCard   (Rovo + Assets only)
//   - monthlyCostCard    (CSR only)
//
// The card copy comes entirely from the content registry, but the
// numeric values ({low}, {high}, {included}) come from calculator
// context selectors and are interpolated into the copy's placeholder
// tokens at render time. That way content designers can change the
// wording without touching component code, while dynamic numbers stay
// wired to state.
//
// See `meter-content.types.ts › SummaryStepContent` for the shape and
// the mapping decision matrix.
// ─────────────────────────────────────────────────────────────────────────
const $add1ab1e0ec10174$var$SummaryResultsCards = ()=>{
    const intl = (0, $8e22h.default)();
    // Formats an optional content descriptor, preserving `undefined` so the
    // ResultsCard slots stay unrendered when a meter omits the field.
    const format = (descriptor, values)=>descriptor ? intl.formatMessage(descriptor, values) : undefined;
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const included = (0, $4xsw0.useSelector)((0, $hSUNh.selectIncludedAllowance));
    const { whatsCoveredCard: whatsCoveredCard, monthlyCostCard: monthlyCostCard, overageCostCard: overageCostCard } = (0, $l4DCt.METER_CONTENT)[meter].summaryStep;
    // Locale/currency for number + price formatting. Both sourced from
    // the calculator's stored user context (defaults to en-US / USD).
    const locale = (0, $4xsw0.useSelector)((0, $hSUNh.getNumberFormatLocale));
    const currency = (0, $4xsw0.useSelector)((0, $hSUNh.getCurrencyIsoCode));
    // Real total monthly cost for the CSR "Monthly cost estimate" card,
    // per GWP-12277. Undefined while CCP pricing data is still loading —
    // we fall back to the static content-registry headline in that case
    // so the card renders something plausible during hydration.
    const totalCost = (0, $4xsw0.useSelector)((0, $hSUNh.selectTotalMonthlyCost));
    // GWP-12277: overage cost — shown only when the org's estimated usage
    // exceeds its included allowance. `hasOverage` gates the panel;
    // `overageCost` is the low/high USD range of the shortfall.
    const hasOverage = (0, $4xsw0.useSelector)((0, $hSUNh.selectHasOverage));
    const overageCost = (0, $4xsw0.useSelector)((0, $hSUNh.selectTotalOverageCost));
    // Overage units (extra meter units beyond the allowance) — drives the
    // Rovo "What's covered" card's gap copy ("There's a gap of X–Y credits").
    const overageUnits = (0, $4xsw0.useSelector)((0, $hSUNh.selectTotalOverageUnits));
    const includedText = (0, $f1WTS.formatNumber)(included, locale);
    const monthlyCostText = totalCost !== undefined ? (0, $f1WTS.formatPrice)(totalCost, {
        currency: currency,
        locale: locale
    }) : undefined;
    // Overage range headline, e.g. "USD $145–180": currency code prefix,
    // the low bound with its currency symbol, then the high bound as a
    // bare number to avoid repeating the symbol. Collapses to a single
    // value when the bounds are equal (e.g. a custom usage override).
    const overageRangeText = (0, $f1WTS.formatPriceRange)(overageCost.low, overageCost.high, {
        currency: currency,
        locale: locale
    });
    // For the Rovo "What's covered" overage copy: the gap size in meter
    // units ("1,200–1,800") and the estimated extra monthly charge
    // ("USD $145–180"), substituted into the card's `{overage}` / `{cost}`
    // tokens at render time.
    const overageUnitsText = (0, $f1WTS.formatNumberRange)(overageUnits.low, overageUnits.high, locale);
    const overageChargeText = overageRangeText;
    // Per-unit rate line under the range. All display copy (unit noun, tier
    // phrasing) comes from the content registry's `rateNote`; here we only
    // substitute the `{rate}` / `{rate2}` … tokens with the currency-formatted
    // overage rate(s) sourced from the pricing config. Sub-dollar rates show
    // cents so "$0.50"/"$0.01" don't round to "$1"/"$0".
    const overageRateNote = overageCostCard ? intl.formatMessage(overageCostCard.rateNote, (0, $f1WTS.buildOverageRateValues)({
        meter: meter,
        currency: currency,
        locale: locale
    })) : undefined;
    // Content-registry copy for the org-needs card usually contains a
    // [PLACEHOLDER] token for the usage range. We substitute the live
    // value here so what the customer sees is the actual number when
    // content has been finalized, but the placeholder still shows up
    // during content-team review.
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fGqzr.OrgNeedsResultsCard), {
                testId: "summary-org-needs"
            }),
            overageCostCard && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $93kHd.ResultsCard), {
                eyebrow: intl.formatMessage(overageCostCard.eyebrow),
                headline: overageRangeText,
                headlineSubtext: overageRateNote,
                coverageText: intl.formatMessage(hasOverage ? overageCostCard.body : overageCostCard.bodyCovered ?? overageCostCard.body),
                bullets: overageCostCard.listItems?.map((item)=>intl.formatMessage(item)),
                testId: "summary-overage-cost"
            }),
            whatsCoveredCard && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $93kHd.ResultsCard), {
                eyebrow: intl.formatMessage(whatsCoveredCard.eyebrow),
                headline: includedText,
                headlineSubtext: format(whatsCoveredCard.headlineSubtext),
                coverageText: hasOverage ? format(whatsCoveredCard.bodyOverage, {
                    overage: overageUnitsText,
                    cost: overageChargeText
                }) : format(whatsCoveredCard.bodyCovered),
                bullets: (hasOverage ? whatsCoveredCard.listItemsOverage : whatsCoveredCard.listItemsCovered)?.map((item)=>intl.formatMessage(item)),
                testId: "summary-covered"
            }),
            monthlyCostCard && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $93kHd.ResultsCard), {
                eyebrow: intl.formatMessage(monthlyCostCard.eyebrow),
                // `monthlyCostCard.headline` is optional; fall back to
                // empty string if neither a live cost nor a static
                // headline is available (ResultsCard's headline is
                // required).
                headline: monthlyCostText ?? format(monthlyCostCard.headline) ?? '',
                headlineSubtext: format(monthlyCostCard.headlineSubtext),
                footerNote: format(monthlyCostCard.footerNote),
                testId: "summary-monthly-cost"
            })
        ]
    });
};
// ─────────────────────────────────────────────────────────────────────────
// NOTE: The "How your teams might use {meter}" section is now a single
// source of truth — imported from `estimate-step.tsx` (exported
// `HowYourTeamsMightUse`). Both the Estimate and Summary steps render the
// exact same component + styling. The previous Summary-local duplicate
// (different Compiled-CSS styling + non-localized copy) was removed per
// GWP-12689 so the two screens stay visually and copy-wise in sync.
// ─────────────────────────────────────────────────────────────────────────
// Right-column: Selected product / collection cards.
//
// Renders one <ProductCardForKey /> per product the user selected on
// the Allowance step (from GWP-12299 / PR 408810). Cards are
// context-bound — they pull their own title/description/pricing from
// the calculator context.
//
// Multiple cards are separated by a horizontal rule (newer master
// treatment, PR ~410947+). If the user hasn't selected anything, we
// render a soft empty-state so the column still has structure — rare,
// since the Allowance step normally blocks Next until at least one
// product is selected.
// ─────────────────────────────────────────────────────────────────────────
const $add1ab1e0ec10174$var$SelectedProductCards = ()=>{
    const intl = (0, $8e22h.default)();
    const selectedProducts = (0, $4xsw0.useSelector)((0, $hSUNh.selectSelectedProducts));
    if (selectedProducts.length === 0) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1rjc1jfw _18zr1ejb _2rko1ylz _19itnp7h _bfhkg7ng _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpu2gc _1tkenklw _y3gn1h6o"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect41vau _1wyb1tcg _vwz41ul9 _k48p1fw0 _syazrf0c"
                ]),
                style: {
                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
                },
                children: intl.formatMessage((0, $hpGSb.messages).noProductsSelected)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect4z4z1 _1wybdlk8 _vwz4gktf _syaz1qc2"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                    "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                },
                children: intl.formatMessage((0, $hpGSb.messages).noProductsSelectedNote)
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _2rko1ylz _11q7g7ng"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: selectedProducts.map((product, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    index > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)("hr", {
                        role: "presentation",
                        className: (0, $2jatx.default)([
                            "_19itidpf _11q7s3kk _4t3it94y _1bsb1wug _1mouu2gc _195gpxbi"
                        ]),
                        style: {
                            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gU1Id.ProductCardForKey), {
                        productKey: product.productKey
                    })
                ]
            }, product.productKey))
    });
};
// ─────────────────────────────────────────────────────────────────────────
// Styles
// ─────────────────────────────────────────────────────────────────────────
// Header per Figma node 1103:32406 — 80px above the H3 (40px base + 40
// added per design refinement) and 40px below the subtitle.
const $add1ab1e0ec10174$var$pageHeaderStyle = null;
const $add1ab1e0ec10174$var$pageTitleStyle = null;
const $add1ab1e0ec10174$var$pageSubtitleStyle = null;
// Placeholder card (empty-state when no products selected on Allowance).
const $add1ab1e0ec10174$var$placeholderCardStyle = null;
const $add1ab1e0ec10174$var$placeholderLabelStyle = null;
const $add1ab1e0ec10174$var$placeholderNoteStyle = null;
// Skeleton loading layout — two equal-width columns on desktop, single
// column below the md breakpoint. The left cell stacks three blocks; the
// right cell holds one tall block.
const $add1ab1e0ec10174$var$skeletonRowStyle = null;
const $add1ab1e0ec10174$var$skeletonLeftColumnStyle = null;
// A single skeleton block — mirrors a summary card: a header bone on top and
// a run of text-line bones below, laid over a card-like surface. The block's
// height is driven by the caller via an inline `minHeight`.
const $add1ab1e0ec10174$var$skeletonBlockStyle = null;
// Two-column layout — collapses to single column below ~832px via
// `repeat(auto-fit, minmax(400px, 1fr))`. Matches Estimate step.
const $add1ab1e0ec10174$var$twoColumnRowStyle = null;
const $add1ab1e0ec10174$var$leftColumnStyle = null;
const $add1ab1e0ec10174$var$rightColumnStyle = null;
// NOTE: The value-cards panel + value-prop styles that used to live here
// were removed alongside the local `HowYourTeamsMightUse` duplicate — the
// shared component imported from `estimate-step.tsx` owns its own styling
// now (single source of truth, GWP-12689).
// Selected product cards — stacked vertically with a gap.
const $add1ab1e0ec10174$var$selectedProductCardsStyle = null;
const $add1ab1e0ec10174$var$hrProductCard = null;
// Feedback wrapper — 56px above, 44px below (matches Estimate step).
// Horizontally centered so the prompt + thumbs sit in the middle of
// the calculator container, on all viewports. FeedbackButtons handles
// row-vs-column switching + internal centering per breakpoint.
const $add1ab1e0ec10174$var$feedbackWrapperStyle = null;
// Restart button — matches Figma "medium anchor default": blue text,
// no border, no background, Charlie Text Bold 16/24 with underline on
// hover/focus for affordance. Focus-visible ring for keyboard users.
// KEEP IN SYNC with the identical `restartButtonStyle` in
// `estimate-step.tsx` (GWP-12674). Compiled CSS's `@compiled/no-exported-css`
// rule forbids exporting `css()` return values because the transformer
// needs to inline the style at build time in the file where it's used —
// so we duplicate rather than centralize. If you edit either copy, edit
// the other too.
const $add1ab1e0ec10174$var$restartButtonStyle = null;
// Bottom action row — Restart button + Share button, side-by-side,
// vertically centered. Mirrors Estimate step's `bottomActionRowStyle`.
const $add1ab1e0ec10174$var$bottomActionRowStyle = null;

});
parcelRegister("gU1Id", function(module, exports) {
$parcel$export(module.exports, "ProductCardForKey", function () { return $ee40da5e59d90b96$export$d8d157f03705ee27; });

var $7VQPk = parcelRequire("7VQPk");

var $c9qHX = parcelRequire("c9qHX");

var $bTAba = parcelRequire("bTAba");

var $i8HPK = parcelRequire("i8HPK");

var $2edad = parcelRequire("2edad");

var $cZcui = parcelRequire("cZcui");

var $aVofn = parcelRequire("aVofn");
const $ee40da5e59d90b96$var$PRODUCT_CARDS = {
    jira: (0, $bTAba.JiraProductCard),
    confluence: (0, $c9qHX.ConfluenceProductCard),
    jsm: (0, $2edad.JsmProductCard),
    jpd: (0, $i8HPK.JpdProductCard),
    teamworkCollection: (0, $aVofn.TeamworkCollectionProductCard),
    serviceCollection: (0, $cZcui.ServiceCollectionProductCard)
};
const $ee40da5e59d90b96$export$d8d157f03705ee27 = (props)=>{
    const Card = $ee40da5e59d90b96$var$PRODUCT_CARDS[props.productKey];
    return /*#__PURE__*/ (0, $7VQPk.jsx)(Card, {});
};

});
parcelRegister("c9qHX", function(module, exports) {
$parcel$export(module.exports, "ConfluenceProductCard", function () { return $671d7989e866751b$export$848dc4facfa11449; });

var $7VQPk = parcelRequire("7VQPk");

var $cNQe2 = parcelRequire("cNQe2");

var $2aniO = parcelRequire("2aniO");

var $gc3X1 = parcelRequire("gc3X1");

var $bNZzU = parcelRequire("bNZzU");
const $671d7989e866751b$export$848dc4facfa11449 = ()=>{
    const { iconUrl: iconUrl, description: description } = (0, $cNQe2.useAppDescriptions)().confluence;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gc3X1.ProductCard), {
        ...(0, $bNZzU.useProductCardData)('confluence'),
        title: "Confluence",
        iconUrl: iconUrl,
        description: description,
        unitType: "user",
        editions: (0, $2aniO.EDITIONS)
    });
};

});
parcelRegister("2aniO", function(module, exports) {
$parcel$export(module.exports, "EDITIONS", function () { return $76b29a3acf0a0969$export$239d6369a7f971d1; });
const $76b29a3acf0a0969$export$239d6369a7f971d1 = [
    {
        value: 'free',
        label: 'Free'
    },
    {
        value: 'standard',
        label: 'Standard'
    },
    {
        value: 'premium',
        label: 'Premium'
    },
    {
        value: 'enterprise',
        label: 'Enterprise'
    }
];

});

parcelRegister("gc3X1", function(module, exports) {
$parcel$export(module.exports, "ProductCard", function () { return $5008b49213b11a2f$export$e6cbe35324ccf844; });
/* product-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $bSVv5 = parcelRequire("bSVv5");

var $gKWOC = parcelRequire("gKWOC");

var $24e6W = parcelRequire("24e6W");

var $yjOd9 = parcelRequire("yjOd9");
const $5008b49213b11a2f$var$NO_PRICE_PLACEHOLDER = "\u2014";
const $5008b49213b11a2f$export$e6cbe35324ccf844 = (props)=>{
    const { title: title, description: description, iconUrl: iconUrl, list: list, additionalBenefit: additionalBenefit, editions: editions, edition: edition, onEditionChange: onEditionChange, unitType: unitType, unitCount: unitCount, onUnitCountChange: onUnitCountChange, maxUnitCount: maxUnitCount, isFree: isFree, formattedPerUnitPerMonth: formattedPerUnitPerMonth } = props;
    const cardId = (0, $1oC0p.useId)();
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_2rko1ylz _kqswh2mm _1e0c1txw _2lx21bp4 _bfhkg7ng _1yt4v47k _zulppxbi _1a5pxncg",
            `icon_${iconUrl ? 'true' : 'false'}`
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: [
            iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e02pxbi _152t1ejb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: iconUrl,
                    alt: "",
                    className: (0, $2jatx.default)([
                        "_1e0c1ule _1bsbzwfg _4t3izwfg _5ral1f51"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp6mu8"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb1k8s _k48p1fw0 _vwz410nf"
                            ]),
                            children: title
                        })
                    }),
                    description && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyboxwj _ect4z4z1"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_ect4z4z1 _1wyb1j6v _1e0c1txw _2lx21bp4"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                },
                children: isFree ? /*#__PURE__*/ (0, $7VQPk.jsx)("em", {
                    children: intl.formatMessage((0, $yjOd9.messages).freePlan)
                }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_k48p1fw0 _1wyb1k8s"
                            ]),
                            children: formattedPerUnitPerMonth ?? $5008b49213b11a2f$var$NO_PRICE_PLACEHOLDER
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            children: intl.formatMessage((0, $yjOd9.perUnitPerMonthMessages)[unitType])
                        })
                    ]
                })
            }),
            list && list.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyboxwj _ect4z4z1"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "ubp.calculator.productcard.collectionincludes",
                            defaultMessage: "Includes {edition} licensing for the following apps:",
                            values: {
                                edition: edition
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1yt41qut _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        children: list.map((listItem, index)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                className: (0, $2jatx.default)([
                                    "_1wyboxwj _ect4z4z1 _18s8sz9k _kqswh2mm"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: listItem.text
                            }, `product-card-list-${index}`);
                        })
                    })
                ]
            }),
            additionalBenefit && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyboxwj _ect4z4z1"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: intl.formatMessage({
                            id: 'ubp.calculator.additionalbenefit',
                            defaultMessage: 'You also receive:'
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1yt41qut _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            className: (0, $2jatx.default)([
                                "_1wyboxwj _ect4z4z1 _18s8sz9k _kqswh2mm"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                            },
                            children: additionalBenefit
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1fhb _4cvr1h6o _zulpu2gc _1n261g80"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gKWOC.Dropdown), {
                        id: `editionDropdown-${cardId}`,
                        label: intl.formatMessage((0, $yjOd9.messages).editionFieldLabel),
                        labelHidden: true,
                        value: edition,
                        onChange: (value)=>onEditionChange(value),
                        options: editions.map((option)=>({
                                value: option.value,
                                label: option.label
                            }))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _zulpu2gc _i0dl1osq _1wzn1wug"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $24e6W.NumericInput), {
                                id: `users-${cardId}`,
                                placeholder: '0',
                                min: 0,
                                max: maxUnitCount,
                                variant: "inline",
                                width: 120,
                                value: unitCount,
                                onChange: (next)=>onUnitCountChange(next ?? 0)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: `users-${cardId}`,
                                children: intl.formatMessage((0, $yjOd9.unitLabelPluralMessages)[unitType])
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $5008b49213b11a2f$var$cardStyle = null;
const $5008b49213b11a2f$var$iconImageStyle = null;
const $5008b49213b11a2f$var$iconContainer = null;
const $5008b49213b11a2f$var$headerRowStyle = null;
const $5008b49213b11a2f$var$listContainerStyle = null;
const $5008b49213b11a2f$var$listElementStyle = null;
const $5008b49213b11a2f$var$additionalParagraphStyle = null;
const $5008b49213b11a2f$var$descriptionStyle = null;
const $5008b49213b11a2f$var$panelTitleStyle = null;
// Layout: Edition dropdown + unit input + unit label.
// On tablet+ they sit on a single row. On mobile viewports (< 768px)
// they wrap so the unit input + label drop onto their own line below
// the dropdown — otherwise the dropdown, input, and label collectively
// exceed the card width and either clip or force horizontal overflow.
const $5008b49213b11a2f$var$inputRowStyle = null;
// Wrapper for NumericInput + unit label so they stay paired. On mobile
// viewports (< 768px) forces the input+label pair onto its own row below
// the Edition dropdown via `flexBasis: 100%`. On tablet+ shrinks to fit
// content and sits inline with the dropdown.
const $5008b49213b11a2f$var$inputAndLabelWrapperStyle = null;
const $5008b49213b11a2f$var$priceLineStyle = null;
const $5008b49213b11a2f$var$priceValueStyle = null;

});
parcelRegister("yjOd9", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $61b71bfae23e7108$export$defe85febe8b728c; });
$parcel$export(module.exports, "perUnitPerMonthMessages", function () { return $61b71bfae23e7108$export$959b780e66fe011d; });
$parcel$export(module.exports, "unitLabelPluralMessages", function () { return $61b71bfae23e7108$export$d928a718812ba0fd; });

var $fnHPc = parcelRequire("fnHPc");
const $61b71bfae23e7108$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    editionFieldLabel: {
        id: 'ubp.calculator.productcard.editionFieldLabel',
        defaultMessage: 'Edition'
    },
    freePlan: {
        id: 'ubp.calculator.productcard.freePlan',
        defaultMessage: "Free plan \u2014 no charge."
    }
});
const $61b71bfae23e7108$export$959b780e66fe011d = (0, $fnHPc.defineMessages)({
    user: {
        id: 'ubp.calculator.productcard.perUnitPerMonth.user',
        defaultMessage: 'Per user/month'
    },
    creator: {
        id: 'ubp.calculator.productcard.perUnitPerMonth.creator',
        defaultMessage: 'Per creator/month'
    },
    agent: {
        id: 'ubp.calculator.productcard.perUnitPerMonth.agent',
        defaultMessage: 'Per agent/month'
    }
});
const $61b71bfae23e7108$export$d928a718812ba0fd = (0, $fnHPc.defineMessages)({
    user: {
        id: 'ubp.calculator.productcard.unitLabelPlural.user',
        defaultMessage: 'users'
    },
    creator: {
        id: 'ubp.calculator.productcard.unitLabelPlural.creator',
        defaultMessage: 'creators'
    },
    agent: {
        id: 'ubp.calculator.productcard.unitLabelPlural.agent',
        defaultMessage: 'agents'
    }
});

});


parcelRegister("bNZzU", function(module, exports) {
$parcel$export(module.exports, "useProductCardData", function () { return $580ce44f4cb448ea$export$2f04e82108aa846b; });

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $f1WTS = parcelRequire("f1WTS");
const $580ce44f4cb448ea$export$2f04e82108aa846b = (productKey)=>{
    const edition = (0, $4xsw0.useSelector)((ctx)=>$hSUNh.getProductEdition(ctx, productKey));
    const unitCount = (0, $4xsw0.useSelector)((ctx)=>$hSUNh.getProductUnitCount(ctx, productKey));
    const maxUnitCount = (0, $4xsw0.useSelector)((ctx)=>$hSUNh.getProductMaxUnitCount(ctx, productKey));
    const perUnitPerMonth = (0, $4xsw0.useSelector)((ctx)=>$hSUNh.getProductPerUnitPerMonth(ctx, productKey));
    const currency = (0, $4xsw0.useSelector)($hSUNh.getCurrencyIsoCode);
    const locale = (0, $4xsw0.useSelector)($hSUNh.getNumberFormatLocale);
    const setEdition = (0, $4xsw0.useSetProductEdition)();
    const setUnitCount = (0, $4xsw0.useSetProductUnitCount)();
    const formattedPerUnitPerMonth = perUnitPerMonth === undefined ? undefined : (0, $f1WTS.formatPrice)(perUnitPerMonth, {
        currency: currency,
        locale: locale,
        fractionDigits: 2
    });
    return {
        edition: edition,
        onEditionChange: (next)=>setEdition(productKey, next),
        unitCount: unitCount,
        onUnitCountChange: (next)=>setUnitCount(productKey, next),
        maxUnitCount: maxUnitCount,
        isFree: edition === 'free',
        formattedPerUnitPerMonth: formattedPerUnitPerMonth
    };
};

});


parcelRegister("bTAba", function(module, exports) {
$parcel$export(module.exports, "JiraProductCard", function () { return $022017daa0cdee53$export$62940f7767e70680; });

var $7VQPk = parcelRequire("7VQPk");

var $cNQe2 = parcelRequire("cNQe2");

var $2aniO = parcelRequire("2aniO");

var $gc3X1 = parcelRequire("gc3X1");

var $bNZzU = parcelRequire("bNZzU");
const $022017daa0cdee53$export$62940f7767e70680 = ()=>{
    const { iconUrl: iconUrl, description: description } = (0, $cNQe2.useAppDescriptions)().jira;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gc3X1.ProductCard), {
        ...(0, $bNZzU.useProductCardData)('jira'),
        title: "Jira",
        iconUrl: iconUrl,
        description: description,
        unitType: "user",
        editions: (0, $2aniO.EDITIONS)
    });
};

});

parcelRegister("i8HPK", function(module, exports) {
$parcel$export(module.exports, "JpdProductCard", function () { return $729575c200d97d1f$export$cb0313ac5b88cce2; });

var $7VQPk = parcelRequire("7VQPk");

var $cNQe2 = parcelRequire("cNQe2");

var $gc3X1 = parcelRequire("gc3X1");

var $bNZzU = parcelRequire("bNZzU");
const $729575c200d97d1f$export$cb0313ac5b88cce2 = ()=>{
    const { iconUrl: iconUrl, description: description } = (0, $cNQe2.useAppDescriptions)().jpd;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gc3X1.ProductCard), {
        ...(0, $bNZzU.useProductCardData)('jpd'),
        title: "Jira Product Discovery",
        iconUrl: iconUrl,
        description: description,
        unitType: "creator",
        editions: $729575c200d97d1f$export$d5e873d060a53804
    });
};
const $729575c200d97d1f$export$d5e873d060a53804 = [
    {
        value: 'free',
        label: 'Free'
    },
    {
        value: 'standard',
        label: 'Standard'
    },
    {
        value: 'premium',
        label: 'Premium'
    }
];

});

parcelRegister("2edad", function(module, exports) {
$parcel$export(module.exports, "JsmProductCard", function () { return $c602719c2b72fb5b$export$688847d464414d3e; });

var $7VQPk = parcelRequire("7VQPk");

var $cNQe2 = parcelRequire("cNQe2");

var $2aniO = parcelRequire("2aniO");

var $gc3X1 = parcelRequire("gc3X1");

var $bNZzU = parcelRequire("bNZzU");
const $c602719c2b72fb5b$export$688847d464414d3e = ()=>{
    const { iconUrl: iconUrl, description: description } = (0, $cNQe2.useAppDescriptions)().jsm;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gc3X1.ProductCard), {
        ...(0, $bNZzU.useProductCardData)('jsm'),
        title: "Jira Service Management",
        iconUrl: iconUrl,
        description: description,
        unitType: "agent",
        editions: (0, $2aniO.EDITIONS)
    });
};

});

parcelRegister("cZcui", function(module, exports) {
$parcel$export(module.exports, "ServiceCollectionProductCard", function () { return $113d12b665201937$export$22309789aa18389b; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $cNQe2 = parcelRequire("cNQe2");

var $f1WTS = parcelRequire("f1WTS");

var $2aniO = parcelRequire("2aniO");

var $gc3X1 = parcelRequire("gc3X1");

var $bNZzU = parcelRequire("bNZzU");
const $113d12b665201937$export$22309789aa18389b = ()=>{
    const { shortDescription: shortDescription, list: list } = (0, $cNQe2.useCollectionDescriptions)().serviceCollection;
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const allowance = (0, $4xsw0.useSelector)((0, $hSUNh.selectIncludedAllowance));
    const intl = (0, $8e22h.default)();
    // Was hardcoded to `toLocaleString('en-US')`, which grouped digits with
    // US separators regardless of the user's locale.
    const locale = (0, $4xsw0.useSelector)((0, $hSUNh.getNumberFormatLocale));
    const additionalBenefit = intl.formatMessage((0, $f1WTS.collectionAllowanceMessage), {
        allowance: (0, $f1WTS.formatNumber)(allowance, locale),
        meterLabel: intl.formatMessage((0, $f1WTS.METER_LABEL_MESSAGES)[meter])
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gc3X1.ProductCard), {
        ...(0, $bNZzU.useProductCardData)('serviceCollection'),
        title: "Service Collection",
        description: shortDescription,
        list: list,
        unitType: "agent",
        editions: (0, $2aniO.EDITIONS),
        additionalBenefit: additionalBenefit
    });
};

});

parcelRegister("aVofn", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionProductCard", function () { return $4b3957ad634d918c$export$a62b00bc6094c43a; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $cNQe2 = parcelRequire("cNQe2");

var $f1WTS = parcelRequire("f1WTS");

var $2aniO = parcelRequire("2aniO");

var $gc3X1 = parcelRequire("gc3X1");

var $bNZzU = parcelRequire("bNZzU");
const $4b3957ad634d918c$export$a62b00bc6094c43a = ()=>{
    const { shortDescription: shortDescription, list: list } = (0, $cNQe2.useCollectionDescriptions)().teamworkCollection;
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const allowance = (0, $4xsw0.useSelector)((0, $hSUNh.selectIncludedAllowance));
    const intl = (0, $8e22h.default)();
    // Was hardcoded to `toLocaleString('en-US')`, which grouped digits with
    // US separators regardless of the user's locale.
    const locale = (0, $4xsw0.useSelector)((0, $hSUNh.getNumberFormatLocale));
    const additionalBenefit = intl.formatMessage((0, $f1WTS.collectionAllowanceMessage), {
        allowance: (0, $f1WTS.formatNumber)(allowance, locale),
        meterLabel: intl.formatMessage((0, $f1WTS.METER_LABEL_MESSAGES)[meter])
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gc3X1.ProductCard), {
        ...(0, $bNZzU.useProductCardData)('teamworkCollection'),
        title: "Teamwork Collection",
        description: shortDescription,
        list: list,
        unitType: "user",
        editions: (0, $2aniO.EDITIONS),
        additionalBenefit: additionalBenefit
    });
};

});


parcelRegister("hpGSb", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $e84c693c4f4261ec$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $e84c693c4f4261ec$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    noProductsSelected: {
        id: 'ubp.calculator.summary.noProductsSelected',
        defaultMessage: 'No products selected'
    },
    noProductsSelectedNote: {
        id: 'ubp.calculator.summary.noProductsSelectedNote',
        defaultMessage: 'Go back to the Allowance step to pick one.'
    }
});

});


parcelRegister("hz9o6", function(module, exports) {
$parcel$export(module.exports, "UsageStep", function () { return $b7809bb0a68c6442$export$cc212cd84b434059; });
/* usage-step.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $l4DCt = parcelRequire("l4DCt");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $3h32c = parcelRequire("3h32c");

var $ahF4L = parcelRequire("ahF4L");

var $24e6W = parcelRequire("24e6W");

var $ehiBJ = parcelRequire("ehiBJ");

var $cIZNT = parcelRequire("cIZNT");

var $f1WTS = parcelRequire("f1WTS");
// Source identifier attached to every analytics event fired from this step.
// Used by downstream analytics consumers to filter/segment Usage-step events.
const $b7809bb0a68c6442$var$ANALYTICS_SOURCE = 'ubpCalculatorUsageStep';
const $b7809bb0a68c6442$export$cc212cd84b434059 = ()=>{
    const intl = (0, $8e22h.default)();
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const setMeter = (0, $4xsw0.useSetMeter)();
    const orgUserCount = (0, $4xsw0.useSelector)((0, $hSUNh.selectOrgUserCount));
    const setOrgUserCount = (0, $4xsw0.useSetOrgUserCount)();
    const orgUserCountError = (0, $4xsw0.useOrgUserCountErrorMessage)();
    const canAdvance = (0, $4xsw0.useSelector)((0, $hSUNh.selectCanAdvanceUsageStep));
    const [hasAttemptedNext, setHasAttemptedNext] = (0, $1oC0p.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const fireStep1Viewed = (0, $3h32c.useUbpStep1ScreenViewedEvent)();
    (0, $1oC0p.useEffect)(()=>{
        fireStep1Viewed();
    // Intentionally run once on mount only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Fires only when the selection actually CHANGES — re-clicking the
    // same card is a no-op (both setMeter and analytics are skipped).
    const handleMeterSelect = (choice)=>{
        if (choice === meter) return;
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'meterChoiceCard',
            actionSubjectId: choice,
            attributes: {
                previousMeter: meter,
                selectedMeter: choice
            },
            source: $b7809bb0a68c6442$var$ANALYTICS_SOURCE
        }).fire();
        setMeter(choice);
    };
    // Fires a `numberInput committed` analytics event when the user
    // finishes editing the org-size input (onBlur is the semantic commit
    // point for a free-form number field).
    const handleOrgUserCountBlur = (value)=>{
        createAnalyticsEvent({
            eventType: 'track',
            action: 'committed',
            actionSubject: 'numberInput',
            actionSubjectId: 'orgUserCount',
            attributes: {
                value: value ?? null,
                hasError: Boolean(orgUserCountError)
            },
            source: $b7809bb0a68c6442$var$ANALYTICS_SOURCE
        }).fire();
    };
    // Fires immediately before StepNav advances to the next step.
    // Sets hasAttemptedNext so validation errors become visible, and
    // returns false to abort navigation if the step isn't complete.
    const handleBeforeNext = ()=>{
        setHasAttemptedNext(true);
        // Force-sync the context error state so the error message renders
        // even on first visit (when the user hasn't typed anything yet and
        // orgUserCountError is still undefined in context).
        setOrgUserCount(orgUserCount);
        if (!canAdvance) return false;
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'usageStepNext',
            attributes: {
                meter: meter,
                orgUserCount: orgUserCount
            },
            source: $b7809bb0a68c6442$var$ANALYTICS_SOURCE
        }).fire();
    };
    // Consumes the atomic per-meter content registry so content authors
    // can update copy for one meter without touching this file. See
    // `src/content/meter-content.ts` for the registry.
    const USAGE_STRINGS = (0, $1oC0p.useMemo)(()=>Object.keys((0, $l4DCt.METER_CONTENT)).reduce((acc, key)=>{
            acc[key] = {
                label: intl.formatMessage((0, $f1WTS.METER_LABEL_MESSAGES)[key]),
                description: intl.formatMessage((0, $l4DCt.METER_CONTENT)[key].description)
            };
            return acc;
        }, {}), [
        intl
    ]);
    const usageMeters = Object.keys(USAGE_STRINGS);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jsxHL.TypographyStyles), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cIZNT.Stepper), {
                visibleStepCount: 3
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _1rjc1ylp"
                ]),
                children: intl.formatMessage({
                    id: 'ubp.calculator.usage.pageTitle',
                    defaultMessage: 'Let\u2019s figure out your usage needs'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                id: "usage-step-heading",
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _85i51ylp"
                ]),
                children: intl.formatMessage({
                    id: 'ubp.calculator.usage.interestQuestion',
                    defaultMessage: 'What are you interested in?'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "radiogroup",
                "aria-labelledby": "usage-step-heading",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulpxy5q _yv0ewxkt _81641ejb _19d7hkll"
                ]),
                children: usageMeters.map((choice)=>{
                    const { label: label, description: description, list: list, info: info } = USAGE_STRINGS[choice];
                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ahF4L.ChoiceCard), {
                        value: choice,
                        selected: meter === choice,
                        onSelect: ()=>handleMeterSelect(choice),
                        groupName: "group-usage",
                        label: label,
                        description: description,
                        list: list,
                        info: info
                    }, `usage-${choice}`);
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1y6m _zulppxbi _1n261g80 _1q511wqb _na0i1bp4 _dh1a1y6m"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        id: "orgUserCount-label",
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                            htmlFor: "orgUserCount",
                            children: intl.formatMessage({
                                id: 'ubp.calculator.usage.orgSizeQuestion',
                                defaultMessage: 'How many people are in your organization?'
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx2vrvc _4cvr1y6m _1n261g80 _y3gn1e5h _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1bsb1lit _kqswh2mm _1e0c1txw _2lx21bp4 _1s4puuw1"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $24e6W.NumericInput), {
                                        id: "orgUserCount",
                                        value: orgUserCount,
                                        min: 0,
                                        invalid: Boolean(hasAttemptedNext && orgUserCountError),
                                        "aria-required": true,
                                        "aria-labelledby": "orgUserCount-label",
                                        onChange: setOrgUserCount,
                                        onBlur: handleOrgUserCountBlur
                                    }),
                                    hasAttemptedNext && orgUserCountError && /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: (0, $2jatx.default)([
                                            "_4t3igktf _1bsbgktf _kqswstnw _rjxp1crf _152t19bv _lcxvglyw"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM9.29289 11.7071C9.48043 11.8946 9.73478 12 10 12C10.2652 12 10.5196 11.8946 10.7071 11.7071C10.8946 11.5196 11 11.2652 11 11V6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5C9.73478 5 9.48043 5.10536 9.29289 5.29289C9.10536 5.48043 9 5.73478 9 6V11C9 11.2652 9.10536 11.5196 9.29289 11.7071ZM9.29289 14.7071C9.48043 14.8946 9.73478 15 10 15C10.2652 15 10.5196 14.8946 10.7071 14.7071C10.8946 14.5196 11 14.2652 11 14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13C9.73478 13 9.48043 13.1054 9.29289 13.2929C9.10536 13.4804 9 13.7348 9 14C9 14.2652 9.10536 14.5196 9.29289 14.7071Z",
                                            fill: "#AE2A19"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_i0dl1osq _1pfh1y44 _1wyboqnp _syaz1d19 _y3gn1e5h _1tke1wto"
                                        ]),
                                        style: {
                                            "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                                        },
                                        children: hasAttemptedNext && orgUserCountError || ' '
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1wyboxwj _vwz41ylp _syazrf0c"
                                ]),
                                style: {
                                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
                                },
                                children: intl.formatMessage({
                                    id: 'ubp.calculator.usage.required',
                                    defaultMessage: 'Required field'
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ehiBJ.StepNav), {
                showNext: true,
                onBeforeNext: handleBeforeNext
            })
        ]
    });
};
// H1 title styling — extra size overrides for the Figma "D - H1 - Small" (48/56).
// TypographyStyles provides the base font-family/weight; centering + explicit
// 40px vertical padding come from Figma spec (40 above and below the H1).
const $b7809bb0a68c6442$var$pageTitleStyle = null;
// First H3 — sits above the meter/choice cards. 40px padding below per Figma;
// the H1 above supplies its own 40px bottom padding so no top padding is needed.
const $b7809bb0a68c6442$var$sectionTitleStyle = null;
// Second H3 — the "How many people..." question that sits on the SAME row as
// the org-size input. The 60px top padding lives on the parent row wrapper
// (orgSizeQuestionStyle) so the H3 and input stay vertically centered on the
// same baseline; no vertical padding is needed here.
const $b7809bb0a68c6442$var$orgSizeHeadingStyle = null;
const $b7809bb0a68c6442$var$cardGridStyle = null;
const $b7809bb0a68c6442$var$orgSizeQuestionStyle = null;
const $b7809bb0a68c6442$var$inputAndRequiredStyle = null;
const $b7809bb0a68c6442$var$inputWithIconStyle = null;
const $b7809bb0a68c6442$var$errorIcon = null;
const $b7809bb0a68c6442$var$requiredLabelStyle = null;
const $b7809bb0a68c6442$var$errorMessageStyle = null;

});

parcelRegister("bIpm5", function(module, exports) {
$parcel$export(module.exports, "initialValuesFromQuery", function () { return $c5de2b8e02ebe94b$export$38fa8d283c15a6dd; });

var $cGx7y = parcelRequire("cGx7y");

var $iqmYR = parcelRequire("iqmYR");

var $kdccD = parcelRequire("kdccD");

var $73KXs = parcelRequire("73KXs");

var $9lJTH = parcelRequire("9lJTH");
const $c5de2b8e02ebe94b$var$STEP_VALUES = new Set((0, $73KXs.STEP_ORDER));
const $c5de2b8e02ebe94b$var$METER_VALUES = new Set([
    'rovoCredits',
    'automations',
    'csResolutions',
    'assetsObjects'
]);
const $c5de2b8e02ebe94b$var$USAGE_TYPE_VALUES = new Set([
    'exploring',
    'adopting',
    'scaling'
]);
const $c5de2b8e02ebe94b$export$38fa8d283c15a6dd = (search)=>{
    const parsed = (0, $kdccD.fromQueryString)(search);
    const initial = {};
    const step = $c5de2b8e02ebe94b$var$asEnum(parsed.scalars['step'], $c5de2b8e02ebe94b$var$STEP_VALUES);
    if (step) initial.step = step;
    const meter = $c5de2b8e02ebe94b$var$asEnum(parsed.scalars['meter'], $c5de2b8e02ebe94b$var$METER_VALUES);
    if (meter) initial.meter = meter;
    const usageType = $c5de2b8e02ebe94b$var$asEnum(parsed.scalars['usageType'], $c5de2b8e02ebe94b$var$USAGE_TYPE_VALUES);
    if (usageType) initial.usageType = usageType;
    const usage = $c5de2b8e02ebe94b$var$asNumber(parsed.scalars['usage']);
    if (usage !== undefined) initial.usage = usage;
    const orgUserCount = $c5de2b8e02ebe94b$var$asNumber(parsed.scalars['orgUserCount']);
    if (orgUserCount !== undefined) initial.orgUserCount = orgUserCount;
    const products = $c5de2b8e02ebe94b$var$buildProducts(parsed.arrays['products'], parsed.nested);
    if (products) initial.products = products;
    return initial;
};
const $c5de2b8e02ebe94b$var$asEnum = (value, allowed)=>value && allowed.has(value) ? value : undefined;
const $c5de2b8e02ebe94b$var$asNumber = (value)=>{
    if (value === undefined) return undefined;
    const n = Number(value);
    return Number.isFinite(n) ? n : undefined;
};
const $c5de2b8e02ebe94b$var$EDITION_VALUES = new Set((0, $73KXs.EDITION_KEYS));
/**
 * Reconstruct a single product from its config default, overriding any
 * inputs present (and valid) in the query's nested `product.<key>.*` record.
 */ const $c5de2b8e02ebe94b$var$productFromNested = (key, nested)=>{
    const base = (0, $9lJTH.buildDefaultProduct)(key);
    if (!nested) return base;
    const unitCount = $c5de2b8e02ebe94b$var$asNumber(nested['unitCount']);
    const edition = $c5de2b8e02ebe94b$var$asEnum(nested['edition'], $c5de2b8e02ebe94b$var$EDITION_VALUES) ?? base.inputs.edition;
    return {
        productKey: key,
        inputs: {
            edition: edition,
            unitCount: unitCount ?? base.inputs.unitCount,
            billingCycle: (0, $iqmYR.resolveBillingCycle)(key, edition)
        }
    };
};
const $c5de2b8e02ebe94b$var$PRODUCT_KEY_VALUES = new Set((0, $cGx7y.productPricingConfigKeys));
const $c5de2b8e02ebe94b$var$buildProducts = (selected, nested)=>{
    if (!selected) return undefined;
    const result = [];
    const seen = new Set();
    for (const raw of selected){
        const key = $c5de2b8e02ebe94b$var$asEnum(raw, $c5de2b8e02ebe94b$var$PRODUCT_KEY_VALUES);
        if (!key || seen.has(key)) continue;
        seen.add(key);
        result.push($c5de2b8e02ebe94b$var$productFromNested(key, nested[`product.${key}`]));
    }
    return result.length > 0 ? result : undefined;
};

});




//# sourceMappingURL=index.8ce6b060.js.map
